<template>
<div>
  <!--    Breadcrumbs-->
  <breadcrumb style="margin-left: -15px">
    <breadcrumb-item>
      <a href="/purchases/transactions?count=10&page=1">Transactions</a>
    </breadcrumb-item>
    <breadcrumb-item>
      <span>Transaction Details</span>
    </breadcrumb-item>
  </breadcrumb>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>
  <!-- Rendered only once loaded, so the empty shell never flashes while the request is in flight -->
  <template v-if="transactionLoaded">
  <div class="row" >
    <div class="col-lg-12 col-12">
      <card>
<!--        <img slot="image" class="card-img-bottom fixed-size-img" :src="booking.img"  alt="Card image cap"/>-->
        <div class="row justify-content-between">
          <div class="col">
            <h3 slot="header" class="card-title">
              Transaction #{{transaction.order_number}}
              <el-tooltip content="Download invoice"
                          effect="light"
                          :open-delay="300"
                          placement="top">
                <base-button
                  @click.native="downloadTransactionPDF()"
                  class="like btn-link text-white"
                  size="sm"
                  icon
                ><i class="tim-icons icon-cloud-download-93"></i>
                </base-button>
              </el-tooltip>
            </h3>
          </div>

          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            filename="invoice"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="transactionPdf"
            @beforeDownload="beforeDownloadSimple($event)"
          >
            <div slot="pdf-content" style="page-break-before: avoid;">
              <!-- Invoice Content Start -->
              <div style="font-family: 'Poppins', sans-serif; color: #222a42; padding: 30px; margin: 0;">

                <!-- Header Section -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; color: #222a42;">
                  <h1 style="color: #222a42">Invoice</h1>
                  <div style="margin: 0; text-align: right;">
                    <h4 style="color: #222a42; padding-bottom: 0px">{{getInvoiceCompanyName()}}</h4>
                    <p v-if="getInvoiceCompanyNumber()" style="color: #222a42">Company #{{getInvoiceCompanyNumber()}}</p>
                    <p v-if="getInvoiceAddress()" style="color: #222a42">{{getInvoiceAddress()}}</p>
                    <p v-if="getInvoiceAddressLine2()" style="color: #222a42">{{getInvoiceAddressLine2()}}</p>
                    <p v-if="getInvoiceCity()" style="color: #222a42">{{getInvoiceCity()}}
                      <span v-if="getInvoiceState()">{{getInvoiceState()}}</span> {{ getInvoiceZip() }}</p>
                    <p v-if="getInvoiceCountry()" style="color: #222a42">{{ getInvoiceCountry() }}</p>
                    <p style="color: #222a42">{{getInvoicePhone()}}</p>
                  </div>
                </div>

                <!-- Billing Section -->
                <div style="display: flex; margin-bottom: 30px; margin-top: 20px;">
                  <div class="col-5">
                    <p style="color: #222a42; margin: 0;"><strong style="color: #e14eca">Billed To</strong></p>
                    <p style="color: #222a42; margin: 5px 0;">{{ transaction.first_name }} {{ transaction.last_name }}</p>
                    <p v-if="transaction.email" style="color: #222a42; margin: 3px 0;">{{ transaction.email }}</p>
                    <p v-if="transaction.phone" style="color: #222a42; margin: 3px 0;">{{ formatPhone(transaction?.country, transaction.phone) }}</p>
                  </div>
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <p style="color: #222a42; margin: 0;"><strong style="color: #e14eca">Date Issued</strong></p>
                      </div>
                      <div class="col text-right">
                        <p style="color: #222a42; margin: 0;"><strong style="color: #e14eca">Order Number</strong></p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p style="color: #222a42; margin: 5px 0;">{{ getLocalDate(transaction.timestamp) }}</p>
                      </div>
                      <div class="col text-right">
                        <p style="color: #222a42; margin: 5px 0;">#{{transaction.order_number}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Line Items Section -->
                <div style="margin-bottom: 30px;">
                  <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px; ">
                    <thead>
                    <tr style="background: linear-gradient(135deg, #344675 0%, #263148 100%); color: white; border-top-left-radius: 5px; border-top-right-radius: 5px">
                      <th style="padding: 15px 20px; text-align: left; font-weight: 600; font-size: 14px; border-top-left-radius: 8px;">
                        Item
                      </th>
                      <th style="padding: 15px 20px; text-align: center; font-weight: 600; font-size: 14px;">
                        Quantity
                      </th>
                      <th style="padding: 15px 20px; text-align: right; font-weight: 600; font-size: 14px; border-top-right-radius: 8px;">
                        Price
                      </th>
                    </tr>
                    </thead>
                    <tbody style="background-color: #ffffff;">
                    <tr v-for="(b, i) in activeBookings" :key="b.id || `booking-${i}`"
                        style="border-bottom: 1px solid #f0f0f0; page-break-inside: avoid; break-inside: avoid;">
                      <td style="padding: 15px 20px; vertical-align: top;">
                        <div v-if="b.hasOwnProperty('invoice_event_name')" style="font-weight: 500; color: #222a42;">
                          {{ b.invoice_event_name }}
                          <div v-if="b.hasOwnProperty('booking_date')" style="font-size: 12px; color: #666; margin-top: 4px;">
                            {{ getFormattedDate(b.booking_date) }}
                            <template v-if="b.is_all_day === 1">
                              • {{ b.all_day_text }}
                            </template>
                            <template v-else>
                              • {{ getTime(b.start_time) }}
                            </template>
                          </div>
                        </div>
                        <div v-else-if="!b.hasOwnProperty('design_url')" style="font-weight: 500; color: #222a42;">
                          {{ b.name }}
                        </div>
                        <div v-else>
                          <div style="color: #222a42; margin: 0; font-weight: 500;">
                            Gift card <span v-if="b.gift_card_type">({{b.gift_card_type}})</span>
                          </div>
                          <div style="color: #666; font-size: 12px; margin-top: 2px;">#{{b.code}}</div>
                        </div>
                      </td>
                      <td style="padding: 15px 20px; text-align: center; color: #222a42;">
                        <template v-if="b.hasOwnProperty('booking_date') && !b.is_reservation_upgraded">
                          <div v-if="payment_settings.invoice_show_ticket_categories && getTicketsArray(b.tickets).some(t => t.number_of_players > 0)" style="display: inline-block; text-align: left;">
                            <div v-for="(ticket, idx) in getTicketsArray(b.tickets).filter(t => t.number_of_players > 0)" :key="'pdf-category-' + idx" style="font-size: 12px;">
                              <span v-if="ticket.category">{{ticket.category}}: {{ticket.number_of_players}}</span>
                              <span v-else>{{ticket.number_of_players}}</span>
                            </div>
                          </div>
                          <span v-else>{{ b.group_size }}</span>
                        </template>
                        <div v-if="b.hasOwnProperty('booking_date') && b.is_reservation_upgraded">
                          <div style="font-size: 12px; color: #666; margin-bottom: 4px;">Private </div>
                          <div v-if="b.tickets && b.tickets.length > 0">
                            <div v-for="(ticket, idx) in getTicketsArray(b.tickets)" :key="'pdf-ticket-' + idx" style="font-size: 11px; color: #666;">
                              <span v-if="ticket.category">{{ticket.number_of_players}}x {{ticket.category}}</span>
                              <span v-else>{{ticket.number_of_players}}x</span>
                            </div>
                          </div>
                          <div style="font-size: 12px; font-weight: 500; margin-top: 4px;">Total: {{ b.group_size }}</div>
                        </div>
                        <span v-if="b.hasOwnProperty('category_name')">{{ b.quantity }}</span>
                        <span v-if="b.hasOwnProperty('design_url')">1</span>
                      </td>
                      <td style="padding: 15px 20px; text-align: right; font-weight: 500; color: #222a42;">
                        <div v-if="!b.hasOwnProperty('design_url') && b.is_reservation_upgraded">
                          <div>{{ getAmount(b.price) }}</div>
                          <div style="font-size: 11px; color: #666; margin-top: 2px;">{{ b.reservation_upgrade_pricing_mode === 'tickets_plus_fee' ? 'Tickets + private booking fee' : 'Upgrade override price' }}</div>
                        </div>
                        <span v-else-if="b.hasOwnProperty('category_name')">{{ getAmount(b.amount) }}</span>
                        <span v-else-if="!b.hasOwnProperty('design_url')">{{ getAmount(b.price) }}</span>
                        <span v-else>{{ getAmount(b.total) }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Totals Section -->
                <div style="display: flex; justify-content: flex-end; margin-bottom: 20px; padding-top: 10px; page-break-inside: avoid; break-inside: avoid;">
                  <div style="width: 400px; background-color: #f4f5f7; padding: 25px; border-radius: 8px; border: 1px solid #344675; border-opacity: 0.2;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                      <div style="color: #222a42; font-weight: 500;">Subtotal</div>
                      <div style="color: #222a42; font-weight: 500;">{{getSubtotalAmount(transaction.price)}}</div>
                    </div>

                    <div v-for="(t, i) in taxes_fees_invoice" :key="'TAXNAMEPDF' + i"
                         style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                      <div v-if="!t.tax_id || t.pricing_type === 0" style="color: #344675; font-size: 14px;">
                        {{ t.name }}
                        <span v-if="t.tax_number" style="font-size: 11px; color: #344675; opacity: 0.7;">
                (#{{ t.tax_number }})
              </span>
                      </div>
                      <div v-if="t.pricing_type === 1" style="color: #344675; font-size: 14px;">
                        {{ t.name }} (included)
                        <span v-if="t.tax_number" style="font-size: 11px; color: #344675; opacity: 0.7;">
                (#{{ t.tax_number }})
              </span>
                      </div>
                      <div style="color: #344675; font-size: 14px;">{{getAmount(t.amount)}}</div>
                    </div>

                    <div v-if="Number(transaction.waive_taxes) === 1 && Number(transaction.inclusive_tax_waived) > 0"
                         style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                      <div style="color: #344675; font-size: 14px;">Included tax (waived)</div>
                      <div style="color: #344675; font-size: 14px;">-{{getAmount(transaction.inclusive_tax_waived)}}</div>
                    </div>

                    <div v-for="(p, i) in promos_invoice" :key="'PROMONAMEPDF' + i"
                         style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                      <div style="color: #fd5d93; font-size: 14px;">{{ p.name }}</div>
                      <div style="color: #fd5d93; font-size: 14px;">-{{getAmount(p.amount)}}</div>
                    </div>

                    <div style="border-top: 2px solid #222a42; margin: 15px 0; padding-top: 15px;">
                      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                        <div style="color: #222a42; font-size: 18px; font-weight: 700;">Total</div>
                        <div style="color: #222a42; font-size: 20px; font-weight: 700;">{{getAmount(transaction.total)}}</div>
                      </div>

                      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                        <div style="color: #222a42; font-weight: 500;">Amount paid</div>
                        <div style="color: #222a42; font-weight: 500;">{{getAmount(transaction.paid)}}</div>
                      </div>

                      <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div style="color: #222a42; font-weight: 500;">Amount due</div>
                        <div style="color: #fd5d93; font-weight: 600;">{{getAmount(transaction.due)}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Details Section - Move entire section to new page if it doesn't fit -->
                <div v-if="payment_settings.invoice_list_payments && payments.filter(p => p.status === 1).length > 0"
                     style="page-break-inside: avoid; break-inside: avoid; padding-top: 40px;">
                  <div style="background-color: #f4f5f7; padding: 20px; border-radius: 8px; border-left: 4px solid #e14eca;">
                    <h3 style="color: #222a42; margin: 0 0 20px 0; font-size: 18px;">Payment Details</h3>

                    <!-- Individual payment items can split within the section if needed -->
                    <div v-for="(payment, i) in payments" :key="'payment-' + i"
                         v-if="payment.status === 1"
                         style="margin-bottom: 15px; padding: 15px; background-color: white; border-radius: 6px; border: 1px solid #344675; border-opacity: 0.2;">
                      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                        <div style="flex: 1;">
                          <div style="color: #222a42; font-weight: 600; margin-bottom: 5px;">
                  <span v-if="payment.type == 'card'">Card Payment
                    <span v-if="payment.card_type"> • {{payment.card_type}}</span>
                  </span>
                            <span v-else-if="payment.type == 'gift_card'">Gift Card
                    <span v-if="payment.gift_card_type"> • {{payment.gift_card_type}}</span>
                  </span>
                            <span v-else-if="payment.type == 'bank_transfer'">Bank Transfer</span>
                            <span v-else-if="payment.type == 'cash'">Cash Payment</span>
                            <span v-else-if="payment.type == 'customer_credit'">Customer Credit</span>
                            <span v-else-if="payment.type == 'pos'">POS Payment</span>
                            <span v-else>{{payment.type}}</span>
                          </div>

                          <div v-if="payment.cardholder_first_name || payment.cardholder_last_name"
                               style="color: #344675; font-size: 13px; margin-bottom: 3px;">
                            Cardholder: {{payment.cardholder_first_name}} {{payment.cardholder_last_name}}
                          </div>

                          <div v-if="payment.last_four" style="color: #344675; font-size: 13px; margin-bottom: 3px;">
                            Card: ****-****-****-{{payment.last_four}}
                            <span v-if="payment.expiration_month && payment.expiration_year">
                    • Exp: {{payment.expiration_month}}/{{payment.expiration_year}}
                  </span>
                          </div>

                          <div v-if="payment.gateway_transaction_id && payment.type === 'gift_card'"
                               style="color: #344675; font-size: 13px; margin-bottom: 3px;">
                            Gift Card: {{getGiftCardCode(payment.gateway_transaction_id)}}
                          </div>

                          <div style="color: #344675; font-size: 13px;">
                            {{getLocalDate(payment.timestamp)}} at {{getLocalTime(payment.timestamp)}}
                          </div>
                        </div>

                        <div style="text-align: right; color: #222a42; font-weight: 600; font-size: 16px;">
                          {{getAmount(payment.amount - payment.refunded)}}
                          <div v-if="payment.refunded > 0" style="color: #fd5d93; font-size: 12px; font-weight: normal; margin-top: 2px;">
                            Refunded: {{getAmount(payment.refunded)}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Custom Fields Section - Move entire section to new page if it doesn't fit -->
                <div v-if="payment_settings.invoice_show_custom_fields && invoiceCustomFields.length > 0"
                     style="page-break-inside: avoid; break-inside: avoid; padding-top: 40px;">
                  <div style="background-color: #f4f5f7; padding: 20px; border-radius: 8px; border-left: 4px solid #e14eca;">
                    <h3 style="color: #222a42; margin: 0 0 15px 0; font-size: 18px;">Additional Information</h3>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px;">
                      <div v-for="(field, i) in invoiceCustomFields" :key="'field-' + i"
                           style="padding: 12px; background-color: white; border-radius: 6px; border: 1px solid #344675; border-opacity: 0.2;">
                        <div style="color: #222a42; font-weight: 600; font-size: 13px; margin-bottom: 5px;">
                          {{field.label}}
                        </div>
                        <div style="color: #222a42; font-size: 14px;">
                          <span v-if="field.type === 1">{{ (field.response === '1' || field.response === 1) ? 'Yes' : 'No' }}</span>
                          <span v-else>{{formatFieldResponse(field) || 'Not provided'}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- Invoice Content End -->
            </div>
          </vue-html2pdf>

          <div class="col mb-2 text-right">
            <base-dropdown v-if="transaction.status === 1"
                           title-classes="dropdown-toggle btn btn-success btn-simple btn-sm"
                           title="Status: Active"
                           menu-on-right
            >
              <a class="text-default dropdown-item" @click="cancelTransactionPrompt()" href="#">Cancel transaction</a>
            </base-dropdown>

            <base-dropdown v-if="transaction.status === 0"
                           title-classes="dropdown-toggle btn btn-danger btn-simple btn-sm"
                           title="Status: Cancelled"
                           menu-on-right
            >
              <a class="text-default dropdown-item" @click="reactivateTransactionPrompt()" href="#">Reactivate transaction</a>
            </base-dropdown>

<!--            <base-button disabled v-if="transaction.status === 0"  v-on:click="cancelTransactionPrompt()"  simple type="danger">-->
<!--              Status: Cancelled</base-button>-->
            <base-button disabled v-if="transaction.status === 2" simple type="danger">
              Status: Pending</base-button>
            <base-button disabled v-if="transaction.status === 3" simple type="danger">
              Status: Failed</base-button>
          </div>
        </div>

        <div class="row" v-if="isReadOnly">
          <div class="col">
            <info-hint variant="danger" icon="icon-alert-circle-exc">
              This order was not completed and is read only. To charge the customer, create a new booking.
            </info-hint>
          </div>
        </div>
        <b-row>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Subtotal</p>
                    <h2 class="card-title">{{ getSubtotalAmount(transaction.price) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Total</p>
                    <h2 class="card-title">{{ getAmount(transaction.total) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Paid</p>
                    <h2 class="card-title" v-if="transaction.status === 2">{{ getAmount(0) }}</h2>
                    <h2 class="card-title" v-else>{{ getAmount(transaction.paid) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Due</p>
                    <h2 class="card-title" v-if="transaction.status === 2">{{ getAmount(transaction.total) }}</h2>
                    <h2 class="card-title" v-else>{{ getAmount(transaction.due) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>

          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Taxes</p>
                    <h2 class="card-title">{{ getAmount(transaction.tax) }}</h2>
                    <sub class="text-uppercase text-white" v-if="getInclusiveTaxes()">included in subtotal</sub>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Fees</p>
                    <h2 class="card-title">{{ getAmount(transaction.fee) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Discount</p>
                    <h2 class="card-title">{{ getAmount(transaction.discount) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>

          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Tips</p>
                    <h2 class="card-title">{{ getAmount(transaction.tips) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <hr style="border: 1px solid #e14eca">
            <div class="row card-stats">
              <div class="col">
                <div class="numbers">
                  <slot>
                    <p class="card-category">Refunded</p>
                    <h2 class="card-title">{{ getAmount(transaction.refunded) }}</h2>
                  </slot>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="row mt-4">
          <div class="col">
            <h4 class="card-title">Purchased by {{transaction.first_name}} {{transaction.last_name}}
              on {{getLocalDate(transaction.timestamp)}}, {{getLocalTime(transaction.timestamp)}}
            </h4>
            <p v-if="transaction.email" style="font-size: small"><i class="tim-icons icon-email-85"></i> {{transaction.email}}</p>
            <p v-if="transaction.phone" style="font-size: small"><i class="tim-icons el-icon-mobile-phone"></i>{{ formatPhone(transaction?.country, transaction.phone) }}</p>
            <p v-if="enable_utm_source_tracking || transaction.affiliate_id || canAttachAffiliate" style="font-size: small" class="mt-2">
              <utm-attribution
                v-if="enable_utm_source_tracking"
                mode="chip"
                icon="icon-world"
                :source="transaction.utm_source"
                :medium="transaction.utm_medium"
                :campaign="transaction.utm_campaign"
                :referrer="transaction.utm_referrer"
                empty-text="-" />
              <span v-if="transaction.affiliate_id" class="badge badge-default" :class="{ 'ml-2': enable_utm_source_tracking }">
                <i class="tim-icons icon-spaceship"></i> {{ transaction.affiliate_name }}
              </span>
              <a
                v-else-if="canAttachAffiliate && !affiliateAttach.open"
                href="#"
                class="text-primary"
                :class="{ 'ml-2': enable_utm_source_tracking }"
                @click.prevent="openAffiliateAttach"
              ><i class="tim-icons icon-spaceship" style="font-size: 10px;"></i> Attach to affiliate</a>
            </p>
            <div v-if="canAttachAffiliate && affiliateAttach.open && !transaction.affiliate_id" class="mt-2 col-md-6 px-0">
              <base-input label="Affiliate" :error="affiliateAttach.error">
                <el-select
                  class="select-primary"
                  v-model="affiliateAttach.affiliateId"
                  placeholder="Choose an affiliate"
                  :loading="affiliateAttach.loading"
                  filterable
                >
                  <el-option
                    class="select-primary"
                    v-for="a in affiliateAttach.options"
                    :key="a.id"
                    :value="a.id"
                    :label="a.tier_name ? `${a.name} (${a.tier_name})` : a.name"
                  />
                </el-select>
              </base-input>
              <base-button
                variant="outlined"
                tone="primary"
                size="sm"
                :disabled="!affiliateAttach.affiliateId || affiliateAttach.saving"
                :loading="affiliateAttach.saving"
                @click="attachAffiliate"
              ><i class="tim-icons icon-check-2"></i>Attach</base-button>
              <a href="#" class="text-muted ml-3" style="font-size: 12px;" @click.prevent="affiliateAttach.open = false">Cancel</a>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <card style="min-height: 150px;">
        <div class="row mb-3">
          <div class="col">
            <tab-rail
              :tabs="categories"
              :value="activeTabIndex"
              @input="switchTab"
            />
          </div>
        </div>

        <div v-if="activeTabIndex === 0" key="tab-0">
          <modal :show.sync="modals.policy"
                 body-classes="p-0"
                 modal-classes="modal-dialog-centered">
            <card type="secondary"
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-4 py-lg-4s"
                  class="border-0 mb-0">
              <p class="text-white" v-html="selectedPolicy"></p>
              <div class="row mt-3 justify-content-center">
                <div class="col text-center">
                  <base-button v-on:click="modals.policy = false" type="primary">Close</base-button>
                </div>
              </div>
            </card>
          </modal>
          <div class="row" v-if="transaction.status === 1">
            <div class="col">
              <el-dropdown placement="bottom-start">
                <base-button size="sm"
                             simple
                             type="success" class="mr-2"

                > Add new <i class="tim-icons icon-minimal-down ml-1"></i>
                </base-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <a v-if="hasPermissions('bookings_create')" class="dropdown-item mb-2 mt-2" href="#" @click="addBooking($event)">
                      <i class="tim-icons icon-calendar-60 mr-2 text-info"></i> Booking
                    </a>
                    <a v-if="hasPermissions('gift_cards_update')" class="dropdown-item mb-2" href="#" @click="addGiftCard($event)">
                      <i class="tim-icons icon-gift-2 mr-2 text-warning"></i> Gift card
                    </a>
                    <a class="dropdown-item mb-2" href="#" @click="addPurchase($event)">
                      <i class="tim-icons icon-shape-star mr-2 text-default"></i> Item
                    </a>
                    <a class="dropdown-item mb-2" href="#" @click="addCustomPurchase($event)">
                      <i class="tim-icons icon-trophy mr-2 text-danger"></i> Custom purchase
                    </a>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
<!--          Desktop-->
          <div class="d-sm-block d-none">
            <div v-if="bookings.length <= 0" class="mt-3" >
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No bookings are associated with this transaction.</h4>
              </div>
            </div>
            <b-table v-if="bookings.length > 0" :items="bookings" :fields="bookingFields">
              <template v-slot:cell(purchase_details)="row">
                <div v-if="editing_bookings[row.index] && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <div class="row">
                    <div class="col">
                      <base-input label="Game">
                        <el-select
                          label="Select game"
                          v-model="row.item.selectedGame"
                          class="select-primary"
                          v-on:change="getInitialSubtotal(row.item)"
                          placeholder="Game">
                          <el-option
                            v-for="game in games"
                            class="select-primary"
                            :label="game.name"
                            :value="game.name"
                            :key="game.id"
                          ></el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input label="Date" :error="errs.booking_date">
                        <el-date-picker :editable="false"
                          type="date"
                          placeholder="Select date"
                          value-format="yyyy-MM-dd"
                          name="date"
                          v-model="row.item.booking_date"
                          :format="date_format_cal"
                          v-on:change="getAvailableBookings(row.item, 'date')"
                                        :picker-options="{ firstDayOfWeek: first_day_of_week }"
                        >
                        </el-date-picker>
                      </base-input>
                    </div>
                    <div class="col">
                      <base-input label="Time" :error="errs.start_time">
                        <el-select v-on:change="onRescheduleSlotChange(row.item.start_time, row.item)"
                          label="Select time"
                          v-model="row.item.start_time"
                          class="select-primary"
                          value-key="id"
                          placeholder="Time">
                          <el-option
                            v-for="(booking, index) in available_bookings"
                            class="select-primary"
                            :label="getTime(booking.start_time) + ' - ' + getTime(booking.end_time)"
                            :value="{id: booking.id,
                         booking_date: booking.booking_date,
                         end_date: booking.end_date,
                         pricing_categories: booking.pricing_categories,
                          pricing: booking.pricing,
                          custom_pricing: booking.custom_pricing,
                          game_id: booking.game_id,
                          start_time: booking.start_time,
                          is_custom_pricing_enabled: booking.is_custom_pricing_enabled,
                          slot_cumulative_category_pricing: booking.slot_cumulative_category_pricing,
                          slot_pricing_type_id: booking.slot_pricing_type_id,
                          pricing_type_id: booking.pricing_type_id,
                          cumulative_category_pricing: booking.cumulative_category_pricing,
                          all_pricing: booking.all_pricing,
                          slot_durations: booking.slot_durations,
                          game_durations: booking.game_durations,
                          enable_multiple_durations: booking.enable_multiple_durations,
                          game_enable_multiple_durations: booking.game_enable_multiple_durations,
                          end_time: booking.end_time}"
                            :key="'A' + index"
                          >
                            <span>{{ getTime(booking.start_time) }} - {{ getTime(booking.end_time) }}</span>
                            <badge v-if="booking.status === 'blocked' && !booking.status_type_id" type="danger" class="badge-compact ml-2">Blocked</badge>
                            <badge v-if="booking.status === 'call_to_book'" type="warning" class="badge-compact ml-2">Call to book</badge>
                            <span v-if="booking.status === 'requestable'" class="badge badge-compact ml-2" :style="{ backgroundColor: '#FFD600', color: '#1E1E2F' }">Requestable</span>
                            <span v-if="booking.status === 'requested'" class="badge badge-compact ml-2 requested-status-chip">Requested</span>
                            <span v-if="booking.status_type_id" class="badge badge-compact ml-2" :style="{ backgroundColor: booking.status_color, color: booking.status_text_color }">{{ booking.status_display_name }}</span>
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div v-if="row.item.start_time && row.item.start_time.id && rescheduleDurationOptions.length > 1" class="row mb-3">
                    <div class="col">
                      <label class="d-block mb-1">Duration</label>
                      <segmented-toggle variant="pills" size="sm" :value="reschedule_duration_id" :options="rescheduleDurationOptions" @input="v => onRescheduleDurationChange(row.item, v)" />
                    </div>
                  </div>
                </div>
<!--                <div v-if="!editing_bookings[row.index] && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">-->
<!--                  <p style="font-size: large" class="text-primary">{{ row.item.name }}-->
<!--                    <el-tooltip content="View game history"-->
<!--                                effect="light"-->
<!--                                :open-delay="300"-->
<!--                                placement="top">-->
<!--                      <base-button v-if="row.item.status === 'completed'"-->
<!--                                   v-on:click="goToGame(row.item)" icon class="btn btn-link" simple size="sm" type="primary">-->
<!--                        <i style="font-size: larger" class="tim-icons el-icon-top-right"></i>-->
<!--                      </base-button>-->
<!--                    </el-tooltip>-->
<!--                  </p>-->
<!--                  <p>-->
<!--                    <i class="tim-icons icon-calendar-60"></i> {{getFormattedDate(row.item.booking_date)}}-->
<!--                    &nbsp; <i class="tim-icons icon-time-alarm"></i> {{getTime(row.item.start_time)}} -  {{getTime(row.item.end_time)}}-->
<!--                  </p>-->
<!--                  <p style="font-size: x-small">Booking id: #{{row.item.master_slot_id ? row.item.master_slot_id : row.item.id }}-->
<!--                  </p>-->
<!--                </div>-->
                <div v-if="!editing_bookings[row.index] && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <p style="font-size: large" class="text-primary">
                    {{ row.item.name }}
                    <badge v-if="row.item.is_reservation_upgraded" type="info" class="ml-2">
                      <i class="tim-icons icon-minimal-up"></i> Private
                    </badge>
                    <el-tooltip content="View game history"
                                effect="light"
                                :open-delay="300"
                                placement="top">
                      <base-button v-if="row.item.status === 'completed'"
                                   v-on:click="goToGame(row.item)" icon class="btn btn-link" simple size="sm" type="primary">
                        <i style="font-size: larger" class="tim-icons el-icon-top-right"></i>
                      </base-button>
                    </el-tooltip>
                  </p>
                  <p>
                    <i class="tim-icons icon-calendar-60"></i> {{getFormattedDate(row.item.booking_date)}}
                    &nbsp;
                    <template v-if="row.item.is_all_day === 1">
                      <i class="tim-icons icon-time-alarm"></i> {{row.item.all_day_text}}
                    </template>
                    <template v-else>
                      <i class="tim-icons icon-time-alarm"></i> {{getTime(row.item.start_time)}} - {{getTime(row.item.end_time)}}
                    </template>
                  </p>
                  <p style="font-size: x-small">Booking id:
                    <el-tooltip v-if="hasPermissions('bookings_view') && bookingCalendarLink(row.item)"
                                content="View on calendar"
                                effect="light"
                                :open-delay="300"
                                placement="top">
                      <a :href="bookingCalendarLink(row.item)" target="_blank" rel="noopener">#{{row.item.master_slot_id ? row.item.master_slot_id : row.item.id }} <i class="tim-icons el-icon-top-right"></i></a>
                    </el-tooltip>
                    <template v-else>#{{row.item.master_slot_id ? row.item.master_slot_id : row.item.id }}</template>
                  </p>
                </div>
                <div v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <p style="font-size: large" class="text-primary">{{ row.item.name }}</p>
                  <p style="font-size: x-small" v-if="row.item.category_name">{{row.item.category_name}}
                  </p>
                  <p style="font-size: x-small" v-if="row.item.is_custom">{{row.item.description}}
                  </p>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')">
                  <p style="font-size: large" class="text-primary">Gift card <span v-if="row.item.gift_card_type">({{row.item.gift_card_type}})</span>
                    <badge v-if="row.item.is_refund_gift_card" type="warning" class="ml-1" style="font-size: 10px;">refund</badge>
                  </p>
                  <p style="font-size: x-small">{{getGiftCardCode(row.item.code)}}</p>
                  <p v-if="row.item.delivery_date" style="font-size: x-small">Delivery date: {{getDayOfWeek(row.item.delivery_date)}}  {{getFormattedDate(row.item.delivery_date)}}</p>
                  <p v-if="!row.item.delivery_date" style="font-size: x-small">Delivery date:  {{getLocalDate(transaction.timestamp)}}</p>
                  <p v-if="row.item.game_name" style="font-size: x-small">Purchased for {{row.item.game_name}}, {{row.item.number_of_participants}} participants</p>
                  <p v-if="row.item.recipients" style="font-size: x-small">Recipient:  {{getRecipient(row.item?.recipients)}}</p>
                  <p v-if="row.item.terms_agreed_at" style="font-size: x-small" class="text-white">
                    <i class="tim-icons icon-check-2 mr-1 text-success"></i>Terms accepted: {{getLocalDate(row.item.terms_agreed_at)}}, {{getLocalTime(row.item.terms_agreed_at)}}<span v-if="row.item.terms_agreed_ip"> &middot; IP {{row.item.terms_agreed_ip}}</span>
                    <base-button v-if="row.item.terms_text_snapshot" style="color: #ba54f5; font-weight:300; font-size: x-small; padding: 0" size="sm" link class="btn btn-link ml-1" v-on:click="openPolicy({policy: row.item.terms_text_snapshot})">View terms</base-button>
                  </p>
                  <img v-if="row.item.design_url" style="object-fit: cover; height: 75px" :src="row.item.design_url"/>
                </div>

                <div class="row" v-if="enable_utm_source_tracking">
                  <div class="col">
                    <p class="text-white">
                      <utm-attribution
                        icon="icon-world"
                        :source="row.item.utm_source"
                        :medium="row.item.utm_medium"
                        :campaign="row.item.utm_campaign"
                        :referrer="row.item.utm_referrer"
                        empty-text="-" />
                    </p>
                  </div>
                </div>
              </template>
              <template v-slot:cell(status)="row">
                <badge v-if="row.item.status == 'available'  && row.item.hasOwnProperty('booking_date')" type="success">available</badge>
                <badge v-if="row.item.status == 'completed'  && row.item.hasOwnProperty('booking_date')" type="success">
                  completed
                </badge>
                <badge v-if="row.item.status == 'booked'  && row.item.hasOwnProperty('booking_date') && !hasPassed(row.item.booking_date)" type="primary">
                  upcoming
                </badge>
                <badge v-if="row.item.status == 'booked'  && row.item.hasOwnProperty('booking_date') && hasPassed(row.item.booking_date)" type="success">
                  completed
                </badge>
                <badge v-if="row.item.status === 'cancelled'  && row.item.hasOwnProperty('booking_date')" type="danger">cancelled</badge>
                <span v-if="row.item.status === 'requested' && row.item.hasOwnProperty('booking_date')" class="badge requested-status-chip">requested</span>
                <p v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">-</p>
                <badge v-if="!row.item.hasOwnProperty('booking_date')
                  && row.item.hasOwnProperty('design_url') && row.item.is_active" type="success">active
                </badge>
                <badge v-if="!row.item.hasOwnProperty('booking_date')
                  && row.item.hasOwnProperty('design_url') && !row.item.is_active" type="danger">deactivated
                </badge>
              </template>
              <template #head(quantity)="row">
                <span></span>
              </template>
              <template v-slot:cell(quantity)="row">

                <div v-if="!editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')">
                  <label>Reservation type</label>
                  <p>Private (upgraded from public)</p>
                  <div v-if="row.item.tickets && row.item.tickets.length > 0" class="mt-2">
                    <label>Participants</label>
                    <div class="small" v-for="(ticket, idx) in getTicketsArray(row.item.tickets)" :key="'qty-ticket-' + idx">
                      <span v-if="ticket.category">{{ticket.number_of_players}}x {{ticket.category}}</span>
                      <span v-else>{{ticket.number_of_players}}x participants</span>
                    </div>
                    <div class="small mt-1"><strong>Total: {{row.item.group_size}} participants</strong></div>
                  </div>
                </div>

                <!-- Editing section for upgraded bookings -->
                <div v-if="editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')">
                  <label>Reservation type</label>
                  <p>Private (upgraded from public)</p>
                  <div class="row mt-2" :key="pr_key">
                    <div class="col-lg-8">
                      <label>Participants</label>
                      <div v-for="(c, i) in row.item.pricing_categories" :key="'CXU' + i">
                        <label class="text-primary text-uppercase">{{c.category}}</label>
                        <base-input>
                          <el-input-number @change="getSubtotal(row.item)" v-model="c.number_of_players" :min="0" />
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input :error="errs.number_of_players"><p></p></base-input>
                    </div>
                  </div>
                </div>

                <div v-if="editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')" >
                  <div class="row" :key="pr_key">
                    <div class="col-lg-8">
                      <div  v-for="(c, i) in row.item.pricing_categories" :key="'CX' + i">
                        <label class="text-primary text-uppercase">{{c.category}}</label>
                        <base-input>
                          <el-input-number @change="getSubtotal(row.item)" v-model="c.number_of_players" :min="0" />
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input :error="errs.number_of_players"><p></p></base-input>
                    </div>
                  </div>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')">
                  <label>Participants</label>
                  <p>x{{row.item.group_size}}</p>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')">
                  <label>Quantity</label>
                  <p>x{{row.item.quantity}}</p>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date')  && row.item.hasOwnProperty('design_url')">
                  <label>Quantity</label>
                  <p>x1</p>
                </div>

                <div v-if="editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')">
                  <div class="col-lg-8">
                    <base-input :error="errs.purchase.quantity" label="Quantity">
                      <el-input-number v-model="row.item.quantity" :min="1" />
                    </base-input>
                  </div>
                </div>
              </template>
              <template v-slot:cell(price)="row" >
                <div v-if="editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.reservation_upgrade_pricing_mode !== 'tickets_plus_fee' && row.item.hasOwnProperty('booking_date')">
                  <div class="row">
                    <div class="col">
                      <label>Upgrade override price ({{currency_symbol}})</label>
                      <base-input :error="errs.price">
                        <el-input-number
                          v-model="row.item.reservation_upgrade_price"
                          :controls="false"
                          :precision="2"
                          :step="0.1"
                          :min="0"
                          placeholder="0.00"
                        />
                      </base-input>
                    </div>
                  </div>
                </div>

                <!-- Tickets+fee upgrade: price = per-ticket subtotal (recomputed from the
                     participant counts) + the fixed private booking fee. Driven by the counts. -->
                <div v-if="editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.reservation_upgrade_pricing_mode === 'tickets_plus_fee' && row.item.hasOwnProperty('booking_date')" :key="pr_key + 'TPF'">
                  <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(row.item.subtotal) }}</h2>
                  <small>
                    <div v-for="(c, i) in row.item.pricing_categories" :key="'TPFR' + i">
                      <span class="text-primary">{{getRate(c, row.item)}}</span>
                    </div>
                  </small>
                  <small class="text-white d-block mt-1">Includes {{ getAmount(row.item.private_booking_fee) }} private booking fee</small>
                </div>

                <div v-if="editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')" >
                  <div class="row" :key="pr_key + 'OO'">
                    <div class="col" v-if="!row.item.price_override">
                      <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(row.item.subtotal) }}</h2>
                      <small>
                        <div  v-for="(c, i) in row.item.pricing_categories" :key="'CC' + i">
                          <span class="text-primary">{{getRate(c, row.item)}}</span>
                        </div>
                      </small>
                      <base-button v-on:click="overridePrice(row.item)" class="mt-2" size="sm" type="primary">Override price</base-button>
                    </div>
                    <div v-else>
                      <div v-for="(c, index) in row.item.pricing_categories" :key="'CCOVERRIDE' + index">
                        <label v-if="row.item.pricing_type_id === 1">Price per {{c.category}} ({{currency_symbol}})</label>
                        <label v-if="row.item.pricing_type_id === 2">Price for {{c.category}} ({{currency_symbol}})</label>
                        <div class="row">
                          <div class="col">
                            <base-input>
                              <el-input-number placeholder="0.00" v-model="c.price" :controls="false" :precision="2" :step="0.1" />
                            </base-input>
                          </div>
                          <div class="col">
                            <small class="text-white mr-2">Original price: {{getAmount(c.original_price)}}</small>
                            <el-tooltip class="d-inline"
                                        content="Set to original price"
                                        effect="light"
                                        :open-delay="300"
                                        placement="right"
                            >
                              <i style="cursor: pointer" class="ml-1 tim-icons icon-refresh-02 text-white" v-on:click="setOriginalPrice(c)"></i>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                      <base-button size="sm" type="primary" v-on:click="saveOverride(row.item)">Save</base-button>
                    </div>
                  </div>
                </div>

                <div v-if="!editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')">
                  <div>
                    <strong>{{getAmount(row.item.price)}}</strong>
                    <div class="small text-muted" v-if="row.item.reservation_upgrade_pricing_mode === 'tickets_plus_fee'">Tickets + {{ getAmount(row.item.private_booking_fee) }} private booking fee</div>
                    <div class="small text-muted" v-else>Upgrade override price</div>
                  </div>
                  <div class="small mt-1" v-if="getInclusiveTaxes()">Tax of {{getAmount(row.item.tax)}} included</div>
                </div>

                <div v-if="!editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  {{getAmount(row.item.price)}}
                  <div class="small" v-if="getInclusiveTaxes()">Tax of {{getAmount(row.item.tax)}} included</div>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  {{getAmount(row.item.amount)}}
                  <div class="small" v-if="getInclusiveTaxes()">Tax of {{getAmount(row.item.tax)}} included</div>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')">
                  <div>Purchased value: {{getAmount(row.item.total)}}</div>
                  <div>Price: {{getAmount(row.item.price)}}</div>
                  <div>Remaining: {{getAmount(row.item.remaining)}}</div>
                </div>
                <div v-if="editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <div class="row">
                    <div class="col" v-if="!row.item.price_override">
                      <h2 style="margin-bottom: 0px" class="warning mt-3">{{getAmount(getPurchaseAmount(row.item.price, row.item.quantity))}}</h2>
                      <small class="text-primary">{{getAmount(row.item.price)}} x {{row.item.quantity}}</small>
                      <br>
                      <base-button @click="overridePurchasePrice(row.item)" class="mt-2" size="sm" type="primary">Override price</base-button>
                    </div>
                    <div v-else>
                      <label>Price per unit ({{currency_symbol}})</label>
                      <div class="row">
                        <div class="col">
                          <base-input :error="errs.purchase.price">
                            <el-input-number
                              v-model="row.item.price"
                              :controls="false"
                              :precision="2"
                              :step="0.1"
                              :min="0"
                              placeholder="0.00"
                            />
                          </base-input>
                        </div>
                        <div class="col">
                          <small class="text-white mr-2">Original: {{getAmount(row.item.original_price)}}</small>
                          <el-tooltip class="d-inline" content="Reset to original price" effect="light" :open-delay="300" placement="right">
                            <i style="cursor: pointer" class="ml-1 tim-icons icon-refresh-02 text-white" @click="row.item.price = row.item.original_price"></i>
                          </el-tooltip>
                        </div>
                      </div>
                      <base-button size="sm" type="primary" @click="savePurchasePriceOverride(row.item)">Save</base-button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <el-dropdown placement="bottom-start"
                             v-if="!isReadOnly && ((!row.item.hasOwnProperty('design_url')
                             && !editing_bookings[row.index])
                  || (row.item.hasOwnProperty('design_url')))">
                  <base-button
                    link
                    type="primary"
                    size="sm"
                  ><i style="font-size: large" class="tim-icons el-icon-more"></i>
                  </base-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled'
                      && !row.item.hasOwnProperty('design_url') &&
                       row.item.status !== 'cancelled' && hasPermissions('bookings_update')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         :style="isAnyBookingBeingEdited && !editing_bookings[row.index] ? 'opacity: 0.5; cursor: not-allowed;' : ''"
                         @click="editBooking(row.item, row.index, $event)">
                        <i class="tim-icons icon-pencil mr-2 text-warning"></i> Edit booking
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         :style="isAnyBookingBeingEdited && !editing_bookings[row.index] ? 'opacity: 0.5; cursor: not-allowed;' : ''"
                         @click="editPurchase(row.item, row.index, $event)">
                        <i class="tim-icons icon-pencil mr-2 text-warning"></i> Edit item
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="viewActivityLog(row.item)">
                        <i class="tim-icons icon-bullet-list-67 text-default mr-2"></i> View activity log
                      </a>
                      <!-- Per-row email actions are duplicated by the send email drawer. Retire these gradually; simple emails are planned for retirement. -->
                      <hr v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled' ">
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled' && !row.item.hasOwnProperty('design_url') &&
                      row.item.status !== 'requested'" :style="{'cursor': cursor_type.resend_confirmation_email}"
                         class="dropdown-item" @click="resendConfirmationEmailPrompt(transaction, $event)" href="#">
                        <i v-if="!emailSettingActive('confirmation')" class="text-danger tim-icons icon-alert-circle-exc mr-2"></i>
                        <i v-else style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i>
                        Send booking confirmation email
                        <p style="font-size: x-small;" class="text-default font-italic">
                          <span v-if="transaction.status === 0" class="ml-4">You cannot send a confirmation email on a cancelled transaction </span>
                          <span v-if="!emailSettingActive('confirmation') && transaction.status === 1" class="ml-4">You must set up the automated email settings to send confirmation emails</span>
                          <span v-if="emailSettingActive('confirmation') && !transaction.email" class="ml-4">This transaction has no customer email, so a confirmation cannot be sent</span>
                        </p>
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled'  && !row.item.hasOwnProperty('design_url') &&
                        row.item.status !== 'requested'"
                         class="dropdown-item mb-2" href="#" @click="sendFollowUpEmailPrompt(row.item, $event)">
                        <i style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i> Send follow-up email
                        <p v-if="!transaction.email" style="font-size: x-small;" class="text-default font-italic">
                          <span class="ml-4">This transaction has no customer email, so a follow-up cannot be sent</span>
                        </p>
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled' && row.item.status !== 'requested'  && !row.item.hasOwnProperty('design_url') &&
                          row.item.status !== 'cancelled'"
                         class="dropdown-item mb-2" href="#" @click="sendReminderEmailPrompt(row.item, $event)">
                        <i style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i> Send reminder email
                        <p v-if="!transaction.email" style="font-size: x-small;" class="text-default font-italic">
                          <span class="ml-4">This transaction has no customer email, so a reminder cannot be sent</span>
                        </p>
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url') && row.item.is_active"
                         :style="{'cursor': cursor_type.gift_card_confirmation_email}"
                         class="dropdown-item mb-2 mt-2 " href="#" @click.prevent="sendGiftCardEmail(row.item)">
                        <i v-if="!emailSettingActive('gift_cards')" class="text-danger tim-icons icon-alert-circle-exc mr-2"></i>
                        <i v-else style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i>
                        Send gift card delivery email
                        <p style="font-size: x-small;" class="text-default font-italic">
                          <span v-if="transaction.status === 0" class="ml-4">You cannot send an email on a cancelled transaction </span>
                          <span v-if="!emailSettingActive('gift_cards') && transaction.status === 1" class="ml-4">You must set up the automated email settings to send this email type</span>
                        </p>
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url') && row.item.is_active"
                         :style="{'cursor': cursor_type.gift_card_confirmation_email}"
                         class="dropdown-item mb-2 mt-2 " href="#" @click="sendGiftCardEmailPrompt(row.item, $event)">
                        <i v-if="!emailSettingActive('gift_card_confirmation')" class="text-danger tim-icons icon-alert-circle-exc mr-2"></i>
                        <i v-else style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i>
                        Send gift card purchase confirmation email
                        <p style="font-size: x-small;" class="text-default font-italic">
                          <span v-if="transaction.status === 0" class="ml-4">You cannot send a confirmation email on a cancelled transaction </span>
                          <span v-if="!emailSettingActive('gift_card_confirmation') && transaction.status === 1" class="ml-4">You must set up the automated email settings to send confirmation emails</span>
                        </p>
                      </a>
                      <a v-if="row.item.hasOwnProperty('design_url') && row.item.is_active && hasPermissions('gift_cards_update')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="openAdjustGiftCardValueModal(row.item)">
                        <i class="tim-icons icon-money-coins text-default mr-2"></i> Adjust value
                      </a>
                      <a v-if="row.item.hasOwnProperty('design_url') && row.item.is_active"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="viewGiftCardActivityLog(row.item)">
                        <i class="tim-icons icon-bullet-list-67 text-default mr-2"></i> View activity log
                      </a>
                      <hr v-if="!(row.item.hasOwnProperty('design_url') && row.item.is_active === 0) ">
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                       row.item.status === 'requested'"
                         class="dropdown-item mb-2" href="/bookings/requests">
                        <i class="tim-icons icon-notes mr-2 text-info"></i> Review request
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                       row.item.status !== 'cancelled' && row.item.status !== 'requested' && hasPermissions('bookings_cancel')"
                         class="dropdown-item mb-2" href="#" @click="cancelBookingPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Cancel booking
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                       row.item.status === 'cancelled' && hasPermissions('bookings_update')"
                         class="dropdown-item mb-2" href="#" @click.prevent="reactivateBookingPrompt(row.item)">
                        <i class="tim-icons icon-refresh-02 mr-2 text-default"></i> Reactivate booking
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')"
                         class="dropdown-item mb-2" href="#" @click="deleteItemPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Delete item
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')
                        && hasPermissions('gift_cards_delete') && row.item.is_active === 1"
                         class="dropdown-item mb-2 mt-2" href="#" @click="deactivateGiftCardPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Deactivate gift card
                      </a>
                      <a v-if="row.item.hasOwnProperty('design_url') && row.item.is_active === 0"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="viewGiftCardActivityLog(row.item)">
                        <i class="tim-icons icon-bullet-list-67 text-default mr-2"></i> View activity log
                      </a>
                      <hr v-if="row.item.hasOwnProperty('design_url') && row.item.is_active === 0">
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')
                        && hasPermissions('gift_cards_delete') && row.item.is_active === 0"
                         class="dropdown-item mb-2 mt-2" href="#" @click="deleteGiftCardPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Delete permanently
                      </a>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
                <span v-if="row.item.hasOwnProperty('design_url') && row.item.is_refunded
                    && !editing_bookings[row.index] && !row.item.is_active">-</span>

                <div class="row" v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <base-button v-if="editing_bookings[row.index] && row.item.status !== 'cancelled'"
                               @click="cancelEdit(row.item, row.index)"
                               type="default"
                               size="sm"
                  > Cancel
                  </base-button>
                  <base-button v-if="editing_bookings[row.index] && row.item.status !== 'cancelled'"
                               @click="saveEditPrompt(row.item, row.index)"
                               class="ml-2"
                               type="primary"
                               size="sm"
                               :disabled="row.item.price_override"
                               :title="row.item.price_override ? 'Save or cancel the price override first' : ''"
                  > Save
                  </base-button>
                </div>
                <div class="row" v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <base-button v-if="editing_bookings[row.index]"
                               @click="cancelEdit(row.item, row.index)"
                               type="default"
                               size="sm"
                  > Cancel
                  </base-button>
                  <base-button v-if="editing_bookings[row.index]"
                               @click="saveItemPrompt(row.item, row.index)"
                               class="ml-2"
                               type="primary"
                               size="sm"
                  > Save
                  </base-button>
                </div>
              </template>
            </b-table>
          </div>
<!--          Mobile-->
          <div class="d-sm-none d-block">
            <div v-if="bookings.length <= 0" class="mt-3" >
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No bookings are associated with this transaction.</h4>
              </div>
            </div>
            <b-table v-if="bookings.length > 0" :items="bookings" :fields="['items']">
              <template v-slot:cell(items)="row">
                <div v-if="editing_bookings[row.index] && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <div class="row">
                    <div class="col">
                      <base-input label="Game">
                        <el-select
                          label="Select game"
                          v-model="row.item.selectedGame"
                          class="select-primary"
                          v-on:change="getInitialSubtotal(row.item)"
                          placeholder="Game">
                          <el-option
                            v-for="game in games"
                            class="select-primary"
                            :label="game.name"
                            :value="game.name"
                            :key="game.id"
                          ></el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div v-if="row.item.is_reservation_upgraded">
                    <label>Reservation type</label>
                    <p>Private (upgraded from public)</p>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <base-input label="Date" :error="errs.booking_date">
                        <el-date-picker :editable="false"
                          type="date"
                          placeholder="Select date"
                          value-format="yyyy-MM-dd"
                          name="date"
                          v-model="row.item.booking_date"
                          :format="date_format_cal"
                          v-on:change="getAvailableBookings(row.item, 'date')"
                                        :picker-options="{ firstDayOfWeek: first_day_of_week }"
                        >
                        </el-date-picker>
                      </base-input>
                    </div>
                    <div class="col-12">
                      <base-input label="Time" :error="errs.start_time">
                        <el-select v-on:change="onRescheduleSlotChange(row.item.start_time, row.item)"
                          label="Select time"
                          v-model="row.item.start_time"
                          class="select-primary"
                          value-key="id"
                          placeholder="Time">
                          <el-option
                            v-for="(booking, index) in available_bookings"
                            class="select-primary"
                            :label="getTime(booking.start_time) + ' - ' + getTime(booking.end_time)"
                            :value="{id: booking.id,
                          booking_date: booking.booking_date,
                          end_date: booking.end_date,
                          pricing_categories: booking.pricing_categories,
                          pricing: booking.pricing,
                          custom_pricing: booking.custom_pricing,
                          game_id: booking.game_id,
                          start_time: booking.start_time,
                          is_custom_pricing_enabled: booking.is_custom_pricing_enabled,
                          slot_cumulative_category_pricing: booking.slot_cumulative_category_pricing,
                          slot_pricing_type_id: booking.slot_pricing_type_id,
                          pricing_type_id: booking.pricing_type_id,
                          cumulative_category_pricing: booking.cumulative_category_pricing,
                          all_pricing: booking.all_pricing,
                          slot_durations: booking.slot_durations,
                          game_durations: booking.game_durations,
                          enable_multiple_durations: booking.enable_multiple_durations,
                          game_enable_multiple_durations: booking.game_enable_multiple_durations,
                          end_time: booking.end_time}"
                            :key="'A' + index"
                          >
                            <span>{{ getTime(booking.start_time) }} - {{ getTime(booking.end_time) }}</span>
                            <badge v-if="booking.status === 'blocked' && !booking.status_type_id" type="danger" class="badge-compact ml-2">Blocked</badge>
                            <badge v-if="booking.status === 'call_to_book'" type="warning" class="badge-compact ml-2">Call to book</badge>
                            <span v-if="booking.status === 'requestable'" class="badge badge-compact ml-2" :style="{ backgroundColor: '#FFD600', color: '#1E1E2F' }">Requestable</span>
                            <span v-if="booking.status === 'requested'" class="badge badge-compact ml-2 requested-status-chip">Requested</span>
                            <span v-if="booking.status_type_id" class="badge badge-compact ml-2" :style="{ backgroundColor: booking.status_color, color: booking.status_text_color }">{{ booking.status_display_name }}</span>
                          </el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div v-if="row.item.start_time && row.item.start_time.id && rescheduleDurationOptions.length > 1" class="row mb-3">
                    <div class="col">
                      <label class="d-block mb-1">Duration</label>
                      <segmented-toggle variant="pills" size="sm" :value="reschedule_duration_id" :options="rescheduleDurationOptions" @input="v => onRescheduleDurationChange(row.item, v)" />
                    </div>
                  </div>
                </div>
                <div v-if="!editing_bookings[row.index] && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <div class="row">
                    <div class="col">
                      <p style="font-size: large" class="text-primary">
                        {{ row.item.name }}
                        <badge v-if="row.item.is_reservation_upgraded" type="info" class="ml-2">
                          <i class="tim-icons icon-minimal-up"></i> Private
                        </badge>
                        <el-tooltip content="View game history"
                                    effect="light"
                                    :open-delay="300"
                                    placement="top">
                          <base-button v-if="row.item.status === 'completed'"
                                       v-on:click="goToGame(row.item)" icon class="btn btn-link" simple size="sm" type="primary">
                            <i style="font-size: larger" class="tim-icons el-icon-top-right"></i>
                          </base-button>
                        </el-tooltip>
                      </p>
                    </div>
                  </div>
                  <p>
                    <i class="tim-icons icon-calendar-60"></i> {{getFormattedDate(row.item.booking_date)}}
                    &nbsp;
                    <template v-if="row.item.is_all_day === 1">
                      <i class="tim-icons icon-time-alarm"></i> {{row.item.all_day_text}}
                    </template>
                    <template v-else>
                      <i class="tim-icons icon-time-alarm"></i> {{getTime(row.item.start_time)}} - {{getTime(row.item.end_time)}}
                    </template>
                  </p>
                  <p style="font-size: x-small">Booking id:
                    <el-tooltip v-if="hasPermissions('bookings_view') && bookingCalendarLink(row.item)"
                                content="View on calendar"
                                effect="light"
                                :open-delay="300"
                                placement="top">
                      <a :href="bookingCalendarLink(row.item)" target="_blank" rel="noopener">#{{row.item.master_slot_id ? row.item.master_slot_id : row.item.id}} <i class="tim-icons el-icon-top-right"></i></a>
                    </el-tooltip>
                    <template v-else>#{{row.item.master_slot_id ? row.item.master_slot_id : row.item.id}}</template>
                  </p>
                </div>
                <div class="mb-2" v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <p style="font-size: large" class="text-primary">{{ row.item.name }}</p>
                  <p style="font-size: x-small" v-if="row.item.category_name">{{row.item.category_name}}
                  </p>
                  <p style="font-size: x-small" v-if="row.item.is_custom">{{row.item.description}}
                  </p>
                </div>
                <div class="mb-3" v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')">
                  <p style="font-size: large" class="text-primary">Gift card <span v-if="row.item.gift_card_type">({{row.item.gift_card_type}})</span>
                    <badge v-if="row.item.is_refund_gift_card" type="warning" class="ml-1" style="font-size: 10px;">refund</badge>
                  </p>
                  <p style="font-size: x-small">{{getGiftCardCode(row.item.code)}}</p>
                  <p v-if="row.item.delivery_date" style="font-size: x-small">Delivery date: {{getDayOfWeek(row.item.delivery_date)}}  {{getFormattedDate(row.item.delivery_date)}}</p>
                  <p v-if="!row.item.delivery_date" style="font-size: x-small">Delivery date:  {{getLocalDate(transaction.timestamp)}}</p>
                  <p v-if="row.item.game_name" style="font-size: x-small">Purchased for {{row.item.game_name}}, {{row.item.number_of_participants}} participants</p>
                  <p v-if="row.item.recipients" style="font-size: x-small">Recipient:  {{getRecipient(row.item?.recipients)}}</p>
                  <p v-if="row.item.terms_agreed_at" style="font-size: x-small" class="text-white">
                    <i class="tim-icons icon-check-2 mr-1 text-success"></i>Terms accepted: {{getLocalDate(row.item.terms_agreed_at)}}, {{getLocalTime(row.item.terms_agreed_at)}}<span v-if="row.item.terms_agreed_ip"> &middot; IP {{row.item.terms_agreed_ip}}</span>
                    <base-button v-if="row.item.terms_text_snapshot" style="color: #ba54f5; font-weight:300; font-size: x-small; padding: 0" size="sm" link class="btn btn-link ml-1" v-on:click="openPolicy({policy: row.item.terms_text_snapshot})">View terms</base-button>
                  </p>
                  <img v-if="row.item.design_url" style="object-fit: cover; height: 75px" :src="row.item.design_url"/>
                </div>

                <div class="row" v-if="enable_utm_source_tracking">
                  <div class="col">
                    <p class="text-white">
                      <utm-attribution
                        icon="icon-world"
                        :source="row.item.utm_source"
                        :medium="row.item.utm_medium"
                        :campaign="row.item.utm_campaign"
                        :referrer="row.item.utm_referrer"
                        empty-text="-" />
                    </p>
                  </div>
                </div>

                <!-- Editing participants for upgraded bookings (mobile) -->
                <div v-if="editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')">
                  <div class="row mt-2" :key="pr_key">
                    <div class="col">
                      <label>Participants</label>
                      <div v-for="(c, i) in row.item.pricing_categories" :key="'CXU' + i">
                        <label class="text-primary text-uppercase">{{c.category}}</label>
                        <base-input>
                          <el-input-number @change="getSubtotal(row.item)" v-model="c.number_of_players" :min="0" />
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input :error="errs.number_of_players"><p></p></base-input>
                    </div>
                  </div>
                </div>

                <!-- Editing participants for standard bookings (mobile) -->
                <div v-if="editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')" >
                  <div class="row" :key="pr_key">
                    <div class="col">
                      <div  v-for="(c, i) in row.item.pricing_categories" :key="'CX' + i">
                        <label class="text-primary text-uppercase">{{c.category}}</label>
                        <base-input>
                          <el-input-number @change="getSubtotal(row.item)" v-model="c.number_of_players" :min="0" />
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <base-input :error="errs.number_of_players"><p></p></base-input>
                    </div>
                  </div>
                </div>
                <div v-if="!editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')">
                  <label>Reservation type</label>
                  <p>Private (upgraded from public)</p>
                  <label>Participants</label>
                  <div v-if="row.item.tickets && row.item.tickets.length > 0">
                    <div class="small" v-for="(ticket, idx) in getTicketsArray(row.item.tickets)" :key="'qty-ticket-m-' + idx">
                      <span v-if="ticket.category">{{ticket.number_of_players}}x {{ticket.category}}</span>
                      <span v-else>{{ticket.number_of_players}}x participants</span>
                    </div>
                    <div class="small mt-1"><strong>Total: {{row.item.group_size}} participants</strong></div>
                  </div>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')">
                  Number of participants: x{{row.item.group_size}}
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')">
                  Quantity: x{{row.item.quantity}}
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date')  && row.item.hasOwnProperty('design_url')">
                  Quantity: x1
                </div>

                <div v-if="editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date')  && !row.item.hasOwnProperty('design_url')">
                  <div class="col-lg-8">
                    <base-input :error="errs.purchase.quantity" label="Quantity">
                      <el-input-number v-model="row.item.quantity" :min="1" />
                    </base-input>
                  </div>
                </div>

                <!-- Editing price for upgraded bookings (mobile) -->
                <div v-if="editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.reservation_upgrade_pricing_mode !== 'tickets_plus_fee' && row.item.hasOwnProperty('booking_date')">
                  <div class="row">
                    <div class="col">
                      <label>Upgrade override price ({{currency_symbol}})</label>
                      <base-input :error="errs.price">
                        <el-input-number
                          v-model="row.item.reservation_upgrade_price"
                          :controls="false"
                          :precision="2"
                          :step="0.1"
                          :min="0"
                          placeholder="0.00"
                        />
                      </base-input>
                    </div>
                  </div>
                </div>

                <!-- Tickets+fee upgrade (mobile): per-ticket subtotal + fixed private fee -->
                <div v-if="editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.reservation_upgrade_pricing_mode === 'tickets_plus_fee' && row.item.hasOwnProperty('booking_date')" :key="pr_key + 'TPFM'">
                  <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(row.item.subtotal) }}</h2>
                  <small>
                    <div v-for="(c, i) in row.item.pricing_categories" :key="'TPFRM' + i">
                      <span class="text-primary">{{getRate(c, row.item)}}</span>
                    </div>
                  </small>
                  <small class="text-white d-block mt-1">Includes {{ getAmount(row.item.private_booking_fee) }} private booking fee</small>
                </div>

                <!-- Editing price for standard bookings (mobile) -->
                <div v-if="editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')" >
                  <div class="row">
                    <div class="col mt-2" v-if="!row.item.price_override">
                      <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(row.item.subtotal) }}</h2>
                      <small>
                        <div  v-for="(c, i) in row.item.pricing_categories" :key="'CC' + i">
                          <span class="text-primary">{{getRate(c, row.item)}}</span>
                        </div>
                      </small>
                      <base-button v-on:click="overridePrice(row.item)" class="mt-2" size="sm" type="primary">Override price</base-button>
                    </div>
                    <div class="col" v-else>
                      <div style="max-width: 90%" v-for="(c, index) in row.item.pricing_categories" :key="'CCDOVERRIDE' + index">
                        <label v-if="row.item.pricing_type_id === 1">Price per {{c.category}} ({{currency_symbol}})</label>
                        <label v-if="row.item.pricing_type_id === 2">Price for {{c.category}} ({{currency_symbol}})</label>
                        <div class="row">
                          <div class="col">
                            <base-input>
                              <el-input-number placeholder="0.00" v-model="c.price" :controls="false" :precision="2" :step="0.1" />
                            </base-input>
                          </div>
                          <div class="col">
                            <small class="text-white mr-2">Original price: {{getAmount(c.original_price)}}</small>
                            <el-tooltip class="d-inline"
                                        content="Set to original price"
                                        effect="light"
                                        :open-delay="300"
                                        placement="right"
                            >
                              <i style="cursor: pointer" class="ml-1 tim-icons icon-refresh-02 text-white" v-on:click="setOriginalPrice(c)"></i>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                      <base-button size="sm" type="primary" v-on:click="saveOverride(row.item)">Save</base-button>
                    </div>
                  </div>
                </div>

                <!-- Read-only price for upgraded bookings (mobile) -->
                <div v-if="!editing_bookings[row.index] && row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date')">
                  <div>
                    <strong>{{getAmount(row.item.price)}}</strong>
                    <div class="small" style="color: rgba(255,255,255,0.7)" v-if="row.item.reservation_upgrade_pricing_mode === 'tickets_plus_fee'">Tickets + {{ getAmount(row.item.private_booking_fee) }} private booking fee</div>
                    <div class="small" style="color: rgba(255,255,255,0.7)" v-else>Upgrade override price</div>
                  </div>
                  <div class="small mt-1" v-if="getInclusiveTaxes()">Tax of {{getAmount(row.item.tax)}} included</div>
                </div>
                <!-- Read-only price for standard bookings (mobile) -->
                <div v-if="!editing_bookings[row.index] && !row.item.is_reservation_upgraded && row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  Price: {{getAmount(row.item.price)}}
                  <div class="small" v-if="getInclusiveTaxes()">Tax of {{getAmount(row.item.tax)}} included</div>
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  Price: {{getAmount(row.item.amount)}}
                </div>
                <div v-if="!editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')">
                  Total: {{getAmount(row.item.total)}} Remaining: {{getAmount(row.item.remaining)}}
                </div>
                <div v-if="editing_bookings[row.index] && !row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')">
                  <div class="row">
                    <div class="col" v-if="!row.item.price_override">
                      <h2 style="margin-bottom: 0px" class="warning mt-3">{{getAmount(getPurchaseAmount(row.item.price, row.item.quantity))}}</h2>
                      <small class="text-primary">{{getAmount(row.item.price)}} x {{row.item.quantity}}</small>
                      <br>
                      <base-button @click="overridePurchasePrice(row.item)" class="mt-2" size="sm" type="primary">Override price</base-button>
                    </div>
                    <div v-else>
                      <label>Price per unit ({{currency_symbol}})</label>
                      <div class="row">
                        <div class="col">
                          <base-input :error="errs.purchase.price">
                            <el-input-number
                              v-model="row.item.price"
                              :controls="false"
                              :precision="2"
                              :step="0.1"
                              :min="0"
                              placeholder="0.00"
                            />
                          </base-input>
                        </div>
                        <div class="col">
                          <small class="text-white mr-2">Original: {{getAmount(row.item.original_price)}}</small>
                          <el-tooltip class="d-inline" content="Reset to original price" effect="light" :open-delay="300" placement="right">
                            <i style="cursor: pointer" class="ml-1 tim-icons icon-refresh-02 text-white" @click="row.item.price = row.item.original_price"></i>
                          </el-tooltip>
                        </div>
                      </div>
                      <base-button size="sm" type="primary" @click="savePurchasePriceOverride(row.item)">Save</base-button>
                    </div>
                  </div>
                </div>

                <el-dropdown placement="bottom-start"
                             v-if="!isReadOnly && ((!row.item.hasOwnProperty('design_url')
                             && !editing_bookings[row.index])
                  || (row.item.hasOwnProperty('design_url')))">
                  <base-button style="padding-left: 0px"
                    link
                    type="primary"
                    size="sm"
                  >More actions <i style="font-size: large" class="tim-icons el-icon-more ml-2"></i>
                  </base-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled'
                      && !row.item.hasOwnProperty('design_url') &&
                       row.item.status !== 'cancelled' && hasPermissions('bookings_update')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         :style="isAnyBookingBeingEdited && !editing_bookings[row.index] ? 'opacity: 0.5; cursor: not-allowed;' : ''"
                         @click="editBooking(row.item, row.index, $event)">
                        <i class="tim-icons icon-pencil mr-2 text-warning"></i> Edit booking
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         :style="isAnyBookingBeingEdited && !editing_bookings[row.index] ? 'opacity: 0.5; cursor: not-allowed;' : ''"
                         @click="editPurchase(row.item, row.index, $event)">
                        <i class="tim-icons icon-pencil mr-2 text-warning"></i> Edit item
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="viewActivityLog(row.item)">
                        <i class="tim-icons icon-bullet-list-67 text-default mr-2"></i> View activity log
                      </a>
                      <!-- Per-row email actions are duplicated by the send email drawer. Retire these gradually; simple emails are planned for retirement. -->
                      <hr v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled' ">
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled' && !row.item.hasOwnProperty('design_url') &&
                      row.item.status !== 'requested'" :style="{'cursor': cursor_type.resend_confirmation_email}"
                         class="dropdown-item" @click="resendConfirmationEmailPrompt(transaction, $event)" href="#">
                        <i v-if="!emailSettingActive('confirmation')" class="text-danger tim-icons icon-alert-circle-exc mr-2"></i>
                        <i v-else style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i>
                        Send booking confirmation email
                        <p style="font-size: x-small;" class="text-default font-italic">
                          <span v-if="transaction.status === 0" class="ml-4">You cannot send a confirmation email on a cancelled transaction </span>
                          <span v-if="!emailSettingActive('confirmation') && transaction.status === 1" class="ml-4">You must set up the automated email settings to send confirmation emails</span>
                          <span v-if="emailSettingActive('confirmation') && !transaction.email" class="ml-4">This transaction has no customer email, so a confirmation cannot be sent</span>
                        </p>
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled'  && !row.item.hasOwnProperty('design_url') &&
                        row.item.status !== 'requested'"
                         class="dropdown-item mb-2" href="#" @click="sendFollowUpEmailPrompt(row.item, $event)">
                        <i style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i> Send follow-up email
                        <p v-if="!transaction.email" style="font-size: x-small;" class="text-default font-italic">
                          <span class="ml-4">This transaction has no customer email, so a follow-up cannot be sent</span>
                        </p>
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && row.item.status !== 'cancelled' && row.item.status !== 'requested'  && !row.item.hasOwnProperty('design_url') &&
                          row.item.status !== 'cancelled'"
                         class="dropdown-item mb-2" href="#" @click="sendReminderEmailPrompt(row.item, $event)">
                        <i style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i> Send reminder email
                        <p v-if="!transaction.email" style="font-size: x-small;" class="text-default font-italic">
                          <span class="ml-4">This transaction has no customer email, so a reminder cannot be sent</span>
                        </p>
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url') && row.item.is_active"
                         :style="{'cursor': cursor_type.gift_card_confirmation_email}"
                         class="dropdown-item mb-2 mt-2 " href="#" @click.prevent="sendGiftCardEmail(row.item)">
                        <i v-if="!emailSettingActive('gift_cards')" class="text-danger tim-icons icon-alert-circle-exc mr-2"></i>
                        <i v-else style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i>
                        Send gift card delivery email
                        <p style="font-size: x-small;" class="text-default font-italic">
                          <span v-if="transaction.status === 0" class="ml-4">You cannot send an email on a cancelled transaction </span>
                          <span v-if="!emailSettingActive('gift_cards') && transaction.status === 1" class="ml-4">You must set up the automated email settings to send this email type</span>
                        </p>
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url') && row.item.is_active"
                         :style="{'cursor': cursor_type.gift_card_confirmation_email}"
                         class="dropdown-item mb-2 mt-2 " href="#" @click="sendGiftCardEmailPrompt(row.item, $event)">
                        <i v-if="!emailSettingActive('gift_card_confirmation')" class="text-danger tim-icons icon-alert-circle-exc mr-2"></i>
                        <i v-else style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i>
                        Send gift card purchase confirmation email
                        <p style="font-size: x-small;" class="text-default font-italic">
                          <span v-if="transaction.status === 0" class="ml-4">You cannot send a confirmation email on a cancelled transaction </span>
                          <span v-if="!emailSettingActive('gift_card_confirmation') && transaction.status === 1" class="ml-4">You must set up the automated email settings to send confirmation emails</span>
                        </p>
                      </a>
                      <a v-if="row.item.hasOwnProperty('design_url') && row.item.is_active && hasPermissions('gift_cards_update')"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="openAdjustGiftCardValueModal(row.item)">
                        <i class="tim-icons icon-money-coins text-default mr-2"></i> Adjust value
                      </a>
                      <a v-if="row.item.hasOwnProperty('design_url') && row.item.is_active"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="viewGiftCardActivityLog(row.item)">
                        <i class="tim-icons icon-bullet-list-67 text-default mr-2"></i> View activity log
                      </a>
                      <hr v-if="!(row.item.hasOwnProperty('design_url') && row.item.is_active === 0)">
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                       row.item.status === 'requested'"
                         class="dropdown-item mb-2" href="/bookings/requests">
                        <i class="tim-icons icon-notes mr-2 text-info"></i> Review request
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                       row.item.status !== 'cancelled' && row.item.status !== 'requested' && hasPermissions('bookings_cancel')"
                         class="dropdown-item mb-2" href="#" @click="cancelBookingPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Cancel booking
                      </a>
                      <a v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                       row.item.status === 'cancelled' && hasPermissions('bookings_update')"
                         class="dropdown-item mb-2" href="#" @click.prevent="reactivateBookingPrompt(row.item)">
                        <i class="tim-icons icon-refresh-02 mr-2 text-default"></i> Reactivate booking
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url')"
                         class="dropdown-item mb-2" href="#" @click="deleteItemPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Delete item
                      </a>
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')
                        && hasPermissions('gift_cards_delete') && row.item.is_active === 1"
                         class="dropdown-item mb-2 mt-2" href="#" @click="deactivateGiftCardPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Deactivate gift card
                      </a>
                      <a v-if="row.item.hasOwnProperty('design_url') && row.item.is_active === 0"
                         class="dropdown-item mb-2 mt-2" href="#"
                         @click.prevent="viewGiftCardActivityLog(row.item)">
                        <i class="tim-icons icon-bullet-list-67 text-default mr-2"></i> View activity log
                      </a>
                      <hr v-if="row.item.hasOwnProperty('design_url') && row.item.is_active === 0">
                      <a v-if="!row.item.hasOwnProperty('booking_date') && row.item.hasOwnProperty('design_url')
                        && hasPermissions('gift_cards_delete') && row.item.is_active === 0"
                         class="dropdown-item mb-2 mt-2" href="#" @click="deleteGiftCardPrompt(row.item, $event)">
                        <i class="tim-icons icon-trash-simple mr-2 text-danger"></i> Delete permanently
                      </a>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

                <div
                  class="btn-group btn-group-toggle mt-3"
                  :class="'float-left'"
                  data-toggle="buttons" style="width:100%; max-width: 100%"
                >
                  <label class="btn btn-sm btn-primary btn-simple"
                         v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                         editing_bookings[row.index] && row.item.status !== 'cancelled'">
                    <base-button style="padding-left: 0; padding-right: 0"
                                 @click.native="cancelEdit(row.item, row.index)"
                                 type="primary"
                                 class="btn btn-link"
                                 size="sm"
                                 icon
                    ><i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </label>
                  <label class="btn btn-sm btn-primary btn-simple"
                         :class="{'disabled': row.item.price_override}"
                         v-if="row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                         editing_bookings[row.index] && row.item.status !== 'cancelled'">
                    <base-button style="padding-left: 0; padding-right: 0"
                                 @click.native="!row.item.price_override && saveEditPrompt(row.item, row.index)"
                                 class="like btn-link"
                                 type="primary"
                                 size="sm"
                                 icon
                                 :disabled="row.item.price_override"
                    ><i class="tim-icons icon-check-2"></i>
                    </base-button>
                  </label>
                  <label class="btn btn-sm btn-primary btn-simple"
                         v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                         editing_bookings[row.index]">
                    <base-button style="padding-left: 0; padding-right: 0"
                                 @click.native="cancelEdit(row.item, row.index)"
                                 type="primary"
                                 class="btn btn-link"
                                 size="sm"
                                 icon
                    ><i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </label>
                  <label class="btn btn-sm btn-primary btn-simple"
                         v-if="!row.item.hasOwnProperty('booking_date') && !row.item.hasOwnProperty('design_url') &&
                         editing_bookings[row.index]">
                    <base-button style="padding-left: 0; padding-right: 0"
                                 @click.native="saveItemPrompt(row.item, row.index)"
                                 type="primary"
                                 class="btn btn-link"
                                 size="sm"
                                 icon
                    ><i class="tim-icons icon-check-2"></i>
                    </base-button>
                  </label>
                </div>
              </template>
            </b-table>
          </div>

        </div>


<!--        Payments-->
        <!-- OTC-3123: an order moved from another location keeps the payments its old gateway took. -->
        <div class="row" v-if="activeTabIndex === 1 && moveActivity" key="tab-1-move-hint">
          <div class="col">
            <info-hint variant="warning" icon="icon-alert-circle-exc" class="mb-3" style="width: 100%">
              {{ moveActivity.description }}. Payments taken before the merge were charged through the previous
              location's payment gateway. A refund from this location succeeds only while both locations use the
              same gateway account.
            </info-hint>
          </div>
        </div>
        <!-- TEMPORARY (group 40 only) — flat 3-button action row replacing
             the Payment options dropdown. To revert: flip the
             `useNewPaymentActions` computed to `return false`, or wrap this
             whole row in `v-if="false"` (the legacy block below still works
             because it gates on `!useNewPaymentActions`). -->
        <div class="row" v-if="activeTabIndex === 1 && useNewPaymentActions && !isReadOnly" key="tab-1-actions-new">
          <div class="col d-flex flex-wrap" style="gap: 8px;">
            <base-button
              size="sm"
              simple
              type="success"
              :disabled="transaction.due <= 0"
              @click.prevent="addPaymentModal($event)"
            >
              <i class="tim-icons icon-money-coins"></i> Add payment
            </base-button>

            <base-button
              size="sm"
              simple
              type="primary"
              @click="paymentRequestsDrawerOpen = true"
            >
              <i class="tim-icons icon-link-72"></i> Payment requests
            </base-button>

            <send-to-pos-button
              v-if="transaction && transaction.id && transaction.due > 0"
              :transaction-id="Number(transaction.id)"
              :amount="Number(transaction.due) || null"
              @already-paid="getTransaction()"
              @order-cancelled="getTransaction()"
            />
          </div>
        </div>

        <div class="row" v-if="activeTabIndex === 1 && !useNewPaymentActions && !isReadOnly" key="tab-1-actions-old">
          <div class="col">
            <el-dropdown placement="bottom-start">
              <base-button size="sm"
                           simple
                           type="success" class="mr-2"

              > Payment options <i class="tim-icons icon-minimal-down ml-1"></i>
              </base-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <a :style="{'cursor': transaction.due <= 0 ? 'not-allowed' : 'pointer'}" class="dropdown-item mb-2 mt-2" href="#" @click.prevent="addPaymentModal($event)">
                    <i style="color: #2dce89" class="tim-icons icon-money-coins mr-2"></i> Add new payment
                    <p style="font-size: x-small;" class="text-default font-italic">
                      <span v-if="transaction.due <= 0" class="ml-4">No amount is due </span>
                    </p>
                  </a>
<!--                  <a v-if="payment_settings.payment_gateway_id === 2 && payment_settings.hardware_type_id === 1" class="dropdown-item mb-2" href="#" @click="sendToSquarePOS($event)">-->
<!--                    <i class="tim-icons icon-tablet-2 mr-2 text-default"></i> Send to Square Register-->
<!--                  </a>-->
<!--                  <a v-if="payment_settings.payment_gateway_id === 2 && payment_settings.hardware_type_id === 2" class="dropdown-item mb-2" href="#" @click="sendToSquarePOS($event)">-->
<!--                    <i class="tim-icons icon-tablet-2 mr-2 text-default"></i> Send to Square Terminal-->
<!--                  </a>-->
                  <hr>
                  <a class="dropdown-item mb-2" href="#" @click.prevent="paymentRequestsDrawerOpen = true">
                    <i class="tim-icons icon-coins mr-2 text-default"></i> Enable custom deposit
                  </a>
                  <a class="dropdown-item mb-2" href="#" @click="copyPaymentRequestLink($event)">
                    <i class="tim-icons icon-link-72 mr-2 text-info"></i> Copy payment request link
                  </a>
                  <a :style="{'cursor': cursor_type.payment_request}" class="dropdown-item" @click="sendPaymentRequestPrompt(transaction)" href="#">
                    <i v-if="email_settings && !email_settings[2].is_active" class="text-danger mr-2 tim-icons icon-alert-circle-exc"></i>
                    <i v-else style="color: #2dce89" class="tim-icons icon-email-85 mr-2"></i>
                    Send payment request
                    <p style="font-size: x-small;" class="text-default font-italic">
                      <span v-if="transaction.status === 0" class="ml-4">You cannot send a payment request email on a cancelled transaction </span>
                      <span v-if="transaction.due <= 0 && transaction.status === 1" class="ml-4">You cannot send a payment request email when no amount is due on the transaction </span>
                      <span v-if="email_settings && !email_settings[2].is_active && transaction.due > 0 && transaction.status === 1" class="ml-4">You must set up the automated email settings to send payment requests </span>
                    </p>
                  </a>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <send-to-pos-button
              v-if="transaction && transaction.id && transaction.due > 0"
              :transaction-id="Number(transaction.id)"
              :amount="Number(transaction.due) || null"
              class="ml-2"
              @already-paid="getTransaction()"
              @order-cancelled="getTransaction()"
            />

<!--            <base-button v-on:click="addPaymentModal()" simple type="success" size="sm">-->
<!--              <i class="tim-icons el-icon-plus"></i> Add new payment</base-button>-->
          </div>
          <div class="col-lg-2 text-right" v-if="transaction.custom_deposit_enabled">
            <label >Custom deposit amount</label>
            <p style="font-size: large"
               label="Custom deposit amount">{{getAmount(transaction.custom_deposit_amount)}}</p>

          </div>
        </div>

        <div v-if="activeTabIndex === 1 && payments.length <= 0" key="tab-1-empty" >
          <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            <h4 class="mt-3">No payments have been made.</h4>
          </div>
        </div>
        <div class="d-sm-block d-none" key="tab-1-table-desktop">
          <b-table v-if="activeTabIndex === 1 && payments.length > 0" :items="payments" :fields="paymentFields">
            <template v-slot:cell(payment_details)="row">
              <div class="row">
                <div class="col">
                  <p v-if="row.item.type == 'card'" style="font-size: large">Card payment
                    <span v-if="row.item.gateway_transaction_id && row.item.gateway_transaction_id.length > 0 && row.item.card_type">({{row.item.card_type}})</span>
                    <badge class="ml-2" v-if="row.item.gateway_transaction_id && row.item.gateway_transaction_id.length > 0 && !row.item.card_type && row.item.status === 2">pending</badge>
                    <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                  </p>
                  <p v-if="row.item.type == 'gift_card'" style="font-size: large">Gift card <span v-if="row.item.gift_card_type">({{row.item.gift_card_type}})</span>
                    <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                  </p>
                  <p v-if="row.item.type == 'bank_transfer'" style="font-size: large">Bank transfer
                    <badge class="ml-2" v-if="row.item.status === 2 || row.item.status === 3">pending</badge>
                  </p>
                  <p v-if="row.item.type == 'cash'" style="font-size: large">Cash payment</p>
                  <p v-if="row.item.type == 'customer_credit'" style="font-size: large">Customer credit payment</p>
                  <p v-if="row.item.type == 'pos'" style="font-size: large">POS payment</p>
                  <p v-if="isCustomPaymentType(row.item.type)"
                     style="font-size: large">{{row.item.type}}
                    <badge class="ml-2" v-if="row.item.status === 2 || row.item.status === 3">pending</badge>
                  </p>

                  <p v-if="row.item.last_four" ><span class="font-weight-600">Card number: </span>xxxx-xxxx-xxxx-{{row.item.last_four}}</p>
                  <p v-if="row.item.cardholder_first_name">
                    <span class="font-weight-600" v-if="row.item.type == 'card'">Cardholder: </span>
                    <span class="font-weight-600" v-else>Payee: </span>
                    {{row.item.cardholder_first_name}} {{row.item.cardholder_last_name}}</p>
                  <p v-if="row.item.gateway_transaction_id && row.item.type === 'gift_card'">
                    <span class="font-weight-600">Gift card code: </span>
                    {{getGiftCardCode(row.item.gateway_transaction_id)}}</p>
                  <p v-if="row.item.gateway_transaction_id && row.item.type === 'gift_card'">
                    <span class="font-weight-600">Remaining: </span>
                    {{getAmount(row.item.gift_card_remaining)}}</p>
                  <p v-else-if="row.item.gateway_transaction_id && row.item.type !== 'gift_card'">
                    <span class="font-weight-600">Gateway reference: </span>
                    {{row.item.gateway_transaction_id}}</p>
                  <p v-if="row.item.timestamp && !showEditPaymentDate[row.index]"><span class="font-weight-600">Paid on: </span>{{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</p>
                  <div v-if="showEditPaymentDate[row.index]" class="mt-2">
                    <div class="d-flex align-items-end" style="gap: 8px;">
                      <base-input label="Date" style="width: 170px; margin-bottom: 0;">
                        <el-date-picker
                          v-model="editPaymentDateDate[row.index]"
                          type="date"
                          :format="date_format_cal"
                          value-format="yyyy-MM-dd"
                          placeholder="Date"
                          :clearable="false"
                          :picker-options="{ disabledDate: (date) => date > new Date(), firstDayOfWeek: first_day_of_week }"
                          @change="$set(editPaymentDateError, row.index, '')"
                        />
                      </base-input>
                      <base-input label="Time" style="width: 140px; margin-bottom: 0;">
                        <el-time-picker
                          v-model="editPaymentDateTime[row.index]"
                          :format="picker_time_format"
                          placeholder="HH:MM"
                          :clearable="false"
                          @change="$set(editPaymentDateError, row.index, '')"
                        />
                      </base-input>
                    </div>
                    <label v-if="editPaymentDateError[row.index]" class="error" style="color: #ec250d;">{{ editPaymentDateError[row.index] }}</label>
                    <div class="mt-2">
                        <base-button size="sm" simple type="primary"
                                     @click="$set(showEditPaymentDate, row.index, false)">
                          Cancel
                        </base-button>
                        <base-button size="sm" type="primary" class="ml-2"
                                     :disabled="!editPaymentDateDate[row.index] || !editPaymentDateTime[row.index] || editPaymentDateLoading"
                                     :loading="editPaymentDateLoading"
                                     @click="updatePaymentDate(row.item, row.index)">
                          Save
                        </base-button>
                    </div>
                  </div>
                  <small v-if="row.item.email" style="font-style: italic"><span class="font-weight-600">Payment collected by: </span>
                    {{row.item.first_name}} {{row.item.last_name}}
                  </small>
                </div>
                <!--              <div class="col">-->
                <!--                <p class="text-white" v-if="row.item.due_amount != null">Total: {{getAmount(row.item.due_amount)}}</p>-->
                <!--                <p class="text-danger" v-if="row.item.due_amount != null">Due: {{getDueAmount(row.item)}}</p>-->
                <!--                <p class="text-success" v-if="row.item.paid_amount != null">Paid: {{getAmount(row.item.paid_amount)}}</p>-->
                <!--              </div>-->
              </div>
              <div v-if="showRefund[row.index]">
                <div class="row mt-1">
                  <div class="col-7">
                    <base-input label="Refund options">
                      <el-select
                        v-model="selectedPaymentAmount"
                        v-on:change="toggleDisabledFlagForAmount(row.item)"
                        class="select-primary"
                        name="game"
                        placeholder="Refund option"
                        value-key="id"
                      >
                        <el-option
                          v-for="option in paymentAmountOptions"
                          class="select-primary"
                          :label="option.name"
                          :value="{id: option.id, name: option.name}"
                          :key="'B' + option.id"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col-3">
                    <base-input v-on:change="validateRefundAmount()" :disabled="isAmountFieldDisabled" :label="'Amount (' + currency_symbol + ')'" v-model="refundAmount">
                    </base-input>
                  </div>
                </div>
                <div v-if="selectedPaymentAmount.id === 3 && gift_card_types.length > 0" class="row mt-1">
                  <div class="col-7">
                    <base-input label="Gift card type">
                      <el-select
                        v-model="selectedRefundGiftCardType"
                        class="select-primary"
                        value-key="id"
                        placeholder="Select gift card type"
                      >
                        <el-option
                          v-for="(gct, index) in gift_card_types"
                          class="select-primary"
                          :label="gct.name"
                          :value="{ id: gct.id, name: gct.name }"
                          :key="'refund-gc-' + index"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <base-button v-on:click="$set(showRefund, row.index, 0)" simple size="sm" type="primary">Cancel</base-button>
                    <base-button v-on:click="processRefund(row.item, row.index)" :disabled="loading" class="ml-2" size="sm" type="primary">
                      {{ selectedPaymentAmount.id === 3 ? 'Issue gift card' : 'Make refund' }}
                    </base-button>

                  </div>
                </div>
              </div>
            </template>
            <template #head(amount)="row">
              <span></span>
            </template>
            <template v-slot:cell(amount)="row">
              <div class="row justify-content-center">
                <div class="col text-center">
                  <small>Amount</small>
                  <p style="font-size: large">{{getAmount(row.item.amount - row.item.refunded)}}</p>
                </div>
                <div v-if="row.item.refunded > 0 && !refundBreakdownTrusted(row.item)" class="col text-center">
                  <small>Refunded</small>
                  <p style="font-size: large">{{getAmount(row.item.refunded)}}</p>
                </div>
                <div v-if="refundBreakdownTrusted(row.item) && row.item.refunded > 0 && !row.item.refund_gift_card_code && (row.item.refunded - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id)) > 0" class="col text-center">
                  <small>Refunded to {{refundMethodLabel(row.item.type)}}</small>
                  <p style="font-size: large">{{getAmount(row.item.refunded - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id))}}</p>
                </div>
                <div v-if="refundBreakdownTrusted(row.item) && row.item.refunded > 0 && row.item.refund_gift_card_code && (row.item.refunded - row.item.refund_gift_card_total - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id)) > 0" class="col text-center">
                  <small>Refunded to {{refundMethodLabel(row.item.type)}}</small>
                  <p style="font-size: large">{{getAmount(row.item.refunded - row.item.refund_gift_card_total - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id))}}</p>
                </div>
                <div v-if="refundBreakdownTrusted(row.item) && getExternalRefundTotal(row.item.id) > 0" class="col text-center">
                  <small>Marked as refunded</small>
                  <p style="font-size: large">{{getAmount(getExternalRefundTotal(row.item.id))}}</p>
                </div>
                <div v-if="refundBreakdownTrusted(row.item) && getCustomerCreditRefundTotal(row.item.id) > 0" class="col text-center">
                  <small>Refunded to store credit</small>
                  <p style="font-size: large">{{getAmount(getCustomerCreditRefundTotal(row.item.id))}}</p>
                </div>
                <div v-if="refundBreakdownTrusted(row.item) && row.item.refund_gift_card_total > 0" class="col text-center">
                  <small>Refunded to gift card</small>
                  <p style="font-size: large">{{getAmount(row.item.refund_gift_card_total)}}</p>
                </div>
              </div>

            </template>
            <template v-slot:cell(status)="row">
              <badge v-if="row.item.status == 1" type="success">Active</badge>
              <badge v-if="row.item.status == 0" type="danger">Cancelled</badge>
            </template>
            <!--          <template v-slot:cell(customer_details)="row">-->
            <!--            <p class="text-white">{{row.item.first_name}} {{row.item.last_name}}</p>-->
            <!--            <p>-->
            <!--              <i v-if="row.item.email != null" class="tim-icons icon-email-85"></i> {{ row.item.email }}-->
            <!--            </p>-->
            <!--            <p>-->
            <!--              <i v-if="row.item.phone != null && row.item.length > 0" class="tim-icons el-icon-mobile-phone"></i> {{row.item.phone}}-->
            <!--            </p>-->
            <!--            <base-button v-on:click="viewCustomerDetails(row.item.end_user_id)" size="sm" simple type="info">View customer details</base-button>-->
            <!--          </template>-->

            <template v-slot:cell(actions)="row">
              <p v-if="!row.item.status">-</p>
            <span>
              <el-dropdown v-if="row.item.status && !isReadOnly">
                <base-button
                  link
                  type="primary"
                  size="sm"
                > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                </base-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <a v-if="isCustomPaymentType(row.item.type) && (row.item.status === 2 || row.item.status === 3)"
                       class="dropdown-item mb-2 mt-2" @click.prevent="markAsPaidPrompt(row.item, row.index)" href="#">
                       <i class="tim-icons icon-check-2 mr-2"></i> Mark as paid
                    </a>
                    <a v-if="isPaymentDateEditable(row.item)"
                       class="dropdown-item mb-2 mt-2" @click.prevent="$set(showEditPaymentDate, row.index, true); initEditPaymentDate(row.item, row.index)" href="#">
                       <i class="tim-icons icon-calendar-60 mr-2"></i> Edit payment date
                    </a>
                    <a v-if="(isRefundable(row.item))
                    && row.item.type !== 'bank_transfer'"
                       class="dropdown-item mb-2" @click.prevent="showRefundForPayment(row.item, row.index)" href="#">
                       <i class="tim-icons icon-refresh-01 mr-2"></i> Refund payment
                    </a>
                    <a class="dropdown-item mb-2" v-if="isRefundable(row.item) && (row.item.type === 'card' || row.item.type === 'bank_transfer') && (row.item.status !== 2 && row.item.status !== 3)"
                       @click.prevent="markAsRefundedPrompt(row.item, row.index)" href="#">
                      <div class="row">
                        <div class="col">
                          <i class="tim-icons icon-tag mr-2"></i>
                           Mark as refunded
                        </div>
                      </div>
                      <div class="row">
                        <div class="col ml-4">
                           <small style="font-style: italic">Will not process card payment</small>
                        </div>
                      </div>
                    </a>
                    <a class="dropdown-item mb-2" v-for="refund in getActiveExternalRefunds(row.item.id)" :key="'undo-refund-' + refund.id"
                       @click.prevent="reverseExternalRefundPrompt(refund)" href="#">
                      <i class="tim-icons icon-refresh-02 mr-2"></i> Undo manual refund ({{getAmount(refund.amount)}})
                    </a>
                    <a class="dropdown-item mb-2" @click.prevent="refundEmailConfirmationPrompt(row.item)" href="#">
                       <i class="tim-icons icon-email-85 mr-2"></i> Send refund email
                    </a>
                    <hr v-if="isRemovablePayment(row.item)">
                    <a v-if="isRemovablePayment(row.item)" class="dropdown-item mb-2" @click.prevent="deletePaymentRecordPrompt(row.item, row.index)" href="#">
                       <i class="tim-icons icon-trash-simple mr-2"></i> Delete payment record
                    </a>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </span>
            </template>
          </b-table>
        </div>
<!--        Mobile-->
        <div class="d-sm-none d-block" key="tab-1-table-mobile">
          <b-table v-if="activeTabIndex === 1 && payments.length > 0" :items="payments" :fields="['payments']">
            <template v-slot:cell(payments)="row">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-9">
                      <p v-if="row.item.type == 'card'" style="font-size: large">Card payment
                        <span v-if="row.item.gateway_transaction_id && row.item.gateway_transaction_id.length > 0 && row.item.card_type">({{row.item.card_type}})</span>
                        <badge class="ml-2" v-if="row.item.gateway_transaction_id && row.item.gateway_transaction_id.length > 0 && !row.item.card_type">pending</badge>
                        <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                      </p>
                      <p v-if="row.item.type == 'gift_card'" style="font-size: large">Gift card <span v-if="row.item.gift_card_type">({{row.item.gift_card_type}})</span>
                        <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                      </p>
                      <p v-if="row.item.type == 'bank_transfer'" style="font-size: large">Bank transfer
                        <badge class="ml-2" v-if="row.item.status === 2 || row.item.status === 3">pending</badge>
                        <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                      </p>
                      <p v-if="row.item.type == 'cash'" style="font-size: large">Cash payment
                        <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                      </p>
                      <p v-if="row.item.type == 'customer_credit'" style="font-size: large">Customer credit payment
                        <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                      </p>
                      <p v-if="row.item.type == 'pos'" style="font-size: large">POS payment
                        <badge class="ml-2" type="danger" v-if="!row.item.status">failed</badge>
                      </p>
                      <p v-if="isCustomPaymentType(row.item.type)"
                         style="font-size: large">{{row.item.type}}
                        <badge class="ml-2" v-if="row.item.status === 2 || row.item.status === 3">pending</badge>
                      </p>
                    </div>
                    <div class="col text-right">
                      <span v-if="!showRefund[row.index]">
                        <el-dropdown v-if="row.item.status && !isReadOnly">
                          <base-button
                            link
                            type="primary"
                            size="sm"
                          > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                          </base-button>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <a v-if="isCustomPaymentType(row.item.type) && (row.item.status === 2 || row.item.status === 3)" class="dropdown-item mb-2 mt-2" @click.prevent="markAsPaidPrompt(row.item, row.index)" href="#">
                                 <i class="tim-icons icon-check-2 mr-2"></i> Mark as paid
                              </a>
                              <a v-if="isPaymentDateEditable(row.item)"
                                 class="dropdown-item mb-2 mt-2" @click.prevent="$set(showEditPaymentDate, row.index, true); initEditPaymentDate(row.item, row.index)" href="#">
                                 <i class="tim-icons icon-calendar-60 mr-2"></i> Edit payment date
                              </a>
                              <a v-if="isRefundable(row.item) && row.item.type !== 'bank_transfer'"
                                 class="dropdown-item mb-2" @click.prevent="showRefundForPayment(row.item, row.index)" href="#">
                                 <i class="tim-icons icon-refresh-01 mr-2"></i> Refund payment
                              </a>
                              <a class="dropdown-item mb-2" v-if="isRefundable(row.item) &&
                              (row.item.type === 'card' || row.item.type === 'bank_transfer') && (row.item.status !== 2 && row.item.status !== 3)" @click.prevent="markAsRefundedPrompt(row.item, row.index)" href="#">
                                <div class="row">
                                  <div class="col">
                                    <i class="tim-icons icon-tag mr-2"></i>
                                     Mark as refunded
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col ml-4">
                                     <small style="font-style: italic">Will not process card payment</small>
                                  </div>
                                </div>
                              </a>
                              <a class="dropdown-item mb-2" v-for="refund in getActiveExternalRefunds(row.item.id)" :key="'m-undo-refund-' + refund.id"
                                 @click.prevent="reverseExternalRefundPrompt(refund)" href="#">
                                <i class="tim-icons icon-refresh-02 mr-2"></i> Undo manual refund ({{getAmount(refund.amount)}})
                              </a>
                              <a class="dropdown-item mb-2" @click.prevent="refundEmailConfirmationPrompt(row.item)" href="#">
                                 <i class="tim-icons icon-email-85 mr-2"></i> Send refund email
                              </a>
                              <hr v-if="isRemovablePayment(row.item)">
                              <a v-if="isRemovablePayment(row.item)" class="dropdown-item mb-2" @click.prevent="deletePaymentRecordPrompt(row.item, row.index)" href="#">
                                 <i class="tim-icons icon-trash-simple mr-2"></i> Delete payment record
                              </a>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </span>
                    </div>
                  </div>
                  <p v-if="row.item.last_four" ><span class="font-weight-600">Card number: </span>xxxx-xxxx-xxxx-{{row.item.last_four}}</p>
                  <p v-if="row.item.cardholder_first_name">
                    <span class="font-weight-600" v-if="row.item.type == 'card'">Cardholder: </span>
                    <span class="font-weight-600" v-else>Payee: </span>
                    {{row.item.cardholder_first_name}} {{row.item.cardholder_last_name}}</p>
                  <p v-if="row.item.gateway_transaction_id && row.item.type === 'gift_card'">
                    <span class="font-weight-600">Gift card code: </span>
                    {{getGiftCardCode(row.item.gateway_transaction_id)}}</p>
                  <p v-if="row.item.gateway_transaction_id && row.item.type === 'gift_card'">
                    <span class="font-weight-600">Remaining: </span>
                    {{getAmount(row.item.gift_card_remaining)}}</p>
                  <p v-else-if="row.item.gateway_transaction_id && row.item.type !== 'gift_card'">
                    <span class="font-weight-600">Gateway reference: </span>
                    {{row.item.gateway_transaction_id}}</p>
                  <p v-if="row.item.timestamp && !showEditPaymentDate[row.index]"><span class="font-weight-600">Paid on: </span>{{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</p>
                  <div v-if="showEditPaymentDate[row.index]" class="mt-2 mb-3">
                    <div class="d-flex flex-column" style="gap: 6px;">
                      <base-input label="Date" style="margin-bottom: 0;">
                        <el-date-picker
                          v-model="editPaymentDateDate[row.index]"
                          type="date"
                          :format="date_format_cal"
                          value-format="yyyy-MM-dd"
                          placeholder="Date"
                          :clearable="false"
                          :picker-options="{ disabledDate: (date) => date > new Date(), firstDayOfWeek: first_day_of_week }"
                          @change="$set(editPaymentDateError, row.index, '')"
                        />
                      </base-input>
                      <base-input label="Time" style="margin-bottom: 0;">
                        <el-time-picker
                          v-model="editPaymentDateTime[row.index]"
                          :format="picker_time_format"
                          placeholder="HH:MM"
                          :clearable="false"
                          @change="$set(editPaymentDateError, row.index, '')"
                        />
                      </base-input>
                      <label v-if="editPaymentDateError[row.index]" class="error" style="color: #ec250d;">{{ editPaymentDateError[row.index] }}</label>
                      <div>
                        <base-button size="sm" simple type="primary"
                                     @click="$set(showEditPaymentDate, row.index, false)">
                          Cancel
                        </base-button>
                        <base-button size="sm" type="primary" class="ml-2"
                                     :disabled="!editPaymentDateDate[row.index] || !editPaymentDateTime[row.index] || editPaymentDateLoading"
                                     :loading="editPaymentDateLoading"
                                     @click="updatePaymentDate(row.item, row.index)">
                          Save
                        </base-button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <p>Amount: {{getAmount(row.item.amount - row.item.refunded)}}</p>
                    </div>
                    <div v-if="row.item.refunded > 0 && !refundBreakdownTrusted(row.item)" class="col text-center">
                      <p>Refunded: {{getAmount(row.item.refunded)}}</p>
                    </div>
                    <div v-if="refundBreakdownTrusted(row.item) && row.item.refunded > 0 && !row.item.refund_gift_card_code && (row.item.refunded - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id)) > 0" class="col text-center">
                      <p>Refunded to {{refundMethodLabel(row.item.type)}}: {{getAmount(row.item.refunded - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id))}}</p>
                    </div>
                    <div v-if="refundBreakdownTrusted(row.item) && row.item.refunded > 0 && row.item.refund_gift_card_code && (row.item.refunded - row.item.refund_gift_card_total - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id)) > 0" class="col text-center">
                      <p>Refunded to {{refundMethodLabel(row.item.type)}}: {{getAmount(row.item.refunded - row.item.refund_gift_card_total - getExternalRefundTotal(row.item.id) - getCustomerCreditRefundTotal(row.item.id))}}</p>
                    </div>
                    <div v-if="refundBreakdownTrusted(row.item) && getExternalRefundTotal(row.item.id) > 0" class="col text-center">
                      <p>Marked as refunded: {{getAmount(getExternalRefundTotal(row.item.id))}}</p>
                    </div>
                    <div v-if="refundBreakdownTrusted(row.item) && getCustomerCreditRefundTotal(row.item.id) > 0" class="col text-center">
                      <p>Refunded to store credit: {{getAmount(getCustomerCreditRefundTotal(row.item.id))}}</p>
                    </div>
                    <div v-if="refundBreakdownTrusted(row.item) && row.item.refund_gift_card_total > 0" class="col text-center">
                      <p>Refunded to gift card: {{getAmount(row.item.refund_gift_card_total)}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showRefund[row.index]">
                <div class="row mt-1">
                  <div class="col-12">
                    <base-input label="Refund options">
                      <el-select
                        v-model="selectedPaymentAmount"
                        v-on:change="toggleDisabledFlagForAmount(row.item)"
                        class="select-primary"
                        name="game"
                        placeholder="Refund option"
                        value-key="id"
                      >
                        <el-option
                          v-for="option in paymentAmountOptions"
                          class="select-primary"
                          :label="option.name"
                          :value="{id: option.id, name: option.name}"
                          :key="'B' + option.id"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col-12">
                    <base-input type="number" :disabled="isAmountFieldDisabled" :label="'Amount (' + currency_symbol + ')'" v-model="refundAmount">
                    </base-input>
                  </div>
                </div>
                <div v-if="selectedPaymentAmount.id === 3 && gift_card_types.length > 0" class="row mt-1">
                  <div class="col-12">
                    <base-input label="Gift card type">
                      <el-select
                        v-model="selectedRefundGiftCardType"
                        class="select-primary"
                        value-key="id"
                        placeholder="Select gift card type"
                      >
                        <el-option
                          v-for="(gct, index) in gift_card_types"
                          class="select-primary"
                          :label="gct.name"
                          :value="{ id: gct.id, name: gct.name }"
                          :key="'refund-gc-mob-' + index"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <base-button v-on:click="$set(showRefund, row.index, 0)" simple size="sm" type="primary">Cancel</base-button>
                    <base-button v-on:click="processRefund(row.item, row.index)" :disabled="loading" class="ml-2" size="sm" type="primary">
                      {{ selectedPaymentAmount.id === 3 ? 'Issue gift card' : 'Make refund' }}
                    </base-button>
                  </div>
                </div>
              </div>
            </template>
          </b-table>
        </div>



        <!--        Promotions-->
        <div v-if="activeTabIndex === 2" key="tab-2">
          <div class="row" v-if="!add_promo && !add_discount && transaction.status === 1">
            <div class="col">
              <el-dropdown placement="bottom-start">
                <base-button size="sm"
                             simple
                             type="success" class="mr-2"

                > Add discount <i class="tim-icons icon-minimal-down ml-1"></i>
                </base-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <a class="dropdown-item mb-2" href="#" @click.prevent="addPromoCode()">
                      <i class="tim-icons icon-tag mr-2 text-default"></i> Add promo code
                    </a>
                    <a class="dropdown-item mb-2" href="#" @click.prevent="addDiscount()">
                      <i class="tim-icons el-icon-minus mr-2 text-info"></i> Add discount
                    </a>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
          <div class="row" v-if="add_discount">
            <div class="col-lg-2">
              <base-input :label="'Discount amount (' + currency_symbol +')'"
                          :error="errs.discount_amount">
                <el-input-number placeholder="0.00" v-model="discount_amount" :controls="false" :precision="2" :step="0.1" />
              </base-input>
            </div>
          </div>
          <div class="row" v-if="add_discount">
            <div class="col-lg-4">
              <base-input label="Discount note">
                <el-input
                  v-model="discount_description"
                  :rows="3"
                  type="textarea"
                  placeholder="Add a note..."
                />
              </base-input>
            </div>
          </div>

          <div class="row" v-if="add_promo">
            <div class="col-lg-4">
              <base-input label="Promo" :error="errs.promo_code">
                <el-autocomplete style="width: 100%"
                                 v-model="promo_code"
                                 :fetch-suggestions="promoSearch"
                                 placeholder="Search by code..."
                                 :trigger-on-focus="false"
                                 @select="handlePromoSelect"
                >
                  <template #default="{ item }">
                    <div class="row">
                      <div class="col">
                        <div>
                          <span class="text-primary">{{ item.name }}</span>
                          <span v-if="!hasBuyXGetYRule(item.rules)"> - </span>
                          <small>
                            <template v-if="!hasBuyXGetYRule(item.rules)">
                              <span v-if="item.redemption_type === 0">{{item.value_amount}}%</span>
                              <span v-if="item.redemption_type === 1">{{getAmount(item.value_amount)}}</span>
                              <span v-if="item.value_type === 0"> per transaction</span>
                              <span v-if="item.value_type === 1"> per line item</span>
                              <span v-if="item.value_type === 2"> per quantity</span>
                            </template>
                            <span class="ml-2"
                                  style="text-transform: uppercase; line-height: 9px; text-decoration: none; border: none;
                                         color: white; background-color: #1d8cf8; border-radius: 2px; padding: 2px 5px 2px 5px; font-size: 9px"
                                  v-if="hasBuyXGetYRule(item.rules)">buy x get y</span>
                            <span class="ml-2"
                                  style="text-transform: uppercase; line-height: 9px; text-decoration: none; border: none;
                                         color: white; background-color: #344675; border-radius: 2px; padding: 2px 5px 2px 5px; font-size: 9px"
                                  v-if="item.internal_only">internal only</span>
                            <span class="ml-2"
                                  style="text-transform: uppercase; line-height: 9px; text-decoration: none; border: none;
                                         color: white; background-color: #00bf9a; border-radius: 2px; padding: 2px 5px 2px 5px; font-size: 9px"
                                  v-if="hasMinValueRule(item.rules)">value rule</span>
                            <span class="ml-2"
                                  style="text-transform: uppercase; line-height: 9px; text-decoration: none; border: none;
                                         color: white; background-color: #ff8d72; border-radius: 2px; padding: 2px 5px 2px 5px; font-size: 9px"
                                  v-if="hasBundlePriceRule(item.rules)">bundle price</span>
                          </small>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-autocomplete>
              </base-input>
            </div>
          </div>

          <div class="row" v-if="add_promo || add_discount">
            <div class="col">
              <base-button v-on:click="cancelDiscount()" type="default">Cancel</base-button>
              <base-button v-on:click="applyPromoCode()" class="ml-2" type="primary">Apply</base-button>
            </div>
          </div>

          <div v-if="(promos.length <= 0) && !add_promo && !add_discount" class="mt-3" >
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No promos have been applied.</h4>
            </div>
          </div>
          <div class="d-sm-block d-none">
            <b-table v-if="promos.length > 0 && !add_promo && !add_discount" :items="promos" :fields="['code', 'description', 'amount', 'date_applied', 'applied_by', 'applied_to', 'actions']">
              <template v-slot:cell(code)="row">
                <p v-if="row.item.hasOwnProperty('name')">{{ row.item.name }}</p>
              </template>
              <template v-slot:cell(description)="row">
                <span v-if="row.item.description">{{ row.item.description }}</span>
                <span v-if="row.item.design_url">
                <img style="object-fit: cover; height: 75px" :src="row.item.design_url"/>
              </span>
                <span v-if="!row.item.description && !row.item.design_url">-</span>
              </template>
              <template v-slot:cell(amount)="row">
                <span>{{ getAmount(row.item.display_amount != null ? row.item.display_amount : row.item.amount) }}</span>
              </template>
              <template v-slot:cell(date_applied)="row">
                <span>{{ getLocalDate(row.item.timestamp) }} {{ getLocalTime(row.item.timestamp) }}</span>
              </template>
              <template v-slot:cell(applied_by)="row">
                <span>{{ row.item.applied_by }}</span>
              </template>
              <template v-slot:cell(applied_to)="row">
                <badge type="default">{{ row.item.link_type.replace(/_/g, ' ') }}</badge>
                <div class="font-italic small" v-if="row.item.link_type !== 'transaction'">{{getLinkedItem(row.item)}}</div>
              </template>
              <template v-slot:cell(actions)="row">
                <el-tooltip content="Delete"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                  <base-button
                    type="danger"
                    class="btn btn-link"
                    aria-label="Close"
                    icon
                    v-if="!isReadOnly"
                    @click="deleteDiscountPrompt(row.item)"
                  >
                    <i class="tim-icons icon-trash-simple"></i>
                  </base-button>
                </el-tooltip>
              </template>
            </b-table>
          </div>
<!--          Mobile-->
          <div class="d-block d-sm-none">
            <b-table v-if="promos.length > 0 && !add_promo" :items="promos" :fields="['promo_codes']">
              <template v-slot:cell(promo_codes)="row">
                <div class="row">
                  <div class="col">
                    <p v-if="row.item.hasOwnProperty('name')">{{ row.item.name }}</p>
                    <small v-if="row.item.description">{{ row.item.description }}</small>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <span>Amount: {{ getAmount(row.item.display_amount != null ? row.item.display_amount : row.item.amount) }}</span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col">
                    <span>Date applied: {{ getLocalDate(row.item.timestamp) }} {{ getLocalTime(row.item.timestamp) }}</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <small>Applied to: <badge type="default" class="ml-1">{{ row.item.link_type.replace(/_/g, ' ') }}</badge>
                      <span class="font-italic small ml-1" v-if="row.item.link_type !== 'transaction'">{{getLinkedItem(row.item)}}</span>
                    </small>
                  </div>
                </div>

                <div
                  class="btn-group btn-group-toggle mt-3"
                  :class="'float-left'"
                  data-toggle="buttons" style="width:100%; max-width: 100%"
                >
                  <label
                         class="btn btn-sm btn-primary btn-simple">
                    <base-button style="padding-left: 0; padding-right: 0"
                                 v-if="!isReadOnly"
                                 @click.native="deleteDiscountPrompt(row.item)"
                                 type="primary"
                                 class="btn btn-link"
                                 size="sm"
                                 icon
                    ><i class="tim-icons icon-trash-simple"></i>
                    </base-button>
                  </label>
                </div>
              </template>
            </b-table>
          </div>
        </div>

<!--        Taxes/fees-->
        <div v-if="activeTabIndex === 3" key="tab-3">
          <div class="row" v-if="!add_fee && transaction.status === 1">
            <div class="col">
              <base-button v-on:click="addFee()" simple type="success" size="sm">
                <i class="tim-icons el-icon-plus"></i> Add tax, fee, or tip</base-button>
            </div>
          </div>
          <div class="row" v-if="add_fee">
            <div class="col">
              <div class="row">
                <div class="col-lg-2">
                  <base-input label="Type" >
                    <el-select
                      v-model="tax_fee_type"
                      class="select-primary"
                      name="bookings"
                      placeholder="Tax or fee"
                      value-key="id"
                    >
                      <el-option
                        v-for="(tft, i) in tax_fee_types"
                        class="select-primary"
                        :label="tft.name"
                        :value="{id: tft.id, name: tft.name}"
                        :key="'TFT' + i"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>

                <div class="col-lg-3" v-if="tax_fee_type && tax_fee_type.id === 0">
                  <base-input label="Taxes" :error="errs.tax">
                    <el-select
                      v-model="selectedTax"
                      class="select-primary"
                      name="bookings"
                      placeholder="Tax"
                      value-key="id"
                    >
                      <el-option
                        v-for="(t, i) in taxes"
                        class="select-primary"
                        :label="t.name"
                        :value="{id: t.id, name: t.name, amount: t.amount, apply_to_all_items: t.apply_to_all_items,
                        linked_items: t.linked_items, linked_games: t.linked_games,
                        apply_after_discount: t.apply_after_discount,
                        is_compound: t.is_compound, value_type: t.value_type, pricing_type: t.pricing_type}"
                        :key="'T' + i"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col-lg-3" v-if="tax_fee_type && tax_fee_type.id === 1">
                  <base-input label="Fees" :error="errs.fee">
                    <el-select
                      v-model="selectedFee"
                      class="select-primary"
                      name="bookings"
                      placeholder="Fee"
                      value-key="id"
                    >
                      <el-option
                        v-for="(f, i) in fees"
                        class="select-primary"
                        :label="f.name"
                        :value="{id: f.id, name: f.name, amount: f.amount, total_amount: f.total_amount,
                        value_type: f.value_type,  apply_to_all_items: f.apply_to_all_items,
                        linked_items: f.linked_items, linked_games: f.linked_games,
                        linked_gift_card_types: f.linked_gift_card_types,
                        covered_by_promo_codes: f.covered_by_promo_codes,
                        apply_fee_to_gift_cards: f.apply_fee_to_gift_cards }"
                        :key="'F' + i"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
<!--                Tip-->
                <div class="col-lg-2" v-if="tax_fee_type && tax_fee_type.id === 2">
                  <base-input :error="errs.tip_amount" placeholder="0" :label="'Tip amount (' + currency_symbol + ')'" v-model.number="tip_amount"></base-input>
                </div>
                <div class="col-lg-3" v-if="tax_fee_type && tax_fee_type.id === 2">
                  <base-input label="Assignee (optional)">
                    <el-autocomplete style="width: 100%"
                                     v-model="company_user_value"
                                     :fetch-suggestions="querySearchCu"
                                     placeholder="Search"
                                     :trigger-on-focus="false"
                                     @select="handleSelectCu"
                    >
                      <template #default="{ item }">
                        <p style="margin-bottom: -12px" class="text-primary">{{ item.first_name }} {{ item.last_name }}</p>
                        <small class="font-italic">
                          <i class="tim-icons icon-email-85"></i> {{item.email }} &nbsp;
                        </small>
                      </template>
                    </el-autocomplete>
                  </base-input>
                </div>
                <div class="col-lg-2" v-if="tax_fee_type && tax_fee_type.id === 0">
                  <label>Amount ({{currency_symbol}})</label>
                  <h4>{{getAmount(getTaxAmount())}}</h4>
                </div>
                <div class="col-lg-2" v-if="tax_fee_type && tax_fee_type.id === 1">
                  <label>Amount ({{currency_symbol}})</label>
                  <h4>{{getAmount(getFeeAmount())}}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-button v-on:click="add_fee = false" type="default">Cancel</base-button>
                  <base-button v-on:click="applyTax()" class="ml-2" type="primary">Apply</base-button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="taxes_fees.length <= 0 && !add_fee" class="mt-3" >
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No taxes or fees have been applied.</h4>
            </div>
          </div>
          <div class="d-sm-block d-none">
            <b-table v-if="taxes_fees.length > 0 && !add_fee" :items="taxes_fees" :fields="['name', 'type', 'amount', 'date_applied', 'applied_by', 'applied_to', 'actions']">
              <template v-slot:cell(name)="row">
                <div>{{ row.item.name || 'Generic' }}</div>
                <small v-if="row.item.email" class="font-italic d-block">{{ row.item.first_name }} {{ row.item.last_name }}</small>
              </template>
              <template v-slot:cell(type)="row">
                <span v-if="row.item.hasOwnProperty('email')"><badge type="info">tip</badge> </span>
                <span v-if="row.item.tax_id"><badge type="success">tax</badge> </span>
                <span v-if="row.item.fee_id"><badge type="warning">fee</badge> </span>
              </template>
              <template v-slot:cell(amount)="row">
                <span>{{ getAmount(row.item.amount) }}</span>
              </template>
              <template v-slot:cell(date_applied)="row">
                <span>{{ getLocalDate(row.item.timestamp) }} {{ getLocalTime(row.item.timestamp) }}</span>
              </template>
              <template v-slot:cell(applied_by)="row">
                <span>{{ row.item.applied_by }}</span>
              </template>
              <template v-slot:cell(applied_to)="row">
                <badge type="default">{{ row.item.link_type.replace(/_/g, ' ') }}</badge>
                <div class="font-italic small" v-if="row.item.link_type !== 'transaction'">{{getLinkedItem(row.item)}}</div>
              </template>
              <template v-slot:cell(actions)="row">
                <el-tooltip content="Delete"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                  <base-button
                    type="danger"
                    class="btn btn-link"
                    aria-label="Close"
                    icon
                    v-if="!isReadOnly"
                    @click="deleteTaxFeePrompt(row.item)"
                  >
                    <i class="tim-icons icon-trash-simple"></i>
                  </base-button>
                </el-tooltip>
              </template>
            </b-table>
          </div>
<!--          Mobile-->
          <div class="d-block d-sm-none">
            <b-table v-if="taxes_fees.length > 0 && !add_fee" :items="taxes_fees" :fields="['taxes_and_fees']">
              <template v-slot:cell(taxes_and_fees)="row">
                <div class="row">
                  <div class="col">
                    <span>{{ row.item.name }}</span>
                  </div>
                  <div class="col text-right">
                    <span v-if="row.item.tax_id"><badge type="success">tax</badge> </span>
                    <span v-if="row.item.fee_id"><badge type="warning">fee</badge> </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <small>Amount: {{ getAmount(row.item.amount) }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <small>Date applied: {{ getLocalDate(row.item.timestamp) }} {{ getLocalTime(row.item.timestamp) }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <small>Applied to: <badge type="default" class="ml-1">{{ row.item.link_type.replace(/_/g, ' ') }}</badge>
                      <span class="font-italic small ml-1" v-if="row.item.link_type !== 'transaction'">{{getLinkedItem(row.item)}}</span>
                    </small>
                  </div>
                </div>
                <div
                  class="btn-group btn-group-toggle mt-3"
                  :class="'float-left'"
                  data-toggle="buttons" style="width:100%; max-width: 100%"
                >
                  <label
                    class="btn btn-sm btn-primary btn-simple">
                    <base-button style="padding-left: 0; padding-right: 0"
                                 v-if="!isReadOnly"
                                 @click.native="deleteTaxFeePrompt(row.item)"
                                 type="primary"
                                 class="btn btn-link"
                                 size="sm"
                                 icon
                    ><i class="tim-icons icon-trash-simple"></i>
                    </base-button>
                  </label>
                </div>
              </template>
            </b-table>
          </div>
          <div class="waive-toggle-row mt-3">
            <el-switch
              :value="Number(transaction.waive_taxes) === 1"
              @change="onWaiveToggle('waive_taxes', $event)"
              :disabled="waiveLoading || isReadOnly"
              active-color="#e14eca" />
            <span class="ml-2 text-white">Waive taxes</span>
            <el-switch
              class="ml-4"
              :value="Number(transaction.waive_fees) === 1"
              @change="onWaiveToggle('waive_fees', $event)"
              :disabled="waiveLoading || isReadOnly"
              active-color="#e14eca" />
            <span class="ml-2 text-white">Waive fees</span>
          </div>
        </div>


<!--        Customers-->
        <div v-if="activeTabIndex === 4" class="mt-3" key="tab-4" style="max-width: 720px;">
          <!-- OTC-3142: read only first. Edit details opens the form; Change customer opens the
               lookup, and a pick fills the form so the same Save links the new customer. -->
          <template v-if="customerTabMode === 'view' || isReadOnly">
            <template v-if="transaction.end_user_id || transaction.first_name || transaction.email">
              <!-- Columns size to their content so an email never breaks mid-address; a value
                   too long for the line moves to the next line instead. -->
              <div class="d-flex flex-wrap mb-3" style="column-gap: 48px; row-gap: 12px;">
                <div>
                  <label class="mb-1">Name</label>
                  <p class="text-white mb-0" style="font-size: 1rem; font-weight: 500;">
                    {{ transaction.first_name }} {{ transaction.last_name }}
                  </p>
                  <router-link
                    v-if="transaction.end_user_id"
                    :to="'/customers/details?id=' + transaction.end_user_id"
                    custom
                    v-slot="{ href }"
                  >
                    <a :href="href" target="_blank" rel="noopener" class="text-primary" style="font-size: 0.8125rem;">
                      View profile <i class="tim-icons el-icon-top-right" style="font-size: 10px;"></i>
                    </a>
                  </router-link>
                </div>
                <div style="min-width: 0; max-width: 100%;">
                  <label class="mb-1">Email</label>
                  <p class="text-white mb-0 text-break" style="font-size: 1rem; font-weight: 500;">{{ transaction.email || '-' }}</p>
                </div>
                <div>
                  <label class="mb-1">Phone</label>
                  <p class="text-white mb-0" style="font-size: 1rem; font-weight: 500;">{{ transaction.phone ? formatPhone(transaction?.country, transaction.phone) : '-' }}</p>
                </div>
              </div>
              <div v-if="!isReadOnly" class="d-flex flex-wrap" style="gap: 8px;">
                <base-button variant="outlined" tone="primary" @click="openCustomerTab('edit')">
                  <i class="tim-icons icon-pencil"></i> Edit details
                </base-button>
                <base-button variant="outlined" tone="primary" @click="openCustomerTab('change')">
                  <i class="tim-icons icon-refresh-02"></i> Change customer
                </base-button>
              </div>
            </template>
            <template v-else>
              <p class="text-white mb-3">No customer on this order yet.</p>
              <div v-if="!isReadOnly" class="d-flex flex-wrap" style="gap: 8px;">
                <base-button variant="outlined" tone="primary" @click="openCustomerTab('change')">
                  <i class="tim-icons icon-simple-add"></i> Add customer
                </base-button>
                <base-button variant="outlined" tone="primary" @click="openCustomerTab('edit')">
                  <i class="tim-icons icon-pencil"></i> Enter details
                </base-button>
              </div>
            </template>
          </template>

          <template v-else-if="customerTabMode === 'change'">
            <div class="row">
              <div class="col-md-6 col-12">
                <base-input label="Find an existing customer">
                  <el-autocomplete style="width: 100%"
                                   v-model="lookup_value"
                                   :fetch-suggestions="querySearch"
                                   placeholder="Search by name, email, or phone"
                                   prefix-icon="el-icon-search"
                                   clearable
                                   :trigger-on-focus="false"
                                   @select="onCustomerLookupSelect"
                  >
                    <template #default="{ item }">
                      <p style="margin-bottom: -12px" class="text-primary">{{ item.first_name }} {{ item.last_name }}</p>
                      <small class="font-italic">
                        <i class="tim-icons icon-email-85"></i> {{item.email }} &nbsp;
                        <i v-if="item.phone" class="tim-icons el-icon-mobile-phone"></i> {{item.phone }}
                      </small>
                    </template>
                  </el-autocomplete>
                </base-input>
              </div>
            </div>
            <base-button size="sm" link class="m-0 px-0 text-white" style="font-size: 12px;" @click="cancelCustomerTab()">Cancel</base-button>
          </template>

          <template v-else>
            <div class="row">
              <div class="col-md-6 col-12">
                <base-input
                  label="First name *"
                  v-model="customer.first_name"
                  placeholder="First name"
                  :error="errs.first_name"
                ></base-input>
              </div>
              <div class="col-md-6 col-12">
                <base-input
                  label="Last name *"
                  v-model="customer.last_name"
                  placeholder="Last name"
                  :error="errs.last_name"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <base-input
                  label="Email *"
                  v-model="customer.email"
                  placeholder="Email"
                  :error="errs.email"
                ></base-input>
              </div>
              <div class="col-md-6 col-12">
                <base-input
                  type="text"
                  :label="isPhoneRequired() ? 'Phone *' : 'Phone (optional)'"
                  :error="errs.phone">
                  <phone-number-input ref="phoneInput"
                                      v-model="customer.phone" @phone-update="handlePhoneUpdate"
                                      :default-country="countryCode || 'US'"
                  />
                </base-input>
              </div>
            </div>
            <!-- Small primary is sized like the pills globally (_buttons.scss); Cancel is a quiet text button. -->
            <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
              <base-button size="sm" type="primary" class="m-0" @click="updateCustomer()">Save customer</base-button>
              <base-button size="sm" link class="m-0 text-white" style="font-size: 12px;" @click="cancelCustomerTab()">Cancel</base-button>
            </div>
          </template>
        </div>

<!--        Waivers-->
        <div v-if="activeTabIndex === 5 && shareableWaiverEnabled" key="tab-5-share">
          <base-button size="sm" type="primary" @click="copyWaiverLink">
            <i class="tim-icons icon-link-72 mr-1 text-white"></i> Copy waiver link
          </base-button>
        </div>
        <div v-if="activeTabIndex === 5" :class="shareableWaiverEnabled ? 'mt-2' : 'mt-3'" key="tab-5-waivers">
          <data-table
            :columns="waiverColumns"
            :rows="waivers || []"
            row-key="id"
            :clickable="hasPermissions('waivers_update')"
            @row-click="openWaiverDrawer">
            <template #cell(customer_details)="{ row }">
              <span class="data-table__primary">{{ row.first_name }} {{ row.last_name }}</span>
              <badge v-if="row.is_minor" type="primary" class="ml-2">minor</badge>
              <badge v-if="Number(row.not_participating) === 1" type="danger" class="ml-2">not participating</badge>
              <el-tooltip content="View customer details" effect="light" :open-delay="300" placement="right">
                <i class="tim-icons el-icon-top-right text-primary ml-1" style="cursor: pointer" @click.stop="viewCustomerDetails(row.user_id)"></i>
              </el-tooltip>
              <div v-if="row.email" class="data-table__muted">{{ row.email }}</div>
              <div v-if="row.phone" class="data-table__muted">{{ row.phone }}</div>
              <div v-if="row.birthday && row.birthday !== '0000-00-00'" class="data-table__muted">
                <i class="tim-icons icon-gift-2"></i> {{ getFormattedDate(row.birthday) }}
              </div>
            </template>
            <template #cell(booking_details)="{ row }">
              <span>{{ row.game_name }}</span>
              <div v-if="row.booking_date" class="data-table__muted">
                {{ getDayOfWeek(row.booking_date) }}{{ getFormattedDate(row.booking_date) }}<span v-if="getTime(row.start_time)">, {{ getTime(row.start_time) }}</span>
              </div>
            </template>
            <template #cell(date_signed)="{ row }">
              <span>{{ getLocalDate(row.created_time) }}, {{ getLocalTime(row.created_time) }}</span>
            </template>
            <template #cell(signature)="{ row }">
              <waiver-signature
                size="cell"
                :waiver-id="row.id"
                :signature="row.signature"
                :has-signature="!!row.has_signature"
                :not-participating="Number(row.not_participating) === 1"
              />
            </template>
            <template #actions="{ row }">
              <el-tooltip content="Download PDF" effect="light" :open-delay="300" placement="top">
                <base-button
                  icon
                  class="btn-link text-white m-0"
                  :disabled="pdfGeneratingId !== null"
                  @click="downloadWaiver(row)">
                  <i :class="pdfGeneratingId === row.id ? 'el-icon-loading' : 'tim-icons icon-cloud-download-93'"></i>
                </base-button>
              </el-tooltip>
            </template>
            <template #empty>
              <img class="empty-state-img empty-state-img--md mb-3" src="/img/pandas/waiver.png" alt="" />
              <h4 class="mb-0 text-white">No waivers signed</h4>
            </template>
          </data-table>
          <waiver-drawer
            :read-only="isReadOnly"
            :show="waiverDrawer.show"
            :waiver="waiverDrawer.waiver"
            @close="waiverDrawer.show = false"
            @changed="onWaiverChanged"
            @deleted="getTransaction(true)" />
        </div>
        <!-- Off-screen branded PDF renderer; generate() is called from Download PDF -->
        <waiver-pdf-document ref="waiverPdf" />

<!--        Custom fields-->
        <div v-if="activeTabIndex === 6 && custom_fields.length <= 0" class="mt-3" key="tab-6-empty" >
          <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            <h4 class="mt-3">No additional information has been recorded for this transaction.</h4>
          </div>
        </div>
        <div  v-if="activeTabIndex === 6 && custom_fields.length > 0" class="d-sm-block d-none" key="tab-6-desktop">
          <b-table  :items="custom_fields"
                    :fields="['custom_field', 'response', 'source', 'timestamp']">
            <template v-slot:cell(custom_field)="row">
              {{row.item.label}}
              <span  v-if="row.item.type === 1">
                <span v-if="row.item.external_links" v-for="(el, i) in JSON.parse(row.item.external_links)" :key="'ELI' + i">
                  <a target="_blank" :href="el.link">{{el.link_text}}</a>
                </span>
                <span v-if="row.item.policies" v-for="(p, i) in JSON.parse(row.item.policies)" :key="'PLI' + i">
                  <base-button style="color: #ba54f5; font-weight:300; font-size: small; padding: 0"
                               size="sm" link class="btn btn-link" href="" v-on:click="openPolicy(p)">{{p.policy_link_text}}</base-button>
                </span>
                      <modal :show.sync="modals.policy"
                             body-classes="p-0"
                             modal-classes="modal-dialog-centered">
                        <card type="secondary"
                              header-classes="bg-white pb-5"
                              body-classes="px-lg-4 py-lg-4s"
                              class="border-0 mb-0">

                          <p class="text-white" v-html="selectedPolicy"></p>
                          <div class="row mt-3 justify-content-center">
                            <div class="col text-center">
                              <base-button v-on:click="modals.policy = false" type="primary">I agree</base-button>
                            </div>
                          </div>
                        </card>
                      </modal>
              </span>
            </template>
            <template v-slot:cell(response)="row">
              <span v-if="row.item.type === 1">{{ (row.item.response === '1' || row.item.response === 1) ? 'Yes' : 'No' }}</span>
              <span v-else>{{formatFieldResponse(row.item)}}</span>
            </template>
            <template v-slot:cell(source)="row">
              <custom-field-source-badge :source="row.item.source" />
            </template>
            <template v-slot:cell(timestamp)="row">
              {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}
            </template>
          </b-table>
        </div>
        <div class="d-sm-none d-block"  v-if="activeTabIndex === 6 && custom_fields.length > 0" key="tab-6-mobile">
          <b-table :items="custom_fields"
                   :fields="['custom_field']">
            <template v-slot:cell(custom_field)="row">
              <p class="text-primary">{{row.item.label}}</p>
              <p v-if="row.item.type === 1">{{ (row.item.response === '1' || row.item.response === 1) ? 'Yes' : 'No' }}</p>
              <p v-else>{{formatFieldResponse(row.item)}}</p>
              <custom-field-source-badge :source="row.item.source" />
              <small style="font-style: italic; display: block; margin-top: 4px;">{{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
            </template>
          </b-table>
        </div>

<!--        Email events-->
        <div v-if="activeTabIndex === 7" key="tab-7">
          <div>
            <base-button v-if="!isReadOnly" size="sm" type="primary" @click="sendEmailDrawerOpen = true">
              <i class="tim-icons icon-send mr-1 text-white"></i> Send an email
            </base-button>
            <base-button class="text-white ml-2" style="padding-left: 0" link v-on:click="getTransaction()">
              <i class="tim-icons icon-refresh-01 mr-1 text-white"></i> Refresh
            </base-button>
          </div>

          <div v-if="email_events.length <= 0">
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No emails associated with this transaction.</h4>
            </div>
          </div>
<!--          Mobile-->
          <div v-if="email_events.length > 0" class="d-sm-none d-block">
            <b-table :items="email_events" :fields="['email_event']">
              <template v-slot:cell(email_event)="row">
                <div class="row">
                  <div class="col">
                    <p style="font-weight: bold; font-size: medium">{{capitalizeFirstLetter(row.item.email_type)}}</p>
                  </div>
                  <div class="col text-right">
                    <badge v-if="row.item.event_type==='Open' || row.item.event_type==='Click' || row.item.event_type==='Subscription'" type="success">{{row.item.event_type}}</badge>
                    <badge v-if="row.item.event_type==='Bounce' || row.item.event_type==='Complaint' || row.item.event_type==='Reject'
                      || row.item.event_type==='Rendering Failure' || row.item.event_type==='DeliveryDelay'"
                           type="danger">{{row.item.event_type}}</badge>
                    <badge v-if="row.item.event_type==='Delivery' || row.item.event_type==='Send'" type="default">{{row.item.event_type}}</badge>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <small style="font-style: italic">{{getLocalDate(row.item.timestamp)}}, {{ getLocalTime(row.item.timestamp)}}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    Recipient: {{row.item.customer_first_name}} {{row.item.customer_last_name}}
                  </div>
                </div>
                <div class="row" v-if="row.item.sender_email">
                  <div class="col">
                    Sender: {{row.item.sender_first_name}} {{row.item.sender_last_name}}
                  </div>
                </div>
              </template>
            </b-table>
          </div>
          <div v-if="email_events.length > 0" class="d-sm-block d-none">
            <b-table :items="email_events" :fields="['email_type', 'email_status', 'time_of_event', 'recipient', 'sender']">
              <template v-slot:cell(email_type)="row">
                {{capitalizeFirstLetter(row.item.email_type)}}
              </template>
              <template v-slot:cell(email_status)="row">
                <badge v-if="row.item.event_type==='Open' || row.item.event_type==='Click' || row.item.event_type==='Subscription'" type="success">{{row.item.event_type}}</badge>
                <badge v-if="row.item.event_type==='Bounce' || row.item.event_type==='Complaint' || row.item.event_type==='Reject'
                      || row.item.event_type==='Rendering Failure' || row.item.event_type==='DeliveryDelay'"
                       type="danger">{{row.item.event_type}}</badge>
                <badge v-if="row.item.event_type==='Delivery' || row.item.event_type==='Send'" type="default">{{row.item.event_type}}</badge>
              </template>
              <template v-slot:cell(time_of_event)="row">
                {{getLocalDate(row.item.timestamp)}}, {{ getLocalTime(row.item.timestamp)}}
              </template>
              <template v-slot:cell(recipient)="row">
                <div>{{row.item.customer_first_name}} {{row.item.customer_last_name}}</div>
                <small> <i class="tim-icons icon-email-85 ml-1"></i> {{row.item.customer_email}}</small>
              </template>
              <template v-slot:cell(sender)="row">
                <div v-if="row.item.sender_email">
                  <div>{{row.item.sender_first_name}} {{row.item.sender_last_name}}</div>
                  <small><i class="tim-icons icon-email-85 ml-1"></i>  {{row.item.sender_email}}</small>
                </div>
                <div v-else>System</div>
              </template>
            </b-table>
          </div>

        </div>
      </card>
    </div>
  </div>
  <div class="d-sm-block d-none">
    <div class="row">
      <div class="col-lg-5">
        <!--      <card>-->
        <div v-if="activity.length > 0">
          <h4 slot="header" class="card-title">Activity</h4>
          <div style="overflow-y: scroll; overflow-x: hidden; height: 650px; max-height: 650px;">
            <div class="row">
              <div class="col ml-2 mr-2">
                <time-line type="simple">
                  <time-line-item v-for="(a, i) in activity" :key="'A' + i"
                                  inverted
                                  badge-type="success"
                                  :badge-text="getInitials(a)"

                  >
                    <p slot="content">

                    <span v-if="a.company_user_id">
                      {{a.company_user_first_name}} {{a.company_user_last_name}}
                    </span>
                    <span v-if="a.user_id">
                      {{a.first_name}} {{a.last_name}}
                    </span>
                      <span v-if="!a.user_id && !a.company_user_id">
                      System User
                    </span>
                      {{ a.description }}{{ a.description && a.description.endsWith('.') ? '' : '.' }}
                    </p>

                    <h6 slot="footer" class="text-white">
                      <i class="ti-time"></i> {{ getLocalDate(a.timestamp)}}, {{ getLocalTime(a.timestamp)}}
                    </h6>
                  </time-line-item>
                </time-line>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activity.length > 0" class="mt-5 mb-5">

        </div>
      </div>
      <div class="col-lg-7">
        <card>
          <div class="row mb-3">
            <div class="col">
              <tab-rail
                :tabs="noteCategories"
                :value="activeTabNotesIndex"
                @input="switchTabNotes"
              />
            </div>
          </div>
          <div style="overflow-y: scroll; overflow-x: hidden; max-height: 250px;">
            <div v-if="activeTabNotesIndex === 0 || activeTabNotesIndex === 1" class="row" v-for="(n, i) in notes" :key="'N' + i">
              <div class="col mt-2">
                <base-alert type="white" style="margin-bottom: -5px;">
                  <div class="row" >
                    <div class="col text-black-50">
                      <base-button
                        type="danger"
                        class="closed btn btn-link"
                        aria-label="Close"
                        icon
                        v-if="!isReadOnly"
                        @click="deleteNote(n.id)"
                      >
                        <i class="tim-icons icon-trash-simple"></i>
                      </base-button>
                      <badge type="success">Transaction #{{ transaction.order_number }}</badge>
                    </div>
                  </div>
                  <div class="row" >
                    <div class="col text-black-50">
                      {{n.note}}
                    </div>
                  </div>
                </base-alert>
                <div class="mt-1">
                  <small class="font-italic text-white">{{getLocalDate(n.timestamp)}}, {{getLocalTime(n.timestamp)}}, {{n.first_name}} {{n.last_name}}
                  </small>
                </div>
              </div>
            </div>

            <div v-if="activeTabNotesIndex === 0 || activeTabNotesIndex === 2" class="row" v-for="(bn, i) in booking_notes" :key="'BN' + i">
              <div class="col mt-2">
                <base-alert type="white" style="margin-bottom: -5px;">
                  <div class="row" >
                    <div class="col text-black-50">
                      <base-button
                        type="danger"
                        class="closed btn btn-link"
                        aria-label="Close"
                        icon
                        v-if="!isReadOnly"
                        @click="deleteBookingNote(bn.booking_slot_id, bn.id)"
                      >
                        <i class="tim-icons icon-trash-simple"></i>
                      </base-button>
                      <badge type="warning">Booking #{{ bn.booking_slot_id }}</badge>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-black-50">
                      {{bn.note}}
                    </div>
                  </div>
                </base-alert>
                <div class="mt-1">
                  <small class="font-italic text-white">{{getLocalDate(bn.timestamp)}}, {{getLocalTime(bn.timestamp)}}, {{bn.first_name}} {{bn.last_name}}
                  </small>
                </div>
              </div>
            </div>

          </div>

          <div class="row justify-content-center mt-4">
            <div class="col">
              <base-input label="Add a new note">
                <el-input
                  v-model="note"
                  :rows="5"
                  type="textarea"
                  placeholder="Notes..."
                />
              </base-input>
            </div>
          </div>

          <label>Note for:</label>
          <div class="row">
            <div class="col">
              <base-radio v-model="note_type" name="transaction">Transaction #{{transaction.order_number}}</base-radio>
            </div>
          </div>
          <div class="row" v-for="(b, i) in bookings" :key="i+'NB'">
            <div class="col">
              <base-radio v-model="note_type" :name="b.id">Booking #{{b.master_slot_id ? b.master_slot_id : b.id}}</base-radio>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <base-button v-if="!isReadOnly" type="primary" @click="addNewComment()">Create note</base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>

  <div class="d-sm-none d-block">
    <div class="row">
      <div class="col-12">
        <card>
          <div class="row mb-3">
            <div class="col">
              <tab-rail
                :tabs="noteCategories"
                :value="activeTabNotesIndex"
                @input="switchTabNotes"
              />
            </div>
          </div>
          <div style="overflow-y: scroll; overflow-x: hidden; max-height: 250px;">
            <div v-if="activeTabNotesIndex === 0 || activeTabNotesIndex === 1" class="row" v-for="(n, i) in notes" :key="'N' + i">
              <div class="col mt-2">
                <base-alert type="white" style="margin-bottom: -5px;">
                  <div class="row" >
                    <div class="col text-black-50">
                      <base-button
                        type="danger"
                        class="closed btn btn-link"
                        aria-label="Close"
                        icon
                        v-if="!isReadOnly"
                        @click="deleteNote(n.id)"
                      >
                        <i class="tim-icons icon-trash-simple"></i>
                      </base-button>
                      <badge type="success">Transaction #{{ transaction.order_number }}</badge>
                    </div>
                  </div>
                  <div class="row" >
                    <div class="col text-black-50">
                      {{n.note}}
                    </div>
                  </div>
                </base-alert>
                <div class="mt-1">
                  <small class="font-italic">{{getLocalDate(n.timestamp)}}, {{getLocalTime(n.timestamp)}}, {{n.first_name}} {{n.last_name}}
                  </small>
                </div>
              </div>
            </div>

            <div v-if="activeTabNotesIndex === 0 || activeTabNotesIndex === 2" class="row" v-for="(bn, i) in booking_notes" :key="'BN' + i">
              <div class="col mt-2">
                <base-alert type="white" style="margin-bottom: -5px;">
                  <div class="row" >
                    <div class="col text-black-50">
                      <base-button
                        type="danger"
                        class="closed btn btn-link"
                        aria-label="Close"
                        icon
                        v-if="!isReadOnly"
                        @click="deleteBookingNote(bn.booking_slot_id, bn.id)"
                      >
                        <i class="tim-icons icon-trash-simple"></i>
                      </base-button>
                      <badge type="warning">Booking #{{ bn.booking_slot_id }}</badge>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-black-50">
                      {{bn.note}}
                    </div>
                  </div>
                </base-alert>
                <div class="mt-1">
                  <small class="font-italic">{{getLocalDate(bn.timestamp)}}, {{getLocalTime(bn.timestamp)}}, {{bn.first_name}} {{bn.last_name}}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-4">
            <div class="col">
              <base-input label="Add a new note">
                <el-input
                  v-model="note"
                  :rows="5"
                  type="textarea"
                  placeholder="Notes..."
                />
              </base-input>
            </div>
          </div>

          <label>Note for:</label>
          <div class="row">
            <div class="col">
              <base-radio v-model="note_type" name="transaction">Transaction #{{transaction.order_number}}</base-radio>
            </div>
          </div>
          <div class="row" v-for="(b, i) in bookings" :key="i+'NB'">
            <div class="col">
              <base-radio v-model="note_type" :name="b.id">Booking #{{b.id}}</base-radio>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <base-button v-if="!isReadOnly" type="primary" @click="addNewComment()">Create note</base-button>
            </div>
          </div>
        </card>
      </div>
      <div class="col-12">
        <!--      <card>-->
        <div v-if="activity.length > 0">
          <h4 slot="header" class="card-title">Activity</h4>
          <div>
            <div class="row">
              <div class="col ml-2 mr-2">

                <time-line type="simple">
                  <time-line-item v-for="(a, i) in activity" :key="'A' + i"
                                  inverted
                                  badge-type="success"
                                  :badge-text="getInitials(a)"

                  >
                    <p slot="content">
                  <span v-if="a.company_user_first_name || a.company_user_last_name">
                    {{a.company_user_first_name}} {{a.company_user_last_name}}
                  </span>
                      <span v-if="a.first_name || a.last_name">
                    {{a.first_name}} {{a.last_name}}
                  </span>
                      {{ a.description }}{{ a.description && a.description.endsWith('.') ? '' : '.' }}
                    </p>

                    <h6 slot="footer">
                      <i class="ti-time"></i> {{ getLocalDate(a.timestamp)}}, {{ getLocalTime(a.timestamp)}}
                    </h6>
                  </time-line-item>
                </time-line>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activity.length > 0" class="mt-5 mb-5">

        </div>

      </div>
    </div>
  </div>
  </template>

  <!--    Not found-->
  <card v-else-if="notFound">
    <div class="empty-state">
      <div class="empty-state__icon"><i class="tim-icons icon-alert-circle-exc"></i></div>
      <h3 class="empty-state__title">
        {{ notFoundOrderNumber ? 'Transaction #' + notFoundOrderNumber + ' not found' : 'Transaction not found' }}
      </h3>
      <p v-if="otherGroup" class="empty-state__hint">This transaction belongs to {{ otherGroup.name }}.</p>
      <p v-else class="empty-state__hint">
        This transaction does not exist in this group. If it belongs to another group, switch groups in the top bar.
      </p>
      <div class="empty-state__actions">
        <base-button v-if="otherGroup" type="primary" size="sm" :loading="switchingGroup" @click="switchToGroup(otherGroup)">
          Switch to {{ otherGroup.name }}
        </base-button>
        <base-button variant="outlined" tone="primary" size="sm" @click="$router.push('/purchases/transactions?count=10&page=1')">
          {{ currentGroupName ? 'View all transactions on ' + currentGroupName : 'View all transactions' }}
        </base-button>
      </div>
    </div>
  </card>

  <!--    Cancel booking Modal-->
  <modal :show.sync="modals.cancel_booking"
         body-classes="p-0"
         modal-classes="modal-dialog-centered">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <h4 class="card-title" v-if="selectedBookingSlot.master_slot_id === null">Cancel booking #{{selectedBookingSlot.id}}</h4>
      <h4 class="card-title" v-else>Partially cancel booking #{{selectedBookingSlot.master_slot_id}}</h4>
      <base-alert type="danger" v-if="selectedBookingSlot.master_slot_id === null">
        <i class="tim-icons icon-alert-circle-exc"></i>
        Cancelling this booking will result in the time slot becoming available to book. Any amount paid will need to be manually refunded to the customer.
      </base-alert>

      <base-alert type="danger" v-else>
        <i class="tim-icons icon-alert-circle-exc"></i>
        Booking will only cancel for selected group. Other groups will still retain the booking.
        Any amount paid will need to be manually refunded to the cancelled group.
      </base-alert>

      <div class="row" v-if="selectedBookingSlot.master_slot_id === null">
        <div class="col">
          <base-input label="Select status for the freed up time slot">
            <el-select
              label="Select status"
              v-model="selectedCancellationStatus"
              class="select-primary"
              value-key="id"
              placeholder="Status">
              <el-option
                v-for="(status, index) in slot_statuses"
                class="select-primary"
                :label="status.label"
                :value="{id: status.id, label: status.label, status: status.status}"
                :key="'CSTATUS' + index"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>

      <div class="row mt-3" v-if="waiverCount > 0 && selectedBookingSlot.master_slot_id === null">
        <div class="col">
          <label class="mb-2">This booking has {{waiverCount}} waiver(s) attached</label>
          <el-radio-group v-model="deleteWaivers" class="waiver-options">
            <div class="waiver-option" :class="{ 'selected': deleteWaivers === 'keep' }" @click="deleteWaivers = 'keep'">
              <el-radio label="keep">Keep waivers on file</el-radio>
              <small class="d-block mt-1">Waivers remain attached to this time slot. Future bookings will inherit them.</small>
            </div>
            <div class="waiver-option" :class="{ 'selected': deleteWaivers === 'delete' }" @click="deleteWaivers = 'delete'">
              <el-radio label="delete">Delete waivers</el-radio>
              <small class="d-block mt-1">Waivers will be permanently removed. The time slot will be clean for new bookings.</small>
            </div>
          </el-radio-group>
        </div>
      </div>

      <div class="row justify-content-center mt-3">
        <base-button type="secondary" @click="modals.cancel_booking = false">Cancel</base-button>
        <base-button class="ml-3" type="primary" @click="cancelBooking(selectedBookingSlot, selectedCancellationStatus.status)">Cancel booking</base-button>
      </div>
    </card>
  </modal>

  <cancel-transaction-drawer
    :show="cancelDrawerOpen"
    :transaction-id="transaction.id"
    @close="cancelDrawerOpen = false"
    @cancelled="getTransaction()"
  />

<!--  Add gift card-->
  <modal :show.sync="modals.add_gift_card"
         @close="resetGiftCardModal"
         body-classes="p-0"
         modal-classes="modal-dialog-centered modal-lg">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <h4>Add gift card</h4>

      <!-- STEP 1: Customer -->
      <transition name="fade" mode="out-in">
      <div v-if="giftCardStep === 1" key="step1">
        <base-alert type="info" class="mb-4">
          <span style="font-size: 0.9em;">
            <i class="tim-icons icon-alert-circle-exc mr-2"></i>
            A customer is required to purchase a gift card. Please add or select a customer to continue.
          </span>
        </base-alert>

        <!-- Customer lookup autocomplete -->
        <div class="row">
          <div class="col">
            <base-input label="Search existing customers">
              <el-autocomplete style="width: 100%"
                               v-model="lookup_value"
                               :fetch-suggestions="querySearch"
                               placeholder="Search by name, email, or phone"
                               :trigger-on-focus="false"
                               @select="handleSelect"
              >
                <template #default="{ item }">
                  <p style="margin-bottom: -12px" class="text-primary">{{ item.first_name }} {{ item.last_name }}</p>
                  <small class="font-italic">
                    <i class="tim-icons icon-email-85"></i> {{item.email }} &nbsp;
                    <i v-if="item.phone" class="tim-icons el-icon-mobile-phone"></i> {{item.phone }}
                  </small>
                </template>
              </el-autocomplete>
            </base-input>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-6 col-12">
            <base-input label="First name" v-model="customer.first_name" placeholder="First name"></base-input>
            <p v-show="errs.gc_customer_first_name" class="text-danger small">{{ errs.gc_customer_first_name }}</p>
          </div>
          <div class="col-lg-6 col-12">
            <base-input label="Last name" v-model="customer.last_name" placeholder="Last name"></base-input>
            <p v-show="errs.gc_customer_last_name" class="text-danger small">{{ errs.gc_customer_last_name }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <base-input label="Email" v-model="customer.email" placeholder="Email"></base-input>
            <p v-show="errs.gc_customer_email" class="text-danger small">{{ errs.gc_customer_email }}</p>
          </div>
          <div class="col-lg-6 col-12">
            <base-input
              type="text"
              label="Phone (optional)">
              <phone-number-input ref="gcPhoneInput"
                                  v-model="customer.phone" @phone-update="handlePhoneUpdate"
                                  :default-country="countryCode || 'US'"
              />
            </base-input>
          </div>
        </div>

        <div class="row d-none d-sm-block text-center mt-4">
          <base-button type="secondary" @click="modals.add_gift_card = false">Cancel</base-button>
          <base-button class="ml-3" type="primary" :disabled="giftCardCustomerLoading" @click="saveCustomerAndContinue()">
            <span v-if="giftCardCustomerLoading"><i class="fa fa-spinner fa-spin mr-1"></i> Saving...</span>
            <span v-else>Next</span>
          </base-button>
        </div>
      </div>

      <!-- STEP 2: Gift card -->
      <div v-else-if="giftCardStep === 2" key="step2">
        <!-- Skeleton loading state -->
        <div v-if="giftCardSettingsLoading">
          <div class="row justify-content-center mb-4">
            <div class="col-lg-8 text-center">
              <div class="skeleton-box" style="width: 100%; height: 300px; border-radius: 4px;"></div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-5">
              <div class="skeleton-box" style="width: 80%; height: 20px; border-radius: 4px;"></div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-4">
              <div class="skeleton-box mb-2" style="width: 60%; height: 14px; border-radius: 4px;"></div>
              <div class="skeleton-box" style="width: 100%; height: 40px; border-radius: 4px;"></div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-4">
              <div class="skeleton-box mb-1" style="width: 40%; height: 12px; border-radius: 4px;"></div>
              <div class="skeleton-box" style="width: 60%; height: 28px; border-radius: 4px;"></div>
            </div>
            <div class="col-lg-4">
              <div class="skeleton-box mb-1" style="width: 50%; height: 12px; border-radius: 4px;"></div>
              <div class="skeleton-box" style="width: 60%; height: 28px; border-radius: 4px;"></div>
            </div>
          </div>
        </div>

        <!-- Loaded content -->
        <div v-else>
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <el-carousel v-on:change="setGiftCardDesign" :autoplay="false" indicator-position="outside">
              <el-carousel-item v-for="(item, index) in gift_card_designs" :key="'GCDESIGNS' + index">
                <img style="border: 3px solid white; object-fit: contain; width: 600px; height: 300px" :src="item.url">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="row mb-2" >
          <div class="col-lg-5">
            <base-radio v-model="gift_card.custom_code" name="0">Automatically generate gift card code</base-radio>
          </div>
          <div class="col-lg-5">
            <base-radio v-model="gift_card.custom_code" name="1">Create a custom gift card code</base-radio>
          </div>
        </div>
        <div class="row" v-if="gift_card.custom_code == 1">
          <div class="col">
            <base-input :error="errs.custom_code" label="Custom code" placeholder="Custom code" v-model="gift_card.code"></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4">
            <base-input :label="'Gift card type'">
              <el-select
                label="Select type"
                v-model="selectedGiftCardType"
                class="select-primary"
                value-key="id"
                v-on:change="selectGiftCardType()"
              >
                <el-option
                  v-for="(gct, index) in gift_card_types"
                  class="select-primary"
                  :label="gct.name"
                  :value="{id: gct.id, name: gct.name, include_taxes_and_fees: gct.include_taxes_and_fees,
                      value_type: gct.value_type, designs: gct.designs, price: gct.price,
                       redemption_amount: gct.redemption_amount}"
                  :key="'AMOUNT' + index"
                >
                  <span>{{gct.name}}</span>
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-4" v-if="selectedGiftCardType.value_type === 0">
            <base-input :label="'Custom value  (' + currency_symbol + ')'"
                        v-on:change="calculateTotals()" placeholder="0.00"
                        v-model.number="gift_card.custom_amount"></base-input>
          </div>
          <div class="col-lg-4" v-if="selectedGiftCardType.value_type === 2 && selectedGiftCardType.game_display_mode !== 1">
            <base-input label="Events">
              <el-select
                label="Select event"
                v-model="selectedGame"
                class="select-primary"
                value-key="id"
                v-on:change="calculateGameValue()"
              >
                <el-option
                  v-for="(game, index) in getFilteredGames()"
                  class="select-primary"
                  :label="game.name"
                  :value="{id: game.id,
                  name: game.name,
                  cumulative_category_pricing: game.cumulative_category_pricing,
                  game_pricing: game.game_pricing,
                  pricing_type_id: game.pricing_type_id,
                  pricing_categories: game.pricing_categories}"
                  :key="'GAME' + index"
                >
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-4" v-if="selectedGiftCardType.value_type === 2" :key="gc_key">
            <div v-for="(c, i) in selectedGame.pricing_categories" :key="'C' + i">
              <label class="mt-2 text-uppercase">{{c.category}}</label>
              <base-input>
                <el-input-number @change="calculateGameValue()" v-model="c.number_of_players" :min="0" />
              </base-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <p class="text-white text-uppercase">value ({{currency_symbol}})</p>
            <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(gift_card.unit_value) }}</h2>
          </div>
          <div class="col-lg-4" v-if="selectedGiftCardType.value_type === 1">
            <p class="text-white text-uppercase">price ({{currency_symbol}})</p>
            <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(gift_card.unit_price) }}</h2>
          </div>
          <div class="col-lg-4">
            <p class="text-white text-uppercase">total cost ({{currency_symbol}})</p>
            <h2 style="margin-bottom: 0px" class="warning">{{ getAmount(gift_card.total) }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 ">
            <base-input label="Quantity">
              <el-input-number v-on:change="calculateTotals()" v-model="gift_card.quantity" placeholder="1" :min="1"></el-input-number>
            </base-input>
          </div>
        </div>

        <div class="row mb-3" >
          <div class="col-lg-3">
            <base-radio v-on:input="setDeliveryDate()" v-model="gift_card.send_instantly" name="1">Send instantly</base-radio>
          </div>
          <div class="col-lg-4">
            <base-radio v-model="gift_card.send_instantly" name="0">Send on a future date</base-radio>
          </div>
        </div>

        <div class="row mt-2 justify-content-between" v-if="gift_card.send_instantly == 0">
          <div class="col-lg-6">
            <base-input label="Delivery date">
              <el-date-picker :editable="false"
                class="custom-cursor"
                type="date"
                placeholder="Select date"
                value-format="yyyy-MM-dd"
                :format="day_of_week + '' + date_format_cal"
                v-model="gift_card.delivery_date"
                :picker-options="{ disabledDate: (time) => disabledDates(time, gift_card.delivery_date) }"
              >
              </el-date-picker>
            </base-input>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <base-checkbox type="checkbox"
                           v-model="send_gift_card_to_self"> Purchasing customer is the recipient
            </base-checkbox>
          </div>
        </div>
        <div class="row justify-content-center" v-if="!send_gift_card_to_self">
          <div class="col-12 col-lg-6">
            <base-input :error="errs.recipient_first_name" v-model="gift_card.recipient_first_name" placeholder="Recipient's first name"></base-input>
          </div>
          <div class="col-12 col-lg-6" >
            <base-input :error="errs.recipient_last_name" v-model="gift_card.recipient_last_name" placeholder="Recipient's last name"></base-input>
          </div>
        </div>
        <div class="row justify-content-center" v-if="!send_gift_card_to_self">
          <div class="col">
            <base-input :error="errs.recipient_email" v-model="gift_card.recipient_email" placeholder="Recipient's email"></base-input>
          </div>
        </div>

        <div class="row  justify-content-center">
          <div class="col">
            <base-input label="Personal message">
              <textarea class="form-control" placeholder="Add your personal message..." v-model="gift_card.personal_message" rows="2"></textarea>
            </base-input>
          </div>
        </div>
        </div>
        <!-- End loaded content -->

        <div class="row d-none d-sm-block text-center">
          <base-button v-if="!transaction.end_user_id" type="default" @click="giftCardStep = 1">Back</base-button>
          <base-button type="secondary" @click="modals.add_gift_card = false">Cancel</base-button>
          <base-button class="ml-3" type="primary" :disabled="loading || giftCardSettingsLoading" @click="createGiftCard()">Save</base-button>
        </div>
      </div>
      </transition>
    </card>
  </modal>


  <!--    Add Bookings Modal-->
  <add-booking-drawer
    :show="addBookingDrawerOpen"
    :transaction-id="transaction.id"
    :has-booking-created-automation="hasBookingCreatedAutomation"
    @close="addBookingDrawerOpen = false"
    @added="getTransaction()"
  />

  <!--    Add item drawer (reuses the booking-drawer AddItemView) -->
  <base-drawer bare :show="modals.add_item" @close="modals.add_item = false">
    <add-item-view
      v-if="modals.add_item"
      :transaction-id="transaction.id"
      :company-id="addItemCompanyId"
      :company-group-id="addItemGroupId"
      :game-ids="transactionGameIds"
      :currency="currency"
      :currency-symbol="currency_symbol"
      :currency-format="currency_format"
      :number-format="number_format"
      @back="modals.add_item = false"
      @updated="onItemAdded"
    ></add-item-view>
  </base-drawer>

  <modal :show.sync="modals.custom_purchase"
         body-classes="p-0"
         modal-classes="modal-dialog-centered modal-lg">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <h4>Add custom purchase</h4>

      <div class="row">
        <div class="col">
          <base-input :error="errs.purchase.name" label="Purchase name" placeholder="Purchase name" v-model="purchase.name">
          </base-input>
        </div>
      </div>

      <div class="row" >
        <div class="col">
          <base-input label="Description">
            <el-input
              v-model="purchase.description"
              :rows="5"
              type="textarea"
              placeholder="Description"
            />
          </base-input>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-4">
          <base-input :error="errs.purchase.quantity" label="Quantity">
            <el-input-number v-model="purchase.quantity" :min="1" />
          </base-input>
        </div>
        <div class="col-lg-4">
          <label>Price per unit ({{currency_symbol}})</label>
          <base-input :error="errs.purchase.price" placeholder="0" v-model.number="purchase.price"></base-input>
        </div>

        <div class="col-lg-4">
          <label>Subtotal ({{currency_symbol}})</label>
          <h4>{{getAmount(getPurchaseAmount(purchase.price, purchase.quantity))}}</h4>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col text-center">
          <base-button type="secondary" @click="modals.custom_purchase = false">Cancel</base-button>
          <base-button class="ml-3" type="primary" :disabled="loading" @click="createCustomPurchase()">Save</base-button>
        </div>
      </div>
    </card>
  </modal>

  <!--    Add Payment Modal-->
  <modal :show.sync="modals.add_payment"
         body-classes="p-0"
         modal-classes="modal-dialog-centered modal-lg">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <h4>Add payment to transaction #{{transaction.order_number}}</h4>
      <div class="row mt-1">
        <div class="col-6">
          <label>Amount ({{currency_symbol}})</label>
          <base-input :error="errs.payment_amount" v-model="payment_amount"></base-input>
        </div>
        <div class="col-6" v-if="selectedPaymentOption.name === 'Customer credit'">
          <label>Available credit ({{currency_symbol}})</label>
          <base-input v-model="available_credit" disabled></base-input>
        </div>
        <div class="col-6" v-if="selectedPaymentOption.name === 'Gift card' && selectedGiftCardCode">
          <label>Available gift card amount ({{currency_symbol}})</label>
          <base-input v-model="selectedGiftCardCode.remaining" disabled></base-input>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <base-input label="Payment options">
            <el-select
              class="select-primary mb-3"
              v-model="selectedPaymentOption"
              placeholder="Option"
              value-key="id"
              @change="onPaymentOptionChange"
            >
              <el-option
                class="select-primary"
                v-for="(item, index) in paymentOptions"
                :key="index + 'P'"
                :label="item.name"
                :value="{id: item.id, name: item.name, content: item.content, is_default: item.is_default}"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-6" v-if="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 3 && payment_settings.store_credit_card && stripe_payment_methods.length > 0">
          <base-input label="Stored cards">
            <el-select
              class="select-primary mb-3"
              v-model="selected_payment_method"
              placeholder="Select card"
              @change="onPaymentMethodChange"
            >
              <el-option
                class="select-primary"
                label="Use a new card"
                value="new"
              >
              </el-option>
              <el-option
                class="select-primary"
                v-for="pm in stripe_payment_methods"
                :key="pm.id"
                :label="getCardBrandName(pm.card_brand) + ' ****' + pm.card_last_four + (pm.is_default ? ' (Default)' : '')"
                :value="pm.id"
              >
                <span>
                  <i :class="getCardBrandIcon(pm.card_brand)" class="mr-2"></i>
                  {{ getCardBrandName(pm.card_brand) }} ****{{ pm.card_last_four }}
                  <badge v-if="pm.is_default" type="success" class="ml-2">Default</badge>
                </span>
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-6" v-if="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 2 && payment_settings.square_store_credit_card && square_payment_methods.length > 0">
          <base-input label="Stored cards">
            <el-select
              class="select-primary mb-3"
              v-model="selected_payment_method"
              placeholder="Select card"
              @change="onSquarePaymentMethodChange"
            >
              <el-option
                class="select-primary"
                label="Use a new card"
                value="new"
              >
              </el-option>
              <el-option
                class="select-primary"
                v-for="pm in square_payment_methods"
                :key="pm.id"
                :label="getCardBrandName(pm.card_brand) + ' ****' + pm.card_last_four + (pm.is_default ? ' (Default)' : '')"
                :value="pm.id"
              >
                <span>
                  <i :class="getCardBrandIcon(pm.card_brand)" class="mr-2"></i>
                  {{ getCardBrandName(pm.card_brand) }} ****{{ pm.card_last_four }}
                  <badge v-if="pm.is_default" type="success" class="ml-2">Default</badge>
                </span>
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>

      <div class="row" v-if="!selectedPaymentOption.is_default">
        <div class="col">
          <div v-html="selectedPaymentOption.content"></div>
        </div>
      </div>

      <div class="row mb-3" v-if="selectedPaymentOption.name === 'Gift card'">
        <div class="col">
          <base-input label="Gift card code" :error="errs.gift_card_code">
            <el-autocomplete style="width: 100%"
                             v-model="gift_card_code"
                             :fetch-suggestions="giftCardSearch"
                             placeholder="Search by code..."
                             :trigger-on-focus="false"
                             @select="handleGiftCardSelect"
            >
              <template #default="{ item }">
                <div class="row">
                  <div class="col">
                    <p style="margin-bottom: -12px" class="text-primary">{{ getGiftCardCode(item.code) }}</p>
                    <small class="font-italic">
                      <i class="tim-icons icon-money-coins"></i> Total {{getAmount(item.total)}} Remaining {{getAmount(item.remaining)}}
                    </small>
                    <br/>
                  </div>
                </div>
              </template>
            </el-autocomplete>
          </base-input>
        </div>
      </div>

      <div class="row" v-if="selectedPaymentOption.name === 'Card' && (payment_settings.payment_gateway_id !== 3 || selected_payment_method === 'new') && (payment_settings.payment_gateway_id !== 2 || selected_payment_method === 'new' || square_payment_methods.length === 0)">
        <div class="col-6">
          <base-input :error="errs.first_name" label="Cardholder first name" v-model="user.first_name" placeholder="First name"></base-input>
        </div>
        <div class="col-6">
          <base-input :error="errs.last_name" label="Cardholder last name" v-model="user.last_name" placeholder="Last name"></base-input>
        </div>
      </div>

      <!--                  Square-->
      <div v-show="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 2">
        <!-- New card form (only show when using new card) -->
        <div class="row mt-2" v-show="selected_payment_method === 'new' || square_payment_methods.length === 0">
          <div class="col">
            <form id="payment-form-square">
              <div id="card-container"></div>
            </form>
            <div id="payment-status-container"></div>
          </div>
        </div>

        <!-- Save card toggle (only show when using new card and store_credit_card is enabled) -->
        <div class="row mt-4 mb-3" v-if="(selected_payment_method === 'new' || square_payment_methods.length === 0) && payment_settings.square_store_credit_card && payment_settings.square_create_customer && transaction.end_user_id">
          <div class="col">
            <el-switch active-color="#e14eca" v-model="save_card_for_future" />
            <label class="text-white opacity-7 ml-2">Save this card for future payments</label>
          </div>
        </div>

        <!-- Selected stored card info -->
        <div class="row mb-3" v-if="selected_payment_method !== 'new' && selectedSquareStoredCard">
          <div class="col">
            <div class="card p-3 mb-0 stored-card" style="background: linear-gradient(135deg, #171826 0%, #2d2d44 100%); border: 2px solid #e14eca40;">
              <div class="d-flex align-items-center">
                <i :class="getCardBrandIcon(selectedSquareStoredCard.card_brand)" class="text-white mr-3" style="font-size: 2rem;"></i>
                <div>
                  <p class="text-white mb-0">{{ getCardBrandName(selectedSquareStoredCard.card_brand) }} ****{{ selectedSquareStoredCard.card_last_four }}</p>
                  <small class="text-white opacity-7" v-if="selectedSquareStoredCard.cardholder_name">{{ selectedSquareStoredCard.cardholder_name }}</small>
                  <small class="text-white opacity-7"> &middot; Expires {{ selectedSquareStoredCard.card_exp_month }}/{{ selectedSquareStoredCard.card_exp_year }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--        Stripe-->
      <div v-show="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 3">
        <!-- New card form (only show when using new card) -->
        <div class="row mb-3" v-show="selected_payment_method === 'new'">
          <div class="col">
            <form id="payment-form">
              <label for="card-element">
                Credit or debit card
              </label>
              <div id="card-element">
                <!-- A Stripe Element will be inserted here. -->
              </div>
              <div id="card-errors" role="alert"></div>
            </form>
          </div>
        </div>

        <!-- Save card toggle (only show when using new card and store_credit_card is enabled) -->
        <div class="row mb-3" v-if="selected_payment_method === 'new' && payment_settings.store_credit_card">
          <div class="col">
            <el-switch active-color="#e14eca" v-model="save_card_for_future" />
            <label class="text-white opacity-7 ml-2">Save this card for future purchases</label>
          </div>
        </div>

        <!-- Selected stored card info -->
        <div class="row mb-3" v-if="selected_payment_method !== 'new' && selectedStoredCard">
          <div class="col">
            <div class="card p-3 mb-0 stored-card" style="background: linear-gradient(135deg, #171826 0%, #2d2d44 100%); border: 2px solid #e14eca40;">
              <div class="d-flex align-items-center">
                <i :class="getCardBrandIcon(selectedStoredCard.card_brand)" class="text-white mr-3" style="font-size: 2rem;"></i>
                <div>
                  <p class="text-white mb-0">{{ getCardBrandName(selectedStoredCard.card_brand) }} ****{{ selectedStoredCard.card_last_four }}</p>
                  <small class="text-white opacity-7" v-if="selectedStoredCard.cardholder_name">{{ selectedStoredCard.cardholder_name }}</small>
                  <small class="text-white opacity-7"> &middot; Expires {{ selectedStoredCard.card_exp_month }}/{{ selectedStoredCard.card_exp_year }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--        Authorize.net (Accept.js)-->
      <div class="row" v-if="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 1">
        <div class="col-12">
          <enhanced-payment-form
            ref="authorizePaymentForm"
            :api-login-id="payment_settings.api_name"
            :public-client-key="payment_settings.public_client_key"
            :is-live="!!payment_settings.is_live"
            :show-security-indicators="false"
          />
        </div>
      </div>

      <div class="row d-none d-sm-block text-center">
        <base-button type="secondary" @click="modals.add_payment = false">Cancel</base-button>
        <base-button class="ml-3" type="primary" :disabled="loading" @click="addPayment()">Add payment</base-button>
      </div>
      <div class="row d-block d-sm-none text-center">
        <base-button simple size="sm" type="secondary" @click="modals.add_payment = false">Cancel</base-button>
        <base-button simple size="sm" class="ml-3" :disabled="loading" type="primary" @click="addPayment()">Add payment</base-button>
      </div>
    </card>
  </modal>

<!--    Activity log-->
  <modal :show.sync="modals.view_booking_log" id="activityModal"
         body-classes="p-0" style="overflow-y: scroll"
         modal-classes="modal-dialog-centered modal-lg">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <badge type="default" v-if="booking_activity_log.length > 0">#{{booking_activity_log_slot_id}}</badge>
      <h4 class="card-title">Activity log</h4>
      <div class="mt-3" v-if="booking_activity_log.length <= 0">
        <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
          <h4 class="mt-3">No event have been recorded.</h4>
        </div>
      </div>
      <div v-if="booking_activity_log.length > 0">
        <b-table :items="booking_activity_log" :fields="['event', 'performed_by', 'timestamp']">
          <template v-slot:cell(event)="row">
            <span v-if="row.item.party_label" class="text-primary">{{ row.item.party_label }}: </span>{{row.item.description}}{{ isOneSidedLogValue(row.item) ? ':' : '' }}
            <span v-if="row.item.new_value && row.item.old_value && isTime(row.item.new_value)"> from
                {{getTime(row.item.old_value)}} to {{getTime(row.item.new_value)}}
              </span>
            <span v-if="row.item.new_value && row.item.old_value && isDate(row.item.new_value)"> from
                {{getFormattedDate(row.item.old_value)}} to {{getFormattedDate(row.item.new_value)}}
              </span>
            <span v-if="row.item.new_value && row.item.old_value && !isTime(row.item.new_value) && !isDate(row.item.new_value)"> from
                {{row.item.old_value}} to {{row.item.new_value}}
              </span>
            <span v-if="row.item.new_value && !row.item.old_value" class="text-muted">
                {{row.item.new_value}}
              </span>
            <span v-if="row.item.old_value && !row.item.new_value" class="text-muted">
                {{row.item.old_value}}
              </span>
          </template>
          <template v-slot:cell(timestamp)="row">
            {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}
          </template>
          <template v-slot:cell(performed_by)="row">
            <span v-if="!row.item.end_user_id && !row.item.company_user_id">System</span>
            <span v-if="row.item.end_user_id && !row.item.company_user_id">{{ row.item.end_user_name }}
                <el-tooltip content="View customer"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                    <base-button v-if="hasPermissions('customer_view')" v-on:click="viewCustomer(row.item.end_user_id)" icon class="btn btn-link" simple size="sm" type="primary">
                      <i class="tim-icons el-icon-top-right"></i>
                    </base-button>
                  </el-tooltip>
              </span>
            <span v-if="!row.item.end_user_id && row.item.company_user_id">{{ row.item.company_user_name }}
              </span>
          </template>

        </b-table>
      </div>


      <div class="row justify-content-center mt-3">
        <div class="col text-center">
          <base-button type="secondary" @click="modals.view_booking_log = false">Cancel</base-button>
        </div>
      </div>
    </card>
  </modal>

  <gift-card-activity-log-modal
    :show.sync="modals.view_gift_card_log"
    :activity-log="gift_card_activity_log"
    :gift-card-code="gift_card_activity_log_code"
    :loading="gift_card_activity_log_loading"
    :date-format="date_format"
    :time-format="time_format"
    :currency-symbol="currency_symbol"
    :currency="currency"
    :currency-format="currency_format"
    :number-format="number_format"
    :has-transaction-permission="true"
    @close="modals.view_gift_card_log = false"
  />

  <gift-card-adjust-value-modal
    :show.sync="modals.adjust_gift_card_value"
    :gift-card="selectedGiftCardForAdjustment"
    :currency-symbol="currency_symbol"
    :currency="currency"
    :currency-format="currency_format"
    :number-format="number_format"
    @close="modals.adjust_gift_card_value = false"
    @adjusted="onGiftCardAdjusted"
  />

  <!-- TEMPORARY (group 40 only) — Payment requests drawer. Safe to leave
       rendered when useNewPaymentActions is off (the trigger is gated). -->
  <payment-requests-drawer
    :show="paymentRequestsDrawerOpen"
    :transaction-id="transaction && transaction.id ? Number(transaction.id) : null"
    :company-group-id="companyGroupId"
    :transaction="transaction"
    :get-amount="getAmount"
    :can-send-email="canSendPaymentRequestEmail"
    @close="paymentRequestsDrawerOpen = false"
    @deposit-saved="getTransaction()"
    @send-email-prompt="sendPaymentRequestPrompt(transaction)"
  />

  <send-email-drawer
    :show="sendEmailDrawerOpen"
    :transaction="transaction"
    :rows="bookings"
    :email-settings="email_settings"
    :company-id="companyId"
    :company-group-id="companyGroupId"
    @close="sendEmailDrawerOpen = false"
    @sent="getTransaction()"
  />

  <base-alert-dialog
    :show="confirmationDialog.show"
    :title="confirmationDialog.title"
    :message="confirmationDialog.message"
    :variant="confirmationDialog.variant"
    :show-cancel="confirmationDialog.showCancel"
    :confirm-text="confirmationDialog.confirmText"
    :cancel-text="confirmationDialog.cancelText || 'Cancel'"
    :dismissible="confirmationDialog.dismissible !== false"
    @confirm="confirmationDialogConfirm"
    @cancel="confirmationDialogCancel"
  />

</div>
</template>

<script>
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import {diacriticIncludes} from "@/util/search";
import { Badge, BaseAlert, TimeLine, TimeLineItem } from '@/components';
import {BTable, BRow, BCol} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import {dayOfWeek, formattedDate, time} from "@/plugins/dateFormatter";
import {formatGroupDate, formatGroupTime} from "@/plugins/dates";
import {collapseEmailEvents} from "@/util/emailEvents";
import {allowsOverpayment} from "@/util/paymentAmountCap";
import _ from "lodash";
import currencies from "@/assets/currencies.json";
import {Autocomplete, Dropdown, DropdownMenu, CarouselItem, Carousel, TimePicker, Switch} from "element-ui";
import axios from "axios";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import countries from "@/assets/countries.json";
import moment from "moment-timezone";
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import {formatPhoneDisplay} from "@/util/phoneFormatter";
import {isValidEmail} from "@/util/emailValidator";
import { switchGroup } from '@/util/activeGroup';
import EnhancedPaymentForm from "@/components/Payments/EnhancedPaymentForm";
import AddItemView from "@/pages/Bookings/Bookings/components/BookingDrawer/drawer-views/AddItemView.vue";
import GiftCardActivityLogModal from "@/pages/Purchases/GiftCards/components/GiftCardActivityLogModal";
import GiftCardAdjustValueModal from "@/pages/Purchases/GiftCards/components/GiftCardAdjustValueModal";
import SendToPosButton from '@/components/POS/SendToPosButton.vue';
import PaymentRequestsDrawer from '@/components/Purchases/PaymentRequestsDrawer.vue';
import SendEmailDrawer from './SendEmailDrawer.vue';
import CancelTransactionDrawer from '@/components/Purchases/CancelTransactionDrawer.vue';
import TabRail from '@/components/TabRail.vue';
import TransactionWatcher from '@/services/transactionWatcher';
import { fetchWaiverDetail } from '@/util/waiverSignature';
import WaiverDrawer from '@/components/Waivers/WaiverDrawer.vue';
import { roundCents, applyPrivateUpgrade, filterPricingByDuration, slotDurationSettings, durationPickerOptions, slotPricingRows, calculateEventGiftCardValue } from '@/util/pricing'
import AddBookingDrawer from './AddBookingDrawer.vue'
import { INTERNAL_SOURCE } from '@/util/customFieldSource'
import { isInternalPhoneRequired, validateInternalCustomerPhone } from '@/util/customerFieldValidation'
import { isAffiliatesBetaCompany } from '@/util/affiliatesBeta'
import { bookingCalendarLink } from '@/util/bookingsView'

// payment_refunds rows written before the refund-type classification deploy may be stamped
// 'gateway' for refunds that actually went to store credit or gift card, so destination
// labels can't be trusted for refunds recorded before this moment
const REFUND_TYPE_TRUST_CUTOFF = new Date('2026-07-07T00:00:00Z')

export default {
  name: "TransactionDetails",
  components: {
    AddBookingDrawer,
    WaiverDrawer,
    Breadcrumb,
    BreadcrumbItem,
    BTable,
    BRow,
    BCol,
    [Autocomplete.name]: Autocomplete,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [CarouselItem.name]: CarouselItem,
    [Carousel.name]: Carousel,
    [TimePicker.name]: TimePicker,
    [Switch.name]: Switch,
    Badge,
    VueHtml2pdf,
    BaseAlert,
    TimeLine,
    TimeLineItem,
    PhoneNumberInput,
    EnhancedPaymentForm,
    GiftCardActivityLogModal,
    GiftCardAdjustValueModal,
    SendToPosButton,
    PaymentRequestsDrawer,
    SendEmailDrawer,
    CancelTransactionDrawer,
    TabRail,
    AddItemView
  },
  data() {
    return {
      confirmationDialog: {
        show: false,
        title: '',
        message: '',
        variant: 'warning',
        showCancel: false,
        confirmText: 'OK',
        cancelText: 'Cancel',
        dismissible: true,
        onConfirm: null,
        onCancel: null
      },
      countryCode: JSON.parse(localStorage.getItem('company')).country,
      enable_utm_source_tracking: false,
      // error is a String because base-input's error prop is typed String.
      affiliateAttach: { open: false, loading: false, saving: false, error: '', affiliateId: null, options: [] },
      discount_amount: 0,
      discount_description: '',
      company: JSON.parse(localStorage.getItem('company')),
      group: JSON.parse(localStorage.getItem('group')),
      totalTaxAmount: 0,
      totalFeeAmount: 0,
      gc_key: 0,
      gift_card_designs: [],
      gift_card_settings: '',
      gift_card_types: [],
      gift_card_games: [],
      game_taxes: [],
      game_fees: [],
      taxLinks: [],
      feeLinks: [],
      gift_card: {
        custom_code: 0,
        code: '',
        personal_message: '',
        design_url: '',
        custom_amount: '',
        recipient_first_name: '',
        recipient_last_name: '',
        recipient_email: '',
        total: {amount: 0},
        quantity: 1,
        send_instantly: 1,
        delivery_date: new Date()
      },
      booking_date: '',
      selectedTimeSlot: '',
      day_of_week: '',
      custom_fields: [],
      country: '',
      countries: countries.countries,
      currencies: currencies.currencies,
      number_format: JSON.parse(localStorage.getItem('group')).number_format,
      currency_symbol: '$',
      currency: JSON.parse(localStorage.getItem('group')).currency,
      currency_format: JSON.parse(localStorage.getItem('group')).currency_format,
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      picker_time_format: 'hh:mm A',
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      first_day_of_week: JSON.parse(localStorage.getItem('group')).first_day_of_week,
      date_format_cal: '',
      email_settings: '',
      refundAmount: 0,
      lookup_value: '',
      // OTC-3142: Customer tab state, 'view' (read only), 'edit' (form) or 'change' (lookup).
      customerTabMode: 'view',
      company_user_value: '',
      showRefund: [],
      showEditPaymentDate: [],
      editPaymentDateDate: [],
      editPaymentDateTime: [],
      editPaymentDateLoading: false,
      editPaymentDateError: [],
      selectedGame: '',
      isAmountFieldDisabled: true,
      selectedPaymentAmount: '',
      selectedRefundGiftCardType: '',
      note: '',
      loading: false,
      hasBookingCreatedAutomation: false,
      transactionLoaded: false,
      currentGroupName: (JSON.parse(localStorage.getItem('group')) || {}).name || '',
      notFound: false,
      notFoundOrderNumber: '',
      otherGroup: null,
      switchingGroup: false,
      transaction: '',
      activity: [],
      payments: [],
      payment_refunds: [],
      waivers: [],
      waiverSettings: [],
      bookings: [],
      available_bookings: [],
      editing_bookings: [],
      games: [],
      notes: [],
      booking_notes: [],
      gift_cards: [],
      note_type: 'transaction',
      paymentFields: ['payment_details', 'amount', 'actions'],
      waiverColumns: [
        { key: 'customer_details', label: 'Customer details' },
        { key: 'booking_details', label: 'Booking details' },
        { key: 'date_signed', label: 'Date signed' },
        { key: 'signature', label: 'Signature' },
      ],
      waiverDrawer: { show: false, waiver: null },
      bookingFields: ['purchase_details', 'quantity', 'price', 'status', 'actions'],
      pdfGeneratingId: null,
      modals: {
        add_payment: false,
        policy: false,
        add_item: false,
        add_gift_card: false,
        custom_purchase: false,
        cancel_booking: false,
        view_booking_log: false,
        view_gift_card_log: false,
        adjust_gift_card_value: false,
      },
      // TEMPORARY (group 40 only) — drawer state for the new Payment
      // requests flow. Safe to leave even when useNewPaymentActions is off.
      paymentRequestsDrawerOpen: false,
      sendEmailDrawerOpen: false,
      addBookingDrawerOpen: false,
      // Inline reschedule: duration chosen for the target slot (null = its default)
      reschedule_duration_id: null,
      cancelDrawerOpen: false,
      selectedGiftCardForAdjustment: null,
      selectedPolicy: '',
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phoneE164: ''
      },
      company_user: {
        first_name: '',
        last_name: '',
        email: '',
      },
      customer: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phoneE164: ''
      },
      errs: {
        discount_amount: '',
        recipient_first_name: '',
        recipient_last_name: '',
        recipient_email: '',
        custom_code: '',
        gc_customer_first_name: '',
        gc_customer_last_name: '',
        gc_customer_email: '',
        number_of_players: '',
        promo_code: '',
        gift_card_code: '',
        ccn: '',
        expiration: '',
        cvv: '',
        zip: '',
        first_name: '',
        last_name: '',
        payment_amount: '',
        email: '',
        phone: '',
        booking_date: '',
        time_slot: '',
        start_time: '',
        group_size: '',
        price: '',
        tax: '',
        fee: '',
        tip_amount: '',
        purchase: {
          name: '',
          category: '',
          available: '',
          amount: '',
          quantity: '',
          price: ''
        }
      },
      authorize_opaque_data: null,
      activeTabIndex: 0,
      activeTabNotesIndex: 0,
      selectedPaymentOption: {name: '', content: '', id: '', is_default: ''},
      paymentOptions: [],
      customer_credits: 0,
      available_credit: 0,
      applied_credit: 0,
      card: '',
      square: '',
      squareAppId: '',
      squareLocationId: '',
      elements: '',
      stripe: '',
      stripe_payment_methods: [],
      stripe_customer: null,
      square_payment_methods: [],
      square_customer: null,
      selected_payment_method: 'new',
      save_card_for_future: false,
      loading_payment_methods: false,
      waiveLoading: false,
      payment_settings: [],
      payment_amount: '',
      cursor_type: {
        resend_confirmation_email: 'pointer',
        payment_request: 'pointer',
        gift_card_confirmation_email: 'pointer',
        no_amount_due: 'pointer'
      },
      promos: [],
      promos_invoice: [],
      add_promo: false,
      add_discount: false,
      promo_code: '',
      gift_card_code: '',
      selectedPromoCode: '',
      selectedGiftCardCode: '',
      add_fee: false,
      taxes_fees: [],
      taxes_fees_invoice: [],
      tax_fee_types: [
        {id: 0, name: 'Tax'}, {id: 1, name: 'Fee'}, {id: 2, name: 'Tip'}
      ],
      tax_fee_type: {id: 0},
      taxes: [],
      fees: [],
      selectedTax: '',
      selectedFee: '',
      purchase: {
        name: '',
        category: '',
        amount: '',
        quantity: '',
        price: 0,
        available: ''
      },
      is_custom_purchase: false,
      custom_category: '',
      cat_key: 0,
      pricing_type_id: 1,
      pricing_categories: [],
      custom_pricing_categories: [],
      subtotal: 0,
      tickets: [],
      price_override: false,
      pr_key: 0,
      email_events: [],
      tip_amount: 0,
      send_gift_card_to_self: false,
      giftCardStep: 1,  // 1 = customer step, 2 = gift card step
      giftCardCustomerLoading: false,  // Local loading state for customer save
      giftCardSettingsLoading: false,  // Local loading state for gift card settings
      selectedGiftCardType: '',
      selectedCancellationStatus: {id: 1},
      waiverCount: 0,
      deleteWaivers: 'keep',
      slot_statuses: [
        {id: 1, label: 'Available', status: 'available'},
        {id: 2, label: 'Blocked', status: 'blocked'},
        {id: 3, label: 'Call to book', status: 'call_to_book'},
      ],
      selectedBookingSlot: '',
      booking_activity_log: [],
      booking_activity_log_slot_id: null,
      gift_card_activity_log: [],
      gift_card_activity_log_loading: false,
      gift_card_activity_log_code: ''
    }
  },
  computed: {
    // OTC-3142: a failed order (status 3) is read only. Every action on this page
    // that is not already limited to an active order is hidden or disabled by this flag.
    isReadOnly() {
      return Number(this.transaction && this.transaction.status) === 3
    },
    moveActivity() {
      const list = Array.isArray(this.activity) ? this.activity : []
      return list.find(a => a && a.activity_type === 'group_move') || null
    },
    rescheduleDurationOptions(){
      const editingIndex = this.editing_bookings.findIndex(v => v === true)
      const item = editingIndex === -1 ? null : this.bookings[editingIndex]
      const slot = item && item.start_time && item.start_time.id ? item.start_time : null
      const settings = slotDurationSettings(slot || {})
      return settings.enabled ? durationPickerOptions(settings.durations) : []
    },
    canAttachAffiliate() {
      // TEMPORARY: ungated for local testing until the affiliates permission seed
      // runs. Restore hasPermissions('affiliates_update') before release, in step
      // with the same expression in src/pages/Marketing/Affiliates.vue.
      return isAffiliatesBetaCompany()
        && (true || this.hasPermissions('affiliates_update'))
        && this.transaction
        && Number(this.transaction.status) === 1
    },
    paymentAmountOptions() {
      let options = [
        {
          id: 0,
          name: 'Refund full amount'
        },
        {
          id: 1,
          name: 'Refund partial amount'
        },
        {
          id: 2,
          name: 'Refund as customer credit'
        },
        {
          id: 3,
          name: 'Refund as gift card'
        }
      ]
      // Half-cent threshold so float residue on due (e.g. -1.4e-14 after a
      // settled transaction) doesn't surface the option with a 0.00 prefill
      if(this.transaction && parseFloat(this.transaction.due) < -0.005){
        options.push({
          id: 4,
          name: 'Refund amount due to customer'
        })
      }
      return options
    },
    // Match the values createPurchase used so AddItemView hits the same add endpoint.
    addItemCompanyId() {
      return localStorage.getItem('companyId');
    },
    addItemGroupId() {
      return JSON.parse(localStorage.getItem('group')).id;
    },
    // Game ids of the bookings on this transaction, so AddItemView can label/
    // prioritise items that are add-ons for any of those experiences.
    transactionGameIds() {
      return [...new Set(
        (this.bookings || [])
          .filter(b => b && b.game_id != null)
          .map(b => Number(b.game_id))
      )].filter(n => !isNaN(n));
    },
    activeBookings() {
      return this.bookings.filter(booking => booking.status !== 'cancelled');
    },
    invoiceCustomFields() {
      return (this.custom_fields || []).filter(f => f.source !== INTERNAL_SOURCE)
    },
    isAnyBookingBeingEdited() {
      return this.editing_bookings.some(isEditing => isEditing === true)
    },
    selectedStoredCard() {
      if (this.selected_payment_method === 'new' || !this.selected_payment_method) {
        return null
      }
      return this.stripe_payment_methods.find(pm => pm.id === this.selected_payment_method)
    },
    selectedSquareStoredCard() {
      if (this.selected_payment_method === 'new' || !this.selected_payment_method) {
        return null
      }
      return this.square_payment_methods.find(pm => pm.id === this.selected_payment_method)
    },
    categories() {
      return [
        { name: 'All purchases', shortName: 'Purchases' },
        { name: 'Payments', shortName: 'Payments' },
        { name: 'Promos', shortName: 'Promos' },
        { name: 'Taxes/Fees/Tips', shortName: 'Taxes/Fees/Tips' },
        { name: 'Customer', shortName: 'Customer' },
        { name: 'Waivers', shortName: 'Waivers' },
        { name: 'Additional information', shortName: 'Info' },
        { name: 'Emails', shortName: 'Emails' },
      ];
    },
    noteCategories() {
      return [
        { name: 'All notes', shortName: 'All notes' },
        { name: 'Transaction notes', shortName: 'Transaction notes' },
        { name: 'Booking notes', shortName: 'Booking notes' },
      ];
    },
    shareableWaiverEnabled() {
      const shareableWaiver = this.waiverSettings.find(w => w.type === 'shareable')
      return shareableWaiver && shareableWaiver.is_active === 1
    },
    companyGroupId() {
      const raw = localStorage.getItem('group')
      if (!raw) return null
      try { return JSON.parse(raw).id } catch (e) { return null }
    },
    companyId() {
      return localStorage.getItem('companyId')
    },
    useNewPaymentActions() {
      // TEMPORARY: replaces the Payment options dropdown with three flat
      // buttons (Add payment, Payment requests, Send to POS) for the test
      // group only. To disable everywhere — including reverting to the
      // legacy dropdown on group 40 — flip this to `return false`. The new
      // template block below it is also commented-friendly: wrap it in
      // `v-if="false"` or delete it without touching the legacy block.
      // Reverted to legacy dropdown for all groups; re-enable with
      // `return this.companyGroupId === 40`.
      return false
    },
    canSendPaymentRequestEmail() {
      // Mirrors the legacy showSendPaymentButton() logic so the drawer's
      // per-row Send email button is gated identically.
      if (!this.transaction || this.transaction.status !== 1) return false
      if (!(this.transaction.due > 0)) return false
      const setting = _.find(this.email_settings, { email_type: 'payment_request' })
      return !!(setting && setting.is_active)
    }
  },
  watch: {
    // Subscribe to live transaction updates (POS payment landed, future
    // webhook fan-out, etc.). Stored on `this._txWatcher` rather than `data`
    // because it's a non-reactive resource — making it reactive would slow
    // Vue's diff for no benefit.
    'transaction.id': {
      immediate: true,
      handler(newId) {
        if (this._txWatcher) {
          this._txWatcher.disconnect()
          this._txWatcher = null
        }
        if (newId) {
          this._txWatcher = new TransactionWatcher(Number(newId), () => {
            // WS only carries the id; re-fetch the canonical state.
            this.getTransaction()
          })
        }
      }
    }
  },
  methods: {
    async onWaiveToggle(field, newValue) {
      this.waiveLoading = true
      const token = await this.getAuthToken()
      const config = { headers: { Authorization: token } }
      const companyId = localStorage.getItem('companyId')
      const companyGroupId = JSON.parse(localStorage.getItem('group')).id
      const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/transactions/${this.transaction.id}`
      const body = { [field]: newValue ? 1 : 0 }
      const label = field === 'waive_taxes' ? 'Taxes' : 'Fees'
      try {
        await this.axios.put(url, body, config)
        await this.getTransaction(true)
        this.$notify({ type: 'success', message: `${label} ${newValue ? 'waived' : 'restored'}` })
      } catch (err) {
        const message = (err.response && err.response.data) || `Failed to update ${label.toLowerCase()}`
        this.$notify({ type: 'danger', message })
      } finally {
        this.waiveLoading = false
      }
    },
    getRecipient(recipient){
      return JSON.parse(recipient).length > 0 ? JSON.parse(recipient)[0].first_name +
        ' ' + JSON.parse(recipient)[0].last_name + ' (' +
        JSON.parse(recipient)[0].email  + ')': '-'
    },
    getTicketsArray(tickets) {
      // Handle tickets that might be stored as string or array
      if (typeof tickets === 'string') {
        try {
          return JSON.parse(tickets)
        } catch (e) {
          console.warn('Failed to parse tickets', e)
          return []
        }
      }
      return tickets || []
    },
    handlePhoneUpdate(phoneData) {
      this.customer.phoneE164 = phoneData.e164;
    },
    formatPhone(country, phone) {
      return formatPhoneDisplay(phone, country || 'US');
    },
    getInvoiceSource() {
      // Determine which source to use based on payment_settings.invoices_address_source
      if (this.payment_settings.invoices_address_source === 'group') {
        return JSON.parse(localStorage.getItem('group'));
      } else {
        return JSON.parse(localStorage.getItem('company'));
      }
    },

    getInvoiceCompanyName() {
      const source = this.getInvoiceSource();
      return source.name || '';
    },

    getInvoiceCompanyNumber() {
      const source = this.getInvoiceSource();
      return source.company_number || '';
    },

    getInvoiceAddress() {
      const source = this.getInvoiceSource();
      return source.address || source.address_line_1 || '';
    },

    getInvoiceAddressLine2() {
      const source = this.getInvoiceSource();
      return source.address_line_2 || '';
    },

    getInvoiceCity() {
      const source = this.getInvoiceSource();
      return source.city || '';
    },

    getInvoiceState() {
      const source = this.getInvoiceSource();
      return source.state || '';
    },

    getInvoiceZip() {
      const source = this.getInvoiceSource();
      return source.zip || '';
    },

    getInvoiceCountry() {
      const source = this.getInvoiceSource();
      return source.country || '';
    },

    getInvoicePhone() {
      const source = this.getInvoiceSource();
      return source.phone || this.company.phone || '';
    },
    getLinkedItem(item){
      let name = _.find(this.bookings, {id: item.item_id})
      if(name){
        return name.name ? name.name : this.getGiftCardCode(name.code)
      }

      return ''
    },
    isDate(date){
      const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
      return regex.test(date);
    },
    isTime(time){
      const regex = /^([01]\d|2[0-3]):[0-5]\d$/;
      return regex.test(time);
    },
    isOneSidedLogValue(item){
      return Boolean((item.new_value && !item.old_value) || (item.old_value && !item.new_value));
    },
    async viewActivityLog(item){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/' + item.id + '/log'

      this.loading = true
      axios.get(url, config)
        .then(response => {
          const root = document.getElementById('activityModal');
          window.requestAnimationFrame(() => {
            root.scrollTo({
              top: 600,
              left: 0,
              behavior: 'smooth',
            });
          });
          this.modals.view_booking_log = true
          this.booking_activity_log = response.data
          this.booking_activity_log_slot_id = item.id
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })

    },
    openAdjustGiftCardValueModal(item) {
      this.selectedGiftCardForAdjustment = { ...item }
      this.modals.adjust_gift_card_value = true
    },
    onGiftCardAdjusted() {
      this.getTransaction()
    },
    async viewGiftCardActivityLog(item) {
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/gifts/' + item.id + '/activity-log'

      this.gift_card_activity_log_code = this.getGiftCardCode(item.code)
      this.gift_card_activity_log_loading = true
      this.modals.view_gift_card_log = true
      this.gift_card_activity_log = []

      axios.get(url, config)
        .then(response => {
          this.gift_card_activity_log = response.data
          this.gift_card_activity_log_loading = false
        })
        .catch(err => {
          this.gift_card_activity_log_loading = false
          console.log(err)
          if (err.response && err.response.status == 401) {
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    calculateTotals(){
      if(this.selectedGiftCardType.value_type === 2){
        this.gift_card.total = this.gift_card.unit_value * this.gift_card.quantity
      }

      if(this.selectedGiftCardType.value_type === 0){
        if(isNaN(this.gift_card.custom_amount) || this.gift_card.custom_amount === ''){
          this.gift_card.custom_amount = 0
          this.gift_card.unit_price = 0
          this.gift_card.unit_value = 0
        }

        this.gift_card.unit_value = this.gift_card.custom_amount
        this.gift_card.total = this.gift_card.custom_amount * this.gift_card.quantity
      }
      if(this.selectedGiftCardType.value_type === 1){
        this.gift_card.unit_price = this.selectedGiftCardType.price
        this.gift_card.unit_value = this.selectedGiftCardType.redemption_amount
        this.gift_card.total = this.gift_card.unit_price * this.gift_card.quantity
      }
    },
    selectGiftCardType(){
      this.gift_card_designs = JSON.parse(this.selectedGiftCardType.designs)
      this.gift_card.design_url = this.gift_card_designs[0]

      if(this.selectedGiftCardType.value_type === 0 || this.selectedGiftCardType.value_type === 2){
        this.gift_card.custom_amount = ''
        this.gift_card.unit_value = 0
        this.gift_card.total = 0
        this.subtotal = 0
        this.total = 0
      }

      if(this.selectedGiftCardType.value_type === 1){
        this.calculateTotals()
      }
      if(this.selectedGiftCardType.value_type === 2){
        let filteredGames = this.getFilteredGames()
        if(filteredGames.length > 0){
          this.selectedGame = {
            id: filteredGames[0].id,
            name: filteredGames[0].name,
            cumulative_category_pricing: filteredGames[0].cumulative_category_pricing,
            game_pricing: filteredGames[0].game_pricing,
            pricing_type_id: filteredGames[0].pricing_type_id,
            pricing_categories: filteredGames[0].pricing_categories
          }
        } else {
          this.selectedGame = this.gift_card_games[0]
        }
        this.calculateGameValue()
      }

      this.gc_key++
    },
    getFilteredGames(){
      if(!this.selectedGiftCardType || this.selectedGiftCardType.value_type !== 2) return this.gift_card_games
      const linked = this.selectedGiftCardType.linked_game_ids
      if(!linked || linked.length === 0) return this.gift_card_games
      return this.gift_card_games.filter(g => linked.includes(g.id))
    },
    copyPaymentRequestLink(event){
      event.preventDefault()
      let url = 'https://offthecouch.io/pay/' + this.transaction.url_hash
      navigator.clipboard.writeText(url);
    },
    async copyWaiverLink(){
      let url = 'https://offthecouch.io/waiver/' + this.transaction.url_hash
      try {
        await navigator.clipboard.writeText(url)
        this.$notify({ type: 'success', message: 'Waiver link copied' })
      } catch (err) {
        this.$notify({ type: 'danger', message: 'Could not copy. Please try again.' })
      }
    },
    emailSettingActive(email_type){
      let setting = _.find(this.email_settings, {email_type: email_type})
      if(!setting){return false}
      return setting.is_active
    },
    refundEmailConfirmationPrompt(item){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This action will send a refund email to customer.",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.sendRefundEmail(item);
        }
      })
    },
    downloadTransactionPDF(){
      this.$refs.transactionPdf.generatePdf()
    },
    calculateGameValue(){
      this.gift_card.unit_value = 0
      this.number_of_players = 0
      if(this.selectedGame.cumulative_category_pricing){
        if(this.selectedGame.pricing_type_id === 1) {
          for (let m in this.selectedGame.pricing_categories) {
            this.number_of_players += this.selectedGame.pricing_categories[m].number_of_players
          }
          for (let m in this.selectedGame.pricing_categories) {
            for(let n in this.selectedGame.game_pricing){
              if(this.selectedGame.game_pricing[n].category_id === this.selectedGame.pricing_categories[m].category_id
                && this.number_of_players >= this.selectedGame.game_pricing[n].min_players
                && this.number_of_players <= this.selectedGame.game_pricing[n].max_players) {
                this.gift_card.unit_value += this.selectedGame.game_pricing[n].price * this.selectedGame.pricing_categories[m].number_of_players
                break
              }
            }
            let last_index = _.findLastKey(this.selectedGame.game_pricing, {category_id: this.selectedGame.pricing_categories[m].category_id})
            if(last_index && this.selectedGame.game_pricing[last_index] && this.number_of_players > this.selectedGame.game_pricing[last_index].max_players){
              this.gift_card.unit_value += this.selectedGame.game_pricing[last_index].price * this.selectedGame.pricing_categories[m].number_of_players
            }
            let smallest_price_category = _.find(this.selectedGame.game_pricing, {category_id : this.selectedGame.pricing_categories[m].category_id})
            if(smallest_price_category && this.number_of_players !== 0 &&
              this.number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += smallest_price_category.price * this.selectedGame.pricing_categories[m].number_of_players
            }
          }
        }
        else if(this.selectedGame.pricing_type_id === 2){
          for (let m in this.selectedGame.pricing_categories) {
            this.number_of_players += this.selectedGame.pricing_categories[m].number_of_players
          }
          for(let m in this.selectedGame.pricing_categories){
            // Empty categories are never sold; total headcount only picks the tier (OTC-2911)
            if(!(this.selectedGame.pricing_categories[m].number_of_players > 0)) continue
            for(let n in this.selectedGame.game_pricing){
              if(this.selectedGame.game_pricing[n].category_id === this.selectedGame.pricing_categories[m].category_id
                && this.number_of_players >= this.selectedGame.game_pricing[n].min_players
                && this.number_of_players <= this.selectedGame.game_pricing[n].max_players) {
                this.gift_card.unit_value += Number(this.selectedGame.game_pricing[n].price)
                break
              }
            }
            let last_index = _.findLastKey(this.selectedGame.game_pricing, {category_id: this.selectedGame.pricing_categories[m].category_id})
            if(last_index && this.selectedGame.game_pricing[last_index] && this.number_of_players > this.selectedGame.game_pricing[last_index].max_players){
              this.gift_card.unit_value += Number(this.selectedGame.game_pricing[last_index].price)
            }

            let smallest_price_category = _.find(this.selectedGame.game_pricing, {category_id : this.selectedGame.pricing_categories[m].category_id})
            if(smallest_price_category && this.number_of_players !== 0 &&
              this.number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += Number(smallest_price_category.price)
            }
          }
        }
      } else {
        if(this.selectedGame.pricing_type_id === 1){
          for(let m in this.selectedGame.pricing_categories){

            this.number_of_players += this.selectedGame.pricing_categories[m].number_of_players
            for(let n in this.selectedGame.game_pricing){
              if(this.selectedGame.game_pricing[n].category_id === this.selectedGame.pricing_categories[m].category_id
                && this.selectedGame.pricing_categories[m].number_of_players >= this.selectedGame.game_pricing[n].min_players
                && this.selectedGame.pricing_categories[m].number_of_players <= this.selectedGame.game_pricing[n].max_players) {
                this.gift_card.unit_value += this.selectedGame.game_pricing[n].price * this.selectedGame.pricing_categories[m].number_of_players
                break
              }
            }
            let last_index = _.findLastKey(this.selectedGame.game_pricing, {category_id: this.selectedGame.pricing_categories[m].category_id})
            if(last_index && this.selectedGame.game_pricing[last_index] && this.selectedGame.pricing_categories[m].number_of_players > this.selectedGame.game_pricing[last_index].max_players){
              this.gift_card.unit_value += this.selectedGame.game_pricing[last_index].price * this.selectedGame.pricing_categories[m].number_of_players
            }

            let smallest_price_category = _.find(this.selectedGame.game_pricing, {category_id : this.selectedGame.pricing_categories[m].category_id})
            if(smallest_price_category && this.selectedGame.pricing_categories[m].number_of_players !== 0 &&
              this.selectedGame.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += smallest_price_category.price * this.selectedGame.pricing_categories[m].number_of_players
            }
          }
        }
        else if(this.selectedGame.pricing_type_id === 2){
          for(let m in this.selectedGame.pricing_categories){
            this.number_of_players += this.selectedGame.pricing_categories[m].number_of_players
            for(let n in this.selectedGame.game_pricing){
              if(this.selectedGame.game_pricing[n].category_id === this.selectedGame.pricing_categories[m].category_id
                && this.selectedGame.pricing_categories[m].number_of_players >= this.selectedGame.game_pricing[n].min_players
                && this.selectedGame.pricing_categories[m].number_of_players <= this.selectedGame.game_pricing[n].max_players) {
                this.gift_card.unit_value += Number(this.selectedGame.game_pricing[n].price)
                break
              }
            }
            let last_index = _.findLastKey(this.selectedGame.game_pricing, {category_id: this.selectedGame.pricing_categories[m].category_id})
            if(last_index && this.selectedGame.game_pricing[last_index] && this.selectedGame.pricing_categories[m].number_of_players > this.selectedGame.game_pricing[last_index].max_players){
              this.gift_card.unit_value += Number(this.selectedGame.game_pricing[last_index].price)
            }

            let smallest_price_category = _.find(this.selectedGame.game_pricing, {category_id : this.selectedGame.pricing_categories[m].category_id})
            if(smallest_price_category && this.selectedGame.pricing_categories[m].number_of_players !== 0 &&
              this.selectedGame.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              this.gift_card.unit_value += Number(smallest_price_category.price)
            }
          }
        }
      }

      if(this.selectedGiftCardType.include_taxes_and_fees){
        this.gift_card.unit_value = calculateEventGiftCardValue({
          subtotal: this.gift_card.unit_value,
          taxes: this.game_taxes,
          fees: this.game_fees,
          numberOfPlayers: this.number_of_players,
          gameId: this.selectedGame ? this.selectedGame.id : null
        })
      }

      this.gift_card.total = this.gift_card.unit_value * this.gift_card.quantity

      this.calculateTotals()

    },
    getCategories(items){

      const groupedArray = [];

      items.forEach(item => {
        const { category_id, category, minimum_participants, default_participants } = item;

        // Find if the category_id already exists in groupedArray
        let group = groupedArray.find(g => g.category_id === category_id);

        if (!group) {
          // If it doesn't exist, create a new group
          group = {
            category_id: category_id,
            category: category,
            minimum_participants: minimum_participants,
            default_participants: default_participants,
            number_of_players: 1,
            pricing: []
          };
          groupedArray.push(group);
        }

        group.pricing.push(item);
      });

      // Sort by category_id to ensure consistent category order
      groupedArray.sort((a, b) => a.category_id - b.category_id);

      return groupedArray;
    },
    /**
     * Calculate what the price would be based on pricing rules
     * Used to detect if a stored price was overridden
     */
    calculatePriceFromRules(pricingRules, categoryId, numberOfPlayers, pricingTypeId, isCumulative, totalPlayers){
      if(!pricingRules || pricingRules.length === 0) return null

      // For cumulative pricing, use totalPlayers for tier lookup
      const playersForTierLookup = isCumulative ? totalPlayers : numberOfPlayers

      // Find applicable pricing rule for this category
      let applicablePrice = null

      for(let p of pricingRules){
        if(p.category_id === categoryId &&
           playersForTierLookup >= p.min_players &&
           playersForTierLookup <= p.max_players){
          applicablePrice = p.price
          break
        }
      }

      // Fallback: if no exact match, try largest tier
      if(applicablePrice === null){
        const categoryPricing = pricingRules.filter(p => p.category_id === categoryId)
        if(categoryPricing.length > 0){
          const lastTier = categoryPricing[categoryPricing.length - 1]
          if(playersForTierLookup > lastTier.max_players){
            applicablePrice = lastTier.price
          } else {
            // Use smallest tier
            applicablePrice = categoryPricing[0].price
          }
        }
      }

      if(applicablePrice === null) return null

      // Calculate final price based on pricing type
      if(pricingTypeId === 1){
        // Per-person pricing: price * number of players in this category
        return applicablePrice * numberOfPlayers
      } else {
        // Flat rate pricing: just the tier price
        return applicablePrice
      }
    },
    disabledDates(time) {
      let date = new Date();
      let previousDate = date.setDate(date.getDate() - 1);
      return time.getTime() < previousDate;
    },
    setDeliveryDate(){
      this.gift_card.delivery_date = new Date()
    },
    setGiftCardDesign(index){
      this.gift_card.design_url = this.gift_card_designs[index]
    },
    addGiftCard(event){
      event.preventDefault();
      this.getGiftCardSettings()

      // Determine starting step based on customer existence
      if (this.transaction.end_user_id) {
        this.giftCardStep = 2  // Customer exists - skip to gift card
      } else {
        this.giftCardStep = 1  // No customer - start at customer step
        // Pre-populate from transaction if partial data exists
        this.customer.first_name = this.transaction.first_name || ''
        this.customer.last_name = this.transaction.last_name || ''
        this.customer.email = this.transaction.email || ''
        this.customer.phone = this.transaction.phone || ''
      }

      this.modals.add_gift_card = true
    },
    // Validate customer fields for gift card step 1
    validateGiftCardCustomer() {
      let errors = 0

      if (!this.customer.first_name || this.customer.first_name.trim() === '') {
        this.errs.gc_customer_first_name = 'First name is required'
        errors++
      } else {
        this.errs.gc_customer_first_name = ''
      }

      if (!this.customer.last_name || this.customer.last_name.trim() === '') {
        this.errs.gc_customer_last_name = 'Last name is required'
        errors++
      } else {
        this.errs.gc_customer_last_name = ''
      }

      if (!this.customer.email || !isValidEmail(this.customer.email)) {
        this.errs.gc_customer_email = 'Valid email is required'
        errors++
      } else {
        this.errs.gc_customer_email = ''
      }

      return errors === 0
    },
    // Save customer and advance to step 2
    async saveCustomerAndContinue() {
      if (!this.validateGiftCardCustomer()) {
        return
      }

      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id

      let data = {
        first_name: this.customer.first_name,
        last_name: this.customer.last_name,
        phone: this.customer.phoneE164 || this.customer.phone,
        email: this.customer.email
      }

      this.giftCardCustomerLoading = true
      try {
        let response = await this.axios.put(url, data, config)
        // Update transaction data directly without triggering global loader
        this.transaction.first_name = this.customer.first_name
        this.transaction.last_name = this.customer.last_name
        this.transaction.email = this.customer.email
        this.transaction.phone = this.customer.phoneE164 || this.customer.phone
        if (response.data && response.data.end_user_id) {
          this.transaction.end_user_id = response.data.end_user_id
        }
        this.giftCardCustomerLoading = false
        this.giftCardStep = 2
      } catch (err) {
        this.giftCardCustomerLoading = false
        console.log(err)
        if (err.response && err.response.status == 401) {
          this.$router.push('/forbidden')
        } else {
          this.showAlertDialog('Error', 'Failed to save customer. Please try again.', 'danger')
        }
      }
    },
    // Reset modal state when closed
    resetGiftCardModal() {
      this.giftCardStep = 1
      this.giftCardCustomerLoading = false
      this.giftCardSettingsLoading = false
      this.errs.gc_customer_first_name = ''
      this.errs.gc_customer_last_name = ''
      this.errs.gc_customer_email = ''
      this.lookup_value = ''
    },
    addBooking(event){
      event.preventDefault();
      this.addBookingDrawerOpen = true
    },
    async getGiftCardSettings(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/gift-cards'
      this.giftCardSettingsLoading = true
      try {
        let response = await this.axios.get(url, config)
        this.giftCardSettingsLoading = false
        this.gift_card_settings = response.data.settings
        this.game_taxes = response.data.taxes
        this.game_fees = response.data.fees
        this.gift_card_types = response.data.gift_card_types
        for(let n in this.gift_card_types){
          if(typeof this.gift_card_types[n].linked_game_ids === 'string'){
            this.gift_card_types[n].linked_game_ids = JSON.parse(this.gift_card_types[n].linked_game_ids)
          }
          this.gift_card_types[n].game_display_mode = this.gift_card_types[n].game_display_mode || 0
        }
        this.gift_card_games = response.data.games
        this.selectedGiftCardType = this.gift_card_types.length > 0 ? this.gift_card_types[0] : ''
        if(this.selectedGiftCardType && this.selectedGiftCardType.designs){
          this.gift_card_designs = JSON.parse(this.selectedGiftCardType.designs)
          this.gift_card.design_url = this.gift_card_designs[0]
        }

        for(let n in this.gift_card_games){
          this.gift_card_games[n].game_pricing = JSON.parse(this.gift_card_games[n].game_pricing)
          this.gift_card_games[n].pricing_categories = this.getCategories(this.gift_card_games[n].game_pricing)
        }
        this.selectGiftCardType()
      } catch(err) {
        this.giftCardSettingsLoading = false
        console.log(err)
        if(err.response && err.response.status == 401){
          this.$router.push('/forbidden')
        } else {
          this.showAlertDialog('Error', 'Something went wrong', 'danger')
        }
      }
    },
    bookingCalendarLink(item){
      return bookingCalendarLink(item)
    },
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    capitalizeFirstLetter(string){
      if (!string) {
        return string;
      }
      string = string.replace(/_/g, ' ');
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    isCustomPaymentType(type){
      return type !== 'pos' && type !== 'customer_credit' && type !== 'cash'
        && type !== 'bank_transfer' && type !== 'gift_card' && type !== 'card'
    },
    isPaymentDateEditable(item){
      return item.type !== 'card' && item.type !== 'gift_card' && item.status === 1
    },
    initEditPaymentDate(payment, index){
      const tz = JSON.parse(localStorage.getItem('group')).tz_name
      const m = tz ? moment.utc(payment.timestamp).tz(tz) : moment(payment.timestamp)
      const year = m.year()
      const month = String(m.month() + 1).padStart(2, '0')
      const day = String(m.date()).padStart(2, '0')
      const wallClock = new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes())
      this.$set(this.editPaymentDateDate, index, `${year}-${month}-${day}`)
      this.$set(this.editPaymentDateTime, index, wallClock)
      this.$set(this.editPaymentDateError, index, '')
    },
    async updatePaymentDate(payment, index){
      this.editPaymentDateLoading = true
      try {
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId
          + '/payments/' + payment.id

        let datePart = this.editPaymentDateDate[index]
        let timePart = this.editPaymentDateTime[index]
        let hours = String(timePart.getHours()).padStart(2, '0')
        let minutes = String(timePart.getMinutes()).padStart(2, '0')
        const tz = JSON.parse(localStorage.getItem('group')).tz_name
        const localStr = `${datePart} ${hours}:${minutes}:00`
        let timestamp = (tz ? moment.tz(localStr, tz) : moment(localStr)).utc().format('YYYY-MM-DD HH:mm:ss')

        await axios.put(url, { timestamp: timestamp }, config)

        payment.timestamp = timestamp
        this.$set(this.showEditPaymentDate, index, false)
        this.$notify({
          type: 'success',
          message: 'Payment date updated',
          icon: 'tim-icons icon-check-2'
        })
      } catch (e) {
        let message = 'Something went wrong. Please try again.'
        if (e.response && e.response.data) {
          message = e.response.data
        }
        this.$set(this.editPaymentDateError, index, message)
      } finally {
        this.editPaymentDateLoading = false
      }
    },
    getDate(d){
      return formattedDate(this.date_format, d)
    },
    openPolicy(item){
      this.selectedPolicy = item.policy
      this.modals.policy = true
    },
    isRemovablePayment(item){
      if(item.type !== 'card' && item.type !== 'gift_card'){
        return true
      }
      return false
    },
    goToGame(item){
      this.$router.push({ path: '/games/history/instance', query: { id: item.game_instance_id }})
    },
    hasPassed(date){
      if(!date){
        return
      }
      let dt = new Date()
      let booking_date = new Date()
      booking_date.setFullYear(date.split('T')[0].split('-')[0])
      booking_date.setMonth(date.split('T')[0].split('-')[1] - 1, date.split('T')[0].split('-')[2])
      return dt > booking_date ? true : false
    },
    deletePaymentRecordPrompt(item, index){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This payment will no longer exist, and refunding the payment will no longer be possible",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.deletePaymentRecord(item);
        }
      })
    },
    async deletePaymentRecord(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments/' + item.id

      this.axios.delete(url, config)
        .then(response => {
          this.showAlertDialog('Success', 'The payment record has been deleted.', 'success');
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.showAlertDialog('Error', 'Something went wrong', 'danger');
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })

    },
    sendGiftCardEmailPrompt(item, event){
      event.preventDefault()
      if(!this.emailSettingActive('gift_card_confirmation')){
        return
      }
      let html = 'Completing this action will send a gift card purchase confirmation email.'
      let title = 'Send confirmation email'

      this.showConfirmDialog({
        title: title,
        message: html,
        variant: 'warning',
        confirmText: 'Send',
        onConfirm: () => {
          this.resendConfirmationEmail(item, 'gift_card');
        }
      })
    },
    sendReminderEmailPrompt(item, event){
      event.preventDefault()
      if(!this.transaction.email){
        return
      }
      this.confirmationDialog = {
        show: true,
        title: 'Send reminder email',
        message: 'This action will send a reminder email to ' + this.transaction.email + '.',
        variant: 'warning',
        showCancel: true,
        confirmText: 'Send',
        onConfirm: () => this.sendReminderEmail(item)
      }
    },
    sendFollowUpEmailPrompt(item, event){
      event.preventDefault()
      if(!this.transaction.email){
        return
      }
      this.confirmationDialog = {
        show: true,
        title: 'Send follow-up email',
        message: 'This action will send a follow-up email to ' + this.transaction.email + '.',
        variant: 'warning',
        showCancel: true,
        confirmText: 'Send',
        onConfirm: () => this.sendFollowUpEmail(item)
      }
    },
    showEmailSendSuccess(message){
      this.confirmationDialog = {
        show: true,
        title: 'Success',
        message: message,
        variant: 'success',
        showCancel: false,
        confirmText: 'OK',
        onConfirm: null
      }
    },
    showEmailSendError(err){
      let message = 'Something went wrong'
      const raw = err.response && err.response.data
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        if(parsed && parsed.error){
          message = parsed.error
        } else if(typeof raw === 'string' && raw.length < 240){
          message = raw
        }
      } catch(e){
        if(typeof raw === 'string' && raw.length < 240){
          message = raw
        }
      }
      this.confirmationDialog = {
        show: true,
        title: 'Email not sent',
        message: message,
        variant: 'danger',
        showCancel: false,
        confirmText: 'OK',
        onConfirm: null
      }
    },
    async sendRefundEmail(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments/' + item.id
      let data = {
        email: this.transaction.email,
        refund_amount: item.refunded
      }

      this.axios.post(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', "Refund email sent to customer", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async sendReminderEmail(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/reminder'
      let data = {
        email: this.transaction.email,
        booking_id: item.id
      }

      this.axios.post(url, data, config)
        .then(response => {
          this.showEmailSendSuccess("Reminder email sent to customer")
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showEmailSendError(err)
          }
        })
    },
    async sendFollowUpEmail(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/follow-up'
      let data = {
        email: this.transaction.email,
        booking_id: item.id
      }

      this.axios.post(url, data, config)
        .then(response => {
          this.showEmailSendSuccess("Follow-up email sent to customer")
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showEmailSendError(err)
          }
        })
    },
    deleteGiftCardPrompt(item){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This action will permanently delete the gift card. Any remaining balance must be refunded manually.",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.deleteGiftCard(item);
        }
      })
    },
    async deleteGiftCard(item){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/gift-cards/remove?id=' + item.id

      this.loading = true
      axios.delete(url, config)
        .then(response => {
          this.loading = false

          this.showAlertDialog('Success', "Gift card has been deleted", 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    deactivateGiftCardPrompt(item){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This action will deactivate the gift card without affecting the transaction balance.",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.deactivateGiftCard(item);
        }
      })
    },
    async deactivateGiftCard(item){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/gift-cards?id=' + item.id

      this.loading = true
      axios.delete(url, config)
        .then(response => {
          this.loading = false

          this.showAlertDialog('Success', "Gift card has been deactivated", 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    getGiftCardCode(code){
      if(!code){
        return
      }
      if(isNaN(code)){
        return code
      }
      let c = code.match(/.{1,4}/g);
      return c.join(' ')
    },
    overridePrice(item, source){

      if(source === 'new'){
        if(item.is_custom_pricing_enabled){
          for(let n in this.custom_pricing_categories){
            if(item.cumulative_category_pricing){
              //Price
              if(!this.custom_pricing_categories[n].hasOwnProperty('original_price')){
                for(let m in this.custom_pricing_categories[n].category_pricing){
                  if(item.number_of_players >= this.custom_pricing_categories[n].category_pricing[m].min_players
                    && item.number_of_players <= this.custom_pricing_categories[n].category_pricing[m].max_players){
                    this.custom_pricing_categories[n].original_price = this.custom_pricing_categories[n].category_pricing[m].price
                    this.custom_pricing_categories[n].price = this.custom_pricing_categories[n].category_pricing[m].price
                  }
                }
                let last_index = _.findLastKey(this.custom_pricing_categories[n].category_pricing)
                if(last_index && item.number_of_players > this.custom_pricing_categories[n].category_pricing[last_index].max_players){
                  this.custom_pricing_categories[n].original_price = this.custom_pricing_categories[n].category_pricing[last_index].price
                  this.custom_pricing_categories[n].price = this.custom_pricing_categories[n].category_pricing[last_index].price
                }
                let smallest_price_category = _.find(this.custom_pricing_categories[n].category_pricing)
                if(smallest_price_category && item.number_of_players !== 0 &&
                  item.number_of_players < smallest_price_category.min_players){
                  this.custom_pricing_categories[n].original_price = smallest_price_category.price
                  this.custom_pricing_categories[n].price = smallest_price_category.price
                }
              }
              //Original price
              if(this.custom_pricing_categories[n].hasOwnProperty('original_price')){
                for(let m in this.custom_pricing_categories[n].category_pricing){
                  if(item.number_of_players >= this.custom_pricing_categories[n].category_pricing[m].min_players
                    && item.number_of_players <= this.custom_pricing_categories[n].category_pricing[m].max_players){
                    this.custom_pricing_categories[n].original_price = this.custom_pricing_categories[n].category_pricing[m].price
                  }
                }

                let last_index = _.findLastKey(this.custom_pricing_categories[n].category_pricing)
                if(last_index && item.number_of_players > this.custom_pricing_categories[n].category_pricing[last_index].max_players){
                  this.custom_pricing_categories[n].original_price = this.custom_pricing_categories[n].category_pricing[last_index].price
                }
                let smallest_price_category = _.find(this.custom_pricing_categories[n].category_pricing)
                if(smallest_price_category && item.number_of_players !== 0 &&
                  this.number_of_players < smallest_price_category.min_players){
                  this.custom_pricing_categories[n].original_price = smallest_price_category.price
                }
              }
            }
            else {
              for(let m in this.custom_pricing_categories[n].category_pricing){
                if(this.custom_pricing_categories[n].number_of_players >= this.custom_pricing_categories[n].category_pricing[m].min_players
                  && this.custom_pricing_categories[n].number_of_players <= this.custom_pricing_categories[n].category_pricing[m].max_players) {
                  this.custom_pricing_categories[n].original_price = this.custom_pricing_categories[n].category_pricing[m].price
                  this.custom_pricing_categories[n].price = this.custom_pricing_categories[n].category_pricing[m].price
                }
              }
              let last_index = _.findLastKey(this.custom_pricing_categories[n].category_pricing)
              if(last_index && this.custom_pricing_categories[n].number_of_players > this.custom_pricing_categories[n].category_pricing[last_index].max_players){
                this.custom_pricing_categories[n].original_price = this.custom_pricing_categories[n].category_pricing[last_index].price
                this.custom_pricing_categories[n].price = this.custom_pricing_categories[n].category_pricing[last_index].price
              }

              let smallest_price_category = _.find(this.custom_pricing_categories[n].category_pricing)
              if(smallest_price_category && this.custom_pricing_categories[n].number_of_players !== 0 &&
                this.custom_pricing_categories[n].number_of_players < smallest_price_category.min_players){
                this.custom_pricing_categories[n].original_price = smallest_price_category.price
                this.custom_pricing_categories[n].price = smallest_price_category.price
              }
            }
          }
        } else {
          for(let n in this.pricing_categories){
            if(item.cumulative_category_pricing){
              if(!this.pricing_categories[n].hasOwnProperty('original_price')){
                for(let m in this.pricing_categories[n].category_pricing){
                  if(item.number_of_players >= this.pricing_categories[n].category_pricing[m].min_players
                    && item.number_of_players <= this.pricing_categories[n].category_pricing[m].max_players){
                    this.pricing_categories[n].original_price = this.pricing_categories[n].category_pricing[m].price
                    this.pricing_categories[n].price = this.pricing_categories[n].category_pricing[m].price
                  }
                }
                let last_index = _.findLastKey(this.pricing_categories[n].category_pricing)
                if(last_index && item.number_of_players > this.pricing_categories[n].category_pricing[last_index].max_players){
                  this.pricing_categories[n].original_price = this.pricing_categories[n].category_pricing[last_index].price
                  this.pricing_categories[n].price = this.pricing_categories[n].category_pricing[last_index].price
                }
                let smallest_price_category = _.find(this.pricing_categories[n].category_pricing)
                if(smallest_price_category && item.number_of_players !== 0 &&
                  item.number_of_players < smallest_price_category.min_players){
                  this.pricing_categories[n].original_price = smallest_price_category.price
                  this.pricing_categories[n].price = smallest_price_category.price
                }
              }
              //Original price
              if(this.pricing_categories[n].hasOwnProperty('original_price')){
                for(let m in this.pricing_categories[n].category_pricing){
                  if(item.number_of_players >= this.pricing_categories[n].category_pricing[m].min_players
                    && item.number_of_players <= this.pricing_categories[n].category_pricing[m].max_players){
                    this.pricing_categories[n].original_price = this.pricing_categories[n].category_pricing[m].price
                  }
                }

                let last_index = _.findLastKey(this.pricing_categories[n].category_pricing)
                if(last_index && item.number_of_players > this.pricing_categories[n].category_pricing[last_index].max_players){
                  this.pricing_categories[n].original_price = this.pricing_categories[n].category_pricing[last_index].price
                }
                let smallest_price_category = _.find(this.pricing_categories[n].category_pricing)
                if(smallest_price_category && item.number_of_players !== 0 &&
                  item.number_of_players < smallest_price_category.min_players){
                  this.pricing_categories[n].original_price = smallest_price_category.price
                }
              }
            } else {
              for(let m in this.pricing_categories[n].category_pricing){
                if(this.pricing_categories[n].number_of_players >= this.pricing_categories[n].category_pricing[m].min_players
                  && this.pricing_categories[n].number_of_players <= this.pricing_categories[n].category_pricing[m].max_players) {
                  this.pricing_categories[n].original_price = this.pricing_categories[n].category_pricing[m].price
                  this.pricing_categories[n].price = this.pricing_categories[n].category_pricing[m].price
                }
              }
              let last_index = _.findLastKey(this.pricing_categories[n].category_pricing)
              if(last_index && this.pricing_categories[n].number_of_players > this.pricing_categories[n].category_pricing[last_index].max_players){
                this.pricing_categories[n].original_price = this.pricing_categories[n].category_pricing[last_index].price
                this.pricing_categories[n].price = this.pricing_categories[n].category_pricing[last_index].price
              }

              let smallest_price_category = _.find(this.pricing_categories[n].category_pricing)
              if(smallest_price_category && this.pricing_categories[n].number_of_players !== 0 &&
                this.pricing_categories[n].number_of_players < smallest_price_category.min_players){
                this.pricing_categories[n].original_price = smallest_price_category.price
                this.pricing_categories[n].price = smallest_price_category.price
              }
            }
          }
        }
      } else {
        for(let n in item.pricing_categories){
          // If category_pricing is not available, set original_price to current price for simple override
          if(!item.pricing_categories[n].category_pricing){
            if(!item.pricing_categories[n].hasOwnProperty('original_price')){
              item.pricing_categories[n].original_price = item.pricing_categories[n].price
            }
            continue;
          }
          if(item.cumulative_category_pricing){
            if(!item.pricing_categories[n].hasOwnProperty('original_price')){
              for(let m in item.pricing_categories[n].category_pricing){
                if(item.number_of_players >= item.pricing_categories[n].category_pricing[m].min_players
                  && item.number_of_players <= item.pricing_categories[n].category_pricing[m].max_players){
                  item.pricing_categories[n].original_price = item.pricing_categories[n].category_pricing[m].price
                  item.pricing_categories[n].price = item.pricing_categories[n].category_pricing[m].price
                }
              }
              let last_index = _.findLastKey(item.pricing_categories[n].category_pricing)
              if(last_index && item.number_of_players > item.pricing_categories[n].category_pricing[last_index].max_players){
                item.pricing_categories[n].original_price = item.pricing_categories[n].category_pricing[last_index].price
                item.pricing_categories[n].price = item.pricing_categories[n].category_pricing[last_index].price
              }
              let smallest_price_category = _.find(item.pricing_categories[n].category_pricing)
              if(smallest_price_category && item.number_of_players !== 0 &&
                item.number_of_players < smallest_price_category.min_players){
                item.pricing_categories[n].original_price = smallest_price_category.price
                item.pricing_categories[n].price = smallest_price_category.price
              }
            }
            //Original price
            if(item.pricing_categories[n].hasOwnProperty('original_price')){
              for(let m in item.pricing_categories[n].category_pricing){
                if(item.number_of_players >= item.pricing_categories[n].category_pricing[m].min_players
                  && item.number_of_players <= item.pricing_categories[n].category_pricing[m].max_players){
                  item.pricing_categories[n].original_price = item.pricing_categories[n].category_pricing[m].price
                }
              }

              let last_index = _.findLastKey(item.pricing_categories[n].category_pricing)
              if(last_index && item.number_of_players > item.pricing_categories[n].category_pricing[last_index].max_players){
                item.pricing_categories[n].original_price = item.pricing_categories[n].category_pricing[last_index].price
              }
              let smallest_price_category = _.find(item.pricing_categories[n].category_pricing)
              if(smallest_price_category && item.number_of_players !== 0 &&
                item.number_of_players < smallest_price_category.min_players){
                item.pricing_categories[n].original_price = smallest_price_category.price
              }
            }
          } else {
            for(let m in item.pricing_categories[n].category_pricing){
              if(item.pricing_categories[n].number_of_players >= item.pricing_categories[n].category_pricing[m].min_players
                && item.pricing_categories[n].number_of_players <= item.pricing_categories[n].category_pricing[m].max_players) {
                item.pricing_categories[n].original_price = item.pricing_categories[n].category_pricing[m].price
                item.pricing_categories[n].price = item.pricing_categories[n].category_pricing[m].price
              }
            }
            let last_index = _.findLastKey(item.pricing_categories[n].category_pricing)
            if(last_index && item.pricing_categories[n].number_of_players > item.pricing_categories[n].category_pricing[last_index].max_players){
              item.pricing_categories[n].original_price = item.pricing_categories[n].category_pricing[last_index].price
              item.pricing_categories[n].price = item.pricing_categories[n].category_pricing[last_index].price
            }

            let smallest_price_category = _.find(item.pricing_categories[n].category_pricing)
            if(smallest_price_category && item.pricing_categories[n].number_of_players !== 0 &&
              item.pricing_categories[n].number_of_players < smallest_price_category.min_players){
              item.pricing_categories[n].original_price = smallest_price_category.price
              item.pricing_categories[n].price = smallest_price_category.price
            }
          }
        }
      }

      this.$set(item, 'price_override', true)
      this.pr_key++
    },
    saveOverride(item, source){
      if(source === 'new'){
        if(item.is_custom_pricing_enabled){
          for(let n in this.custom_pricing_categories){
            if(this.custom_pricing_categories[n].hasOwnProperty('original_price') &&
              this.custom_pricing_categories[n].original_price  === this.custom_pricing_categories[n].price){
              delete this.custom_pricing_categories[n].original_price
            }
          }
        } else {
          for(let n in this.pricing_categories){
            if(this.pricing_categories[n].hasOwnProperty('original_price') &&
              this.pricing_categories[n].original_price  === this.pricing_categories[n].price){
              delete this.pricing_categories[n].original_price
            }
          }
        }
      } else {
        // Don't delete original_price - we need to keep it to indicate an override is in place
        // The presence of original_price tells getSubtotal to use the custom price
      }

      this.getSubtotal(item, source)
      this.$set(item, 'price_override', false)
      this.pr_key++
    },
    setOriginalPrice(category){
      category.price = category.original_price
      this.pr_key++
    },
    getSubtotal(item, source){

      // Buyout upgrade: flat fee, independent of category quantities. Tickets+fee
      // upgrades fall through to the normal per-category calc below; the fixed
      // private fee is added at the end of this function.
      if (item.is_reservation_upgraded && item.reservation_upgrade_pricing_mode !== 'tickets_plus_fee') {
        item.number_of_players = 0
        for (let m in item.pricing_categories) {
          item.number_of_players += item.pricing_categories[m].number_of_players || 0
        }

        // Calculate group_size for the update
        item.group_size = item.number_of_players

        // Keep the flat reservation upgrade price (it doesn't change based on category quantities)
        item.subtotal = item.reservation_upgrade_price || 0
        this.pr_key++
        return
      }

      let pricing = []
      let pricing_type_id = ''
      let cumulative_category_pricing = ''
      if(source === 'new'){
        pricing = filterPricingByDuration(item.is_custom_pricing_enabled ? item.custom_pricing : item.pricing, null)
        item.pricing_categories = item.is_custom_pricing_enabled ? this.custom_pricing_categories : this.pricing_categories
        pricing_type_id = item.is_custom_pricing_enabled ? item.slot_pricing_type_id : item.pricing_type_id
        cumulative_category_pricing = item.is_custom_pricing_enabled ? item.slot_cumulative_category_pricing : item.cumulative_category_pricing
      } else {
        // Handle both string and already-parsed pricing data
        if(item.is_custom_pricing_enabled){
          pricing = typeof item.custom_pricing === 'string' ? JSON.parse(item.custom_pricing) : item.custom_pricing
        } else {
          pricing = typeof item.game_pricing === 'string' ? JSON.parse(item.game_pricing) : item.game_pricing
        }
        pricing_type_id =  item.is_custom_pricing_enabled ? item.slot_pricing_type_id : item.pricing_type_id
        cumulative_category_pricing = item.is_custom_pricing_enabled ?  item.slot_cumulative_category_pricing : item.cumulative_category_pricing
      }

      // Ensure pricing is an array
      if(!pricing || !Array.isArray(pricing)){
        pricing = []
      }

      item.subtotal = 0
      item.number_of_players = 0

      if(cumulative_category_pricing){
        if(pricing_type_id === 1){
          for (let m in item.pricing_categories) {
            item.number_of_players += item.pricing_categories[m].number_of_players
          }
          for(let m in item.pricing_categories){
            // Use category-specific pricing if available (from getTickets API for public child bookings)
            // Otherwise fall back to the main pricing array
            let categoryPricing = item.pricing_categories[m].category_pricing
                               || item.pricing_categories[m].pricing
                               || pricing

            let priceAdded = false
            for(let n in categoryPricing){
              if(categoryPricing[n].category_id === item.pricing_categories[m].category_id
                && item.number_of_players >= categoryPricing[n].min_players
                && item.number_of_players <= categoryPricing[n].max_players) {
                if(item.pricing_categories[m].hasOwnProperty('original_price')){
                  item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
                } else {
                  item.subtotal += categoryPricing[n].price * item.pricing_categories[m].number_of_players
                }
                priceAdded = true
                break
              }
            }

            let last_index = _.findLastKey(categoryPricing, {category_id: item.pricing_categories[m].category_id})
            if(!priceAdded && last_index && categoryPricing[last_index] && item.number_of_players > categoryPricing[last_index].max_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
              } else {
                item.subtotal += categoryPricing[last_index].price * item.pricing_categories[m].number_of_players
              }
              priceAdded = true
            }

            let smallest_price_category = _.find(categoryPricing, {category_id : item.pricing_categories[m].category_id})
            if(!priceAdded && smallest_price_category && item.number_of_players !== 0 &&
              item.number_of_players < smallest_price_category.min_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
              } else {
                item.subtotal += smallest_price_category.price * item.pricing_categories[m].number_of_players
              }
              priceAdded = true
            }

            // Fallback: if price override exists but no pricing tier matched, use the override price
            if(!priceAdded && item.pricing_categories[m].hasOwnProperty('original_price')){
              item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
            }
          }
        }
        else if(pricing_type_id === 2){
          for (let m in item.pricing_categories) {
            item.number_of_players += item.pricing_categories[m].number_of_players
          }
          for(let m in item.pricing_categories){
            // Empty categories are never sold; total headcount only picks the tier (OTC-2911)
            if(!(item.pricing_categories[m].number_of_players > 0)) continue
            // Use category-specific pricing if available (from getTickets API for public child bookings)
            // Otherwise fall back to the main pricing array
            let categoryPricing = item.pricing_categories[m].category_pricing
                               || item.pricing_categories[m].pricing
                               || pricing

            let priceAdded = false
            for(let n in categoryPricing){
              if(categoryPricing[n].category_id === item.pricing_categories[m].category_id
                && item.number_of_players >= categoryPricing[n].min_players
                && item.number_of_players <= categoryPricing[n].max_players) {
                if(item.pricing_categories[m].hasOwnProperty('original_price')){
                  item.subtotal += Number(item.pricing_categories[m].price)
                } else {
                  item.subtotal += Number(categoryPricing[n].price)
                }
                priceAdded = true
                break
              }
            }
            let last_index = _.findLastKey(categoryPricing, {category_id: item.pricing_categories[m].category_id})
            if(!priceAdded && last_index && categoryPricing[last_index] && item.number_of_players > categoryPricing[last_index].max_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += Number(item.pricing_categories[m].price)
              } else {
                item.subtotal += Number(categoryPricing[last_index].price)
              }
              priceAdded = true
            }

            let smallest_price_category = _.find(categoryPricing, {category_id : item.pricing_categories[m].category_id})
            if(!priceAdded && smallest_price_category && item.number_of_players !== 0 &&
              item.number_of_players < smallest_price_category.min_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += Number(item.pricing_categories[m].price)
              } else {
                item.subtotal += Number(smallest_price_category.price)
              }
              priceAdded = true
            }

            // Fallback: if price override exists but no pricing tier matched, use the override price
            if(!priceAdded && item.pricing_categories[m].hasOwnProperty('original_price')){
              item.subtotal += Number(item.pricing_categories[m].price)
            }
          }
        }
      } else {
        if(pricing_type_id === 1){
          for(let m in item.pricing_categories){
            item.number_of_players += item.pricing_categories[m].number_of_players
            // Use category-specific pricing if available (from getTickets API for public child bookings)
            // Otherwise fall back to the main pricing array
            let categoryPricing = item.pricing_categories[m].category_pricing
                               || item.pricing_categories[m].pricing
                               || pricing

            let priceAdded = false
            for(let n in categoryPricing){
              if(categoryPricing[n].category_id === item.pricing_categories[m].category_id
                && item.pricing_categories[m].number_of_players >= categoryPricing[n].min_players
                && item.pricing_categories[m].number_of_players <= categoryPricing[n].max_players) {
                if(item.pricing_categories[m].hasOwnProperty('original_price')){
                  item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
                } else {
                  item.subtotal += categoryPricing[n].price * item.pricing_categories[m].number_of_players
                }
                priceAdded = true
                break
              }
            }

            let last_index = _.findLastKey(categoryPricing, {category_id: item.pricing_categories[m].category_id})
            if(!priceAdded && last_index && categoryPricing[last_index] && item.pricing_categories[m].number_of_players > categoryPricing[last_index].max_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
              } else {
                item.subtotal += categoryPricing[last_index].price * item.pricing_categories[m].number_of_players
              }
              priceAdded = true
            }

            let smallest_price_category = _.find(categoryPricing, {category_id : item.pricing_categories[m].category_id})
            if(!priceAdded && smallest_price_category && item.pricing_categories[m].number_of_players !== 0 &&
              item.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
              } else {
                item.subtotal += smallest_price_category.price * item.pricing_categories[m].number_of_players
              }
              priceAdded = true
            }

            // Fallback: if price override exists but no pricing tier matched, use the override price
            if(!priceAdded && item.pricing_categories[m].hasOwnProperty('original_price')){
              item.subtotal += item.pricing_categories[m].price * item.pricing_categories[m].number_of_players
            }
          }
        }
        else if(pricing_type_id === 2){
          for(let m in item.pricing_categories){
            item.number_of_players += item.pricing_categories[m].number_of_players
            // Use category-specific pricing if available (from getTickets API for public child bookings)
            // Otherwise fall back to the main pricing array
            let categoryPricing = item.pricing_categories[m].category_pricing
                               || item.pricing_categories[m].pricing
                               || pricing

            let priceAdded = false
            for(let n in categoryPricing){
              if(categoryPricing[n].category_id === item.pricing_categories[m].category_id
                && item.pricing_categories[m].number_of_players >= categoryPricing[n].min_players
                && item.pricing_categories[m].number_of_players <= categoryPricing[n].max_players) {
                if(item.pricing_categories[m].hasOwnProperty('original_price')){
                  item.subtotal += Number(item.pricing_categories[m].price)
                } else {
                  item.subtotal += Number(categoryPricing[n].price)
                }
                priceAdded = true
                break
              }
            }
            let last_index = _.findLastKey(categoryPricing, {category_id: item.pricing_categories[m].category_id})
            if(!priceAdded && last_index && categoryPricing[last_index] && item.pricing_categories[m].number_of_players > categoryPricing[last_index].max_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += Number(item.pricing_categories[m].price)
              } else {
                item.subtotal += Number(categoryPricing[last_index].price)
              }
              priceAdded = true
            }

            let smallest_price_category = _.find(categoryPricing, {category_id : item.pricing_categories[m].category_id})
            if(!priceAdded && smallest_price_category && item.pricing_categories[m].number_of_players !== 0 &&
              item.pricing_categories[m].number_of_players < smallest_price_category.min_players){
              if(item.pricing_categories[m].hasOwnProperty('original_price')){
                item.subtotal += Number(item.pricing_categories[m].price)
              } else {
                item.subtotal += Number(smallest_price_category.price)
              }
              priceAdded = true
            }

            // Fallback: if price override exists but no pricing tier matched, use the override price
            if(!priceAdded && item.pricing_categories[m].hasOwnProperty('original_price')){
              item.subtotal += Number(item.pricing_categories[m].price)
            }
          }
        }
      }

      // tickets+fee upgrade: add the fixed private booking fee on top of the
      // recomputed per-ticket subtotal (single source of truth: applyPrivateUpgrade).
      if (item.is_reservation_upgraded && item.reservation_upgrade_pricing_mode === 'tickets_plus_fee') {
        item.group_size = item.number_of_players
        item.subtotal = roundCents(applyPrivateUpgrade({ baseSubtotal: item.subtotal, mode: 'tickets_plus_fee', fee: item.private_booking_fee || 0 }))
      }

      this.pr_key++
    },
    getRate(item, game, source){
      let pricing = []
      let pricing_type_id = ''
      let cumulative_category_pricing = ''
      if(source === 'new'){
        pricing = filterPricingByDuration(game.is_custom_pricing_enabled ? game.custom_pricing : game.pricing, null)
        pricing_type_id = game.is_custom_pricing_enabled ? game.slot_pricing_type_id : game.pricing_type_id
        cumulative_category_pricing = game.is_custom_pricing_enabled ? game.slot_cumulative_category_pricing : game.cumulative_category_pricing

      } else {
        let pricingStr = game.is_custom_pricing_enabled ? game.custom_pricing : game.game_pricing
        pricing = pricingStr ? JSON.parse(pricingStr) : []
        pricing_type_id = game.is_custom_pricing_enabled ? game.slot_pricing_type_id : game.pricing_type_id
        cumulative_category_pricing = game.is_custom_pricing_enabled ? game.slot_cumulative_category_pricing : game.cumulative_category_pricing
      }
      // Use category-specific pricing if available (from getTickets API for public child bookings)
      // This takes priority over the main pricing array
      if(item.category_pricing && item.category_pricing.length > 0){
        pricing = item.category_pricing
      } else if(item.archived && item.pricing){
        pricing = item.pricing
      }
      // Ensure pricing is always an array
      if(!pricing || !Array.isArray(pricing)){
        pricing = []
      }

      if(cumulative_category_pricing){
        for(let n in pricing){
          if(pricing[n].category_id === item.category_id
            && game.number_of_players >= pricing[n].min_players
            && game.number_of_players <= pricing[n].max_players) {
            if(item.hasOwnProperty('original_price')){
              return pricing_type_id === 1 ? this.getAmount(item.price) + ` per ` + item.category
                : this.getAmount(item.price) + ' for ' + item.category + ' (' + pricing[n].min_players + '-' + pricing[n].max_players + ' players)'
            } else {
              return pricing_type_id === 1 ? this.getAmount(pricing[n].price) + ` per ` + item.category
                : this.getAmount(pricing[n].price) + ' for ' + item.category + ' (' + pricing[n].min_players + '-' + pricing[n].max_players + ' players)'
            }

          }
        }
        let last_index = _.findLastKey(pricing, {category_id: item.category_id})
        if(last_index && game.number_of_players > pricing[last_index].max_players){
          if(item.hasOwnProperty('original_price')){
            return pricing_type_id === 1 ? this.getAmount(item.price) + ` per ` + item.category
              : this.getAmount(item.price) + ' for ' + item.category + ' (' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' players)'
          } else {
            return pricing_type_id === 1 ? this.getAmount(pricing[last_index].price) + ` per ` + item.category
              : this.getAmount(pricing[last_index].price) + ' for ' + item.category + ' (' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' players)'
          }
        }

        let smallest_price_category = _.find(pricing, {category_id : item.category_id})
        if(smallest_price_category && game.number_of_players !== 0 &&
          game.number_of_players < smallest_price_category.min_players){
          if(item.hasOwnProperty('original_price')){
            return pricing_type_id === 1 ? this.getAmount(item.price) + ` per ` + item.category
              : this.getAmount(item.price) + ' for ' + item.category + ' (' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' players)'
          } else {
            return pricing_type_id === 1 ? this.getAmount(smallest_price_category.price) + ` per ` + item.category
              : this.getAmount(smallest_price_category.price) + ' for ' + item.category + ' (' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' players)'
          }

        }
      } else {
        for(let n in pricing){

          if(pricing[n].category_id === item.category_id
            && item.number_of_players >= pricing[n].min_players
            && item.number_of_players <= pricing[n].max_players) {
            if(item.hasOwnProperty('original_price')){
              return pricing_type_id === 1 ? this.getAmount(item.price) + ` per ` + item.category
                : this.getAmount(item.price) + ' for ' + item.category + ' (' + pricing[n].min_players + '-' + pricing[n].max_players + ' players)'
            } else {
              return pricing_type_id === 1 ? this.getAmount(pricing[n].price) + ` per ` + item.category
                : this.getAmount(pricing[n].price) + ' for ' + item.category + ' (' + pricing[n].min_players + '-' + pricing[n].max_players + ' players)'
            }

          }
        }
        let last_index = _.findLastKey(pricing, {category_id: item.category_id})
        if(last_index && pricing[last_index] && item.number_of_players > pricing[last_index].max_players){
          if(item.hasOwnProperty('original_price')){
            return pricing_type_id === 1 ? this.getAmount(item.price) + ` per ` + item.category
              : this.getAmount(item.price) + ' for ' + item.category + ' (' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' players)'
          } else {
            return pricing_type_id === 1 ? this.getAmount(pricing[last_index].price) + ` per ` + item.category
              : this.getAmount(pricing[last_index].price) + ' for ' + item.category + ' (' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' players)'
          }

        }

        let smallest_price_category = _.find(pricing, {category_id : item.category_id})
        if(smallest_price_category && item.number_of_players !== 0 &&
          item.number_of_players < smallest_price_category.min_players){
          if(item.hasOwnProperty('original_price')){
            return pricing_type_id === 1 ? this.getAmount(item.price) + ` per ` + item.category
              : this.getAmount(item.price) + ' for ' + item.category + ' (' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' players)'
          } else {
            return pricing_type_id === 1 ? this.getAmount(smallest_price_category.price) + ` per ` + item.category
              : this.getAmount(smallest_price_category.price) + ' for ' + item.category + ' (' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' players)'
          }

        }
      }

      return ''
    },

    deleteItemPrompt(item){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "The item will be removed from the transaction",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.deleteItem(item);
        }
      })
    },
    async deleteItem(item){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      //validate
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/items?id=' + item.id

      this.loading = true
      axios.delete(url, config)
        .then(response => {
          this.loading = false

          this.showAlertDialog('Success', "Item has been removed from the transaction", 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    validateCustomPurchase(item){
      let errors = 0
      if(item.name === ''){
        this.errs.purchase.name = 'Purchase name cannot be empty'
        errors++
      } else {
        this.errs.purchase.name = ''
      }

      if(isNaN(item.price) || item.price < 0 || item.price === ''){
        this.errs.purchase.price = 'Invalid price'
        errors++
      } else {
        this.errs.purchase.price = ''
      }

      if(errors > 0){
        return false
      }
      return true
    },
    validatePurchase(item){
      let errors = 0
      if(!item.unlimited_available_quantity && !item.is_custom && item.quantity > item.available){
        this.errs.purchase.quantity = 'Quantity exceeds number of available items'
        errors++
      } else {
        this.errs.purchase.quantity = ''
      }

      if(isNaN(item.price) || item.price < 0 || item.price === '' || item.price === null){
        this.errs.purchase.price = 'Invalid price'
        errors++
      } else {
        this.errs.purchase.price = ''
      }

      if(errors > 0){
        return false
      }
      return true
    },
    validateGiftCardForm(){
      let errors = 0

      if(this.gift_card.custom_code == 1 && this.gift_card.code === ''){
        this.errs.custom_code = 'Gift card code cannot be empty'
        errors++
      } else if(this.gift_card.custom_code == 1 && this.gift_card.quantity > 1){
        this.errs.custom_code = 'You are trying to create more than one gift card with the same custom code. Code must be unique.'
        errors++
      } else if(this.gift_card.custom_code == 1 && this.gift_card.code.indexOf(' ') >= 0){
        this.errs.custom_code = 'Gift card code cannot have spaces'
        errors++
      }
      else {
        this.errs.custom_code = ''
      }

      if(this.gift_card.recipient_first_name === ''){
        this.errs.recipient_first_name = 'Recipient first name cannot be empty'
        errors++
      } else {
        this.errs.recipient_first_name = ''
      }

      if(this.gift_card.recipient_last_name === ''){
        this.errs.recipient_last_name = 'Recipient last name cannot be empty'
        errors++
      } else {
        this.errs.recipient_last_name = ''
      }

      if(this.gift_card.recipient_email === ''){
        this.errs.recipient_email = 'Recipient email cannot be empty'
        errors++
      } else {
        this.errs.recipient_email = ''
      }

      return errors > 0 ? false : true

    },
    async sendGiftCardEmail(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/gift-cards'
      let data = {
        email: JSON.parse(item.recipients)[0].email,
        gift_card_id: item.id
      }

      this.axios.post(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', "Gift card delivery email sent to customer", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async createGiftCard(){
      if(this.send_gift_card_to_self){
        this.gift_card.recipient_first_name = this.transaction.first_name
        this.gift_card.recipient_last_name = this.transaction.last_name
        this.gift_card.recipient_email = this.transaction.email
      }
      if(!this.validateGiftCardForm()){
        return
      }
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      //validate
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/gift-cards'
      this.gift_card.gift_card_type_id = this.selectedGiftCardType.id
      this.gift_card.price = this.gift_card.unit_price
      this.gift_card.delivery_date = moment(this.gift_card.delivery_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
      let data = {
        gift_card: this.gift_card
      }

      this.loading = true
      axios.put(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.add_gift_card = false
          this.gift_card = {
            custom_code: 0,
            code: '',
            personal_message: '',
            design_url: '',
            custom_amount: '',
            recipient_first_name: '',
            recipient_last_name: '',
            recipient_email: '',
            total: {amount: 0},
            quantity: 1,
            send_instantly: 1,
            delivery_date: new Date()
          }
          this.send_gift_card_to_self = false
          this.showAlertDialog('Success', "Gift card has been added to the transaction", 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async createCustomPurchase(){
      if(!this.validateCustomPurchase(this.purchase)){
        return
      }

      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      //validate
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/items'
      let data = this.purchase
      data.amount = this.getPurchaseAmount(this.purchase.price, this.purchase.quantity)

      this.loading = true
      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.modals.add_item = false
          this.modals.custom_purchase = false
          this.purchase = {
            name: '',
            description: '',
            amount: '',
            quantity: '',
            price: 0
          }
          this.showAlertDialog('Success', "Custom purchase has been added to the transaction", 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    getPurchaseAmount(price, quantity){
      return price * quantity
    },
    async applyTax(){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      //validate
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/taxes'
      let html = "Tax has been added to the transaction"
      let data = this.selectedTax

      if(this.tax_fee_type.id === 0){
        data.total_amount = this.totalTaxAmount
        data.tax_links = this.taxLinks
        if(this.selectedTax == ''){
          this.errs.tax = 'You must select a tax'
          return
        } else {
          this.errs.tax = ''
        }
      } else if(this.tax_fee_type.id === 1) {
        url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
          '/transactions/' + this.transaction.id + '/fees'
        html = "Fee has been added to the transaction"
        data = this.selectedFee
        data.total_amount = this.totalFeeAmount
        data.fee_links = this.feeLinks
        if(this.selectedFee == ''){
          this.errs.fee = 'You must select a fee'
          return
        } else {
          this.errs.fee = ''
        }
      } else {
        url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
          '/transactions/' + this.transaction.id + '/tips'
        html = "Tip has been added to the transaction"
        data =  {
          amount: this.tip_amount,
          company_user_id: this.company_user.id
        }
        if(this.tip_amount <= 0){
          this.errs.tip_amount = 'Invalid tip amount'
          return
        } else {
          this.errs.tip_amount = ''
        }
      }
      this.loading = true
      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.add_fee = false
          this.tax_fee_type.id = 0
          this.showAlertDialog('Success', html, 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if(err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    getFeeAmount(){
      let fee = this.selectedFee
      let totalFeeAmount = 0
      let feeLinks = []

      if(fee.value_type === 0){
        totalFeeAmount = fee.amount
      }
      else if(fee.value_type === 1){
        let feeItemLinks = []
        if(!fee.apply_to_all_items){
          feeItemLinks = JSON.parse(fee.linked_games).concat(JSON.parse(fee.linked_items)).concat(JSON.parse(fee.linked_gift_card_types))
        }

        for(let m in this.bookings){
          let found = false
          if(this.bookings[m].hasOwnProperty('item_id')){
            found = _.find(feeItemLinks, {id: this.bookings[m].item_id, item_type: 'item'})
          } else if(this.bookings[m].hasOwnProperty('booking_date') && this.bookings[m].status !== 'cancelled'){
            found = _.find(feeItemLinks, {id: this.bookings[m].game_id, item_type: 'game'})
          } else if(this.bookings[m].hasOwnProperty('design_url')){
            found = _.find(feeItemLinks, {id: this.bookings[m].gift_card_type_id, item_type: 'gift_card_type'})
          }
          if((!fee.apply_to_all_items && found) || (fee.apply_to_all_items)){
            if(this.bookings[m].hasOwnProperty('item_id')){
              totalFeeAmount += fee.amount * this.bookings[m].quantity
              feeLinks.push({fee_id: fee.id, link_type: 'item', item_id: this.bookings[m].id, amount: fee.amount * this.bookings[m].quantity})
            } else {
              totalFeeAmount += fee.amount * this.bookings[m].group_size
              feeLinks.push({fee_id: fee.id, link_type: 'booking', item_id: this.bookings[m].id,  amount: fee.amount * this.bookings[m].group_size })
            }
          }
        }
      }
      else if(fee.value_type === 2){
        let subtotalAmount = this.transaction.price
        if(fee.covered_by_promo_codes){
          subtotalAmount = this.transaction.price - this.transaction.discount
        }

        totalFeeAmount = roundCents(subtotalAmount * (fee.amount * 0.01))
      }
      else if(fee.value_type === 3){
        let feeItemLinks = []
        if(!fee.apply_to_all_items){
          feeItemLinks = JSON.parse(fee.linked_games).concat(JSON.parse(fee.linked_items)).concat(JSON.parse(fee.linked_gift_card_types))
        }

        for(let m in this.bookings){
          let found = false
          if(this.bookings[m].hasOwnProperty('item_id')){
            found = _.find(feeItemLinks, {id: this.bookings[m].item_id, item_type: 'item'})
          } else if(this.bookings[m].hasOwnProperty('booking_date') && this.bookings[m].status !== 'cancelled'){
            found = _.find(feeItemLinks, {id: this.bookings[m].game_id, item_type: 'game'})
          } else if(this.bookings[m].hasOwnProperty('design_url')){
            found = _.find(feeItemLinks, {id: this.bookings[m].gift_card_type_id, item_type: 'gift_card_type'})
          }
          if((!fee.apply_to_all_items && found) || (fee.apply_to_all_items && !this.bookings[m].hasOwnProperty('design_url'))){
            if(this.bookings[m].hasOwnProperty('item_id')){
              totalFeeAmount += fee.amount
              feeLinks.push({fee_id: fee.id, link_type: 'item', item_id: this.bookings[m].id, amount: fee.amount})
            } else if(this.bookings[m].status !== 'cancelled') {
              totalFeeAmount += fee.amount
              feeLinks.push({fee_id: fee.id, link_type: 'booking', item_id: this.bookings[m].id, amount: fee.amount})
            }
          }
        }
      }
      else if(fee.value_type === 4){
        let feeItemLinks = []
        if(!fee.apply_to_all_items){
          feeItemLinks = JSON.parse(fee.linked_games).concat(JSON.parse(fee.linked_items)).concat(JSON.parse(fee.linked_gift_card_types))
        }

        for(let m in this.bookings){
          let found = false
          let subtotalAmount = 0
          if(this.bookings[m].hasOwnProperty('item_id')){
            subtotalAmount = this.bookings[m].amount
            if(fee.covered_by_promo_codes){
              subtotalAmount = this.bookings[m].amount - this.bookings[m].discount
            }
            subtotalAmount = subtotalAmount
            found = _.find(feeItemLinks, {id: this.bookings[m].item_id, item_type: 'item'})
          } else if (this.bookings[m].hasOwnProperty('booking_date') && this.bookings[m].status !== 'cancelled'){
            subtotalAmount = this.bookings[m].price
            if(fee.covered_by_promo_codes){
              subtotalAmount = this.bookings[m].price - this.bookings[m].discount
            }

            found = _.find(feeItemLinks, {id: this.bookings[m].game_id, item_type: 'game'})
          } else if(this.bookings[m].hasOwnProperty('design_url')){
            subtotalAmount = this.bookings[m].price
            if(fee.covered_by_promo_codes){
              subtotalAmount = this.bookings[m].price - this.bookings[m].discount
            }

            found = _.find(feeItemLinks, {id: this.bookings[m].gift_card_type_id, item_type: 'gift_card_type'})
          }

          if((!fee.apply_to_all_items && found) || (fee.apply_to_all_items)){
            let amount = subtotalAmount * (fee.amount * 0.01) >= 0 ? roundCents(subtotalAmount * (fee.amount * 0.01)) : 0
            totalFeeAmount += amount
            if(this.bookings[m].hasOwnProperty('item_id')){
              feeLinks.push({fee_id: fee.id, link_type: 'item', item_id: this.bookings[m].id, amount: amount })
            } else if(this.bookings[m].hasOwnProperty('design_url')){
              feeLinks.push({fee_id: fee.id, link_type: 'gift_card', item_id: this.bookings[m].id, amount: amount })
            }
            else if(this.bookings[m].status !== 'cancelled') {
              feeLinks.push({fee_id: fee.id, link_type: 'booking', item_id: this.bookings[m].id, amount: amount })
            }
          }
        }
      }

      if(totalFeeAmount < 0){
        totalFeeAmount = 0
      }
      this.feeLinks = feeLinks
      this.totalFeeAmount = totalFeeAmount
      return totalFeeAmount
    },
    getGiftCardTotalAmount(){
      let total = 0
      for(let n in this.bookings){
        if(this.bookings[n].hasOwnProperty('item_id')){
          total += this.bookings[n].amount
        } else if(this.bookings[n].hasOwnProperty('booking_date') && this.bookings[n].status !== 'cancelled'){
          total += Number(this.bookings[n].price)
        }
      }
      return this.transaction.price - total
    },
    getTaxAmount(){
      let tax = this.selectedTax
      let totalTaxAmount = 0
      let taxLinks = []

      if(tax.value_type === 0){
        totalTaxAmount = tax.amount
      }
      else if(tax.value_type === 1){
        let taxItemLinks = []
        if(!tax.apply_to_all_items){
          taxItemLinks = JSON.parse(tax.linked_games).concat(JSON.parse(tax.linked_items))
        }

        for(let m in this.bookings){
          let found = false
          if(this.bookings[m].hasOwnProperty('item_id')){
            found = _.find(taxItemLinks, {id: this.bookings[m].item_id, item_type: 'item'})
          } else if(this.bookings[m].status !== 'cancelled'){
            found = _.find(taxItemLinks, {id: this.bookings[m].game_id, item_type: 'game'})
          }
          if((!tax.apply_to_all_items && found) || (tax.apply_to_all_items && !this.bookings[m].hasOwnProperty('design_url'))){
            if(this.bookings[m].hasOwnProperty('item_id')){
              totalTaxAmount += tax.amount * this.bookings[m].quantity
              taxLinks.push({tax_id: tax.id, link_type: 'item', item_id: this.bookings[m].id, amount: tax.amount * this.bookings[m].quantity })
            } else {
              totalTaxAmount += tax.amount * this.bookings[m].group_size
              taxLinks.push({tax_id: tax.id, link_type: 'booking', item_id: this.bookings[m].id,  amount: tax.amount * this.bookings[m].group_size })
            }
          }
        }
      }
      else if(tax.value_type === 2){
        let subtotalAmount = this.transaction.price - this.getGiftCardTotalAmount()
        if(tax.apply_after_discount){
          subtotalAmount = this.transaction.price - this.getGiftCardTotalAmount() - this.transaction.discount
        }

        if(tax.pricing_type === 1){
          if(!tax.is_compound){
            subtotalAmount = subtotalAmount - this.transaction.tax
          }
        } else {
          if(tax.is_compound){
            subtotalAmount = subtotalAmount + this.transaction.tax
          }
        }
        totalTaxAmount = roundCents(subtotalAmount * (tax.amount * 0.01))
      }
      else if(tax.value_type === 3){
        let taxItemLinks = []
        if(!tax.apply_to_all_items){
          taxItemLinks = JSON.parse(tax.linked_games).concat(JSON.parse(tax.linked_items))
        }

        for(let m in this.bookings){
          let found = false
          if(this.bookings[m].hasOwnProperty('item_id')){
            found = _.find(taxItemLinks, {id: this.bookings[m].item_id, item_type: 'item'})
          } else if(this.bookings[m].status !== 'cancelled'){
            found = _.find(taxItemLinks, {id: this.bookings[m].game_id, item_type: 'game'})
          }
          if((!tax.apply_to_all_items && found) || (tax.apply_to_all_items && !this.bookings[m].hasOwnProperty('design_url'))){
            if(this.bookings[m].hasOwnProperty('item_id')){
              totalTaxAmount += tax.amount
              taxLinks.push({tax_id: tax.id, link_type: 'item', item_id: this.bookings[m].id, amount: tax.amount})
            } else if(this.bookings[m].status !== 'cancelled') {
              totalTaxAmount += tax.amount
              taxLinks.push({tax_id: tax.id, link_type: 'booking', item_id: this.bookings[m].id, amount: tax.amount})
            }
          }
        }
      }
      else if(tax.value_type === 4){
        let taxItemLinks = []
        if(!tax.apply_to_all_items){
          taxItemLinks = JSON.parse(tax.linked_games).concat(JSON.parse(tax.linked_items))
        }

        for(let m in this.bookings){
          let found = false
          let subtotalAmount = 0
          if(this.bookings[m].hasOwnProperty('item_id')){
            subtotalAmount = this.bookings[m].amount
            if(tax.apply_after_discount){
              subtotalAmount = this.bookings[m].amount - this.bookings[m].discount
            }
            if(tax.pricing_type === 1){
              if(!tax.is_compound){
                subtotalAmount = subtotalAmount - this.bookings[m].tax
              }
            } else {
              if(tax.is_compound){
                subtotalAmount = subtotalAmount + this.bookings[m].tax
              }
            }
            found = _.find(taxItemLinks, {id: this.bookings[m].item_id, item_type: 'item'})
          } else if(this.bookings[m].status !== 'cancelled'){
            subtotalAmount = this.bookings[m].price
            if(tax.apply_after_discount){
              subtotalAmount = this.bookings[m].price - this.bookings[m].discount
            }
            if(tax.pricing_type === 1){
              if(!tax.is_compound){
                subtotalAmount = subtotalAmount - this.bookings[m].tax
              }
            } else {
              if(tax.is_compound){
                subtotalAmount = subtotalAmount + this.bookings[m].tax
              }
            }
            found = _.find(taxItemLinks, {id: this.bookings[m].game_id, item_type: 'game'})
          }
          if((!tax.apply_to_all_items && found) || (tax.apply_to_all_items && !this.bookings[m].hasOwnProperty('design_url'))){
            let amount = subtotalAmount * (tax.amount * 0.01) >= 0 ? roundCents(subtotalAmount * (tax.amount * 0.01)) : 0
            totalTaxAmount += amount
            if(this.bookings[m].hasOwnProperty('item_id')){
              taxLinks.push({tax_id: tax.id, link_type: 'item', item_id: this.bookings[m].id, amount: amount})
            } else if(this.bookings[m].status !== 'cancelled') {
              taxLinks.push({tax_id: tax.id, link_type: 'booking', item_id: this.bookings[m].id, amount: amount})
            }
          }
        }
      }

      if(totalTaxAmount< 0){
        totalTaxAmount = 0
      }
      this.taxLinks = taxLinks
      this.totalTaxAmount = totalTaxAmount

      return totalTaxAmount
    },
    deleteDiscountPrompt(item){
      let html = 'The discount will be removed from the transaction'

      this.showConfirmDialog({
        title: 'Are you sure?',
        message: html,
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.deleteDiscount(item);
        }
      })
    },
    async deleteDiscount(item){

      if(item.transaction_promo_link_id === undefined){
        item.transaction_promo_link_id = ''
      }


      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/discounts?promo_id=' + item.transaction_promo_link_id
      if(item.link_type !== 'transaction'){
        url += '&link_type=' + encodeURIComponent(item.link_type)
      }
      if(item.link_type === 'transaction' && item.id === item.transaction_promo_link_id && item.name === 'Discount'){
        url += '&link_type=' + encodeURIComponent('discount')
      }

      axios.delete(url, config)
        .then(response => {
          this.loading = false
          this.showAlertDialog('Success', "Discount has been removed from the transaction.", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    deleteTaxFeePrompt(item){
      let message = 'The fee will be removed from the transaction.'
      if(item.hasOwnProperty('tax_id')){
        message = 'The tax will be removed from the transaction.'
      }

      this.showConfirmDialog({
        title: 'Are you sure?',
        message: message,
        confirmText: 'Confirm',
        onConfirm: () => {
          if(item.hasOwnProperty('tax_id')){
            this.deleteTax(item)
          } else if(item.hasOwnProperty('fee_id')){
            this.deleteFee(item)
          } else {
            this.deleteTip(item)
          }
        }
      })
    },
    async deleteTip(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/tips?id=' + item.id
      axios.delete(url, config)
        .then(response => {
          this.loading = false
          this.showAlertDialog('Success', "Tip has been removed from the transaction.", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async deleteTax(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/taxes?id=' + item.id + '&tax_id=' + item.tax_id +
        '&item_id=' + item.item_id + '&link_type=' + item.link_type
      axios.delete(url, config)
        .then(response => {
          this.loading = false
          this.showAlertDialog('Success', "Tax has been removed from the transaction.", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async deleteFee(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/fees?id=' + item.id + '&fee_id=' + item.fee_id +
        '&item_id=' + item.item_id + '&link_type=' + item.link_type
      axios.delete(url, config)
        .then(response => {
          this.loading = false
          this.showAlertDialog('Success', "Fee has been removed from the transaction.", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async giftCardSearch(queryString, cb){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/gifts/autocomplete?q=' + encodeURIComponent(queryString)
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.gift_cards){
            if(response.data.gift_cards[n].code != null){
              suggestions.push({
                value: JSON.stringify(response.data.gift_cards[n]),
                id: response.data.gift_cards[n].id,
                code: response.data.gift_cards[n].code,
                customer_id: response.data.gift_cards[n].customer_id,
                date_purchased: response.data.gift_cards[n].date_purchased,
                email: response.data.gift_cards[n].email,
                first_name: response.data.gift_cards[n].first_name,
                last_name: response.data.gift_cards[n].last_name,
                remaining: response.data.gift_cards[n].remaining,
                total: response.data.gift_cards[n].total
              })
            }

          }
          const results = suggestions

          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    handleGiftCardSelect(item){
      this.gift_card_code = this.getGiftCardCode(item.code)
      this.selectedGiftCardCode = item
    },
    async promoSearch(queryString, cb){
      let today = new Date()
      let purchase_date = today.getFullYear() +  "-" +  ('0' + (today.getMonth() + 1)).slice(-2) + "-" + ('0' + today.getDate()).slice(-2);

      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/promos?autocomplete=' + encodeURIComponent(queryString) + '&purchase_date=' + purchase_date
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.promos){
            if(response.data.promos[n].name != null){
              suggestions.push({
                value: JSON.stringify(response.data.promos[n]),
                id: response.data.promos[n].id,
                name: response.data.promos[n].name,
                description: response.data.promos[n].description,
                value_amount: response.data.promos[n].value_amount,
                redemption_type: response.data.promos[n].redemption_type,
                value_type: response.data.promos[n].value_type,
                games: JSON.parse(response.data.promos[n].games),
                event_exlusions: response.data.promos[n].event_exlusions,
                internal_only: response.data.promos[n].internal_only,
                is_cross_group: response.data.promos[n].is_cross_group,
                event_is_date_range: response.data.promos[n].event_is_date_range,
                event_is_time_range: response.data.promos[n].event_is_time_range,
                event_start_date: response.data.promos[n].event_start_date,
                event_end_date: response.data.promos[n].event_end_date,
                event_start_time: response.data.promos[n].event_start_time,
                event_end_time: response.data.promos[n].event_end_time,
                available_days: [response.data.promos[n].available_sunday,
                  response.data.promos[n].available_monday,
                  response.data.promos[n].available_tuesday,
                  response.data.promos[n].available_wednesday,
                  response.data.promos[n].available_thursday,
                  response.data.promos[n].available_friday,
                  response.data.promos[n].available_saturday],
                rules: response.data.promos[n].rules || []
              })
            }

          }
          const results = queryString
            ? suggestions.filter(this.createFilter(queryString))
            : suggestions;

          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    handlePromoSelect(item){
      this.promo_code = item.name
      this.selectedPromoCode = item
    },
    hasBuyXGetYRule(rules) {
      if (!rules || rules.length === 0) return false;
      return rules.some(r => r.rule_type?.rule_key === 'BUY_X_GET_Y');
    },
    hasMinValueRule(rules) {
      if (!rules || rules.length === 0) return false;
      return rules.some(r => r.rule_type?.rule_key === 'MIN_VALUE');
    },
    hasBundlePriceRule(rules) {
      if (!rules || rules.length === 0) return false;
      return rules.some(r => r.rule_type?.rule_key === 'BUNDLE_PRICE');
    },
    cancelDiscount(){
      this.add_promo = false
      this.add_discount = false
    },
    async applyPromoCode(){
      if(this.add_promo && this.selectedPromoCode === ''){
        this.errs.promo_code = 'Please add a valid promo code'
        return
      } else {
        this.errs.promo_code = ''
      }

      if(this.add_discount && this.discount_amount > this.transaction.total){
        this.errs.discount_amount = 'Discount cannot be greater than total'
        return
      } else {
        this.errs.discount_amount = ''
      }

      let id = this.selectedPromoCode.id
      if(id){
        let non_unique = _.find(this.promos, function(o) { return o.id === id })
        if(non_unique){
          this.showAlertDialog('Error', "Promo code has already been applied", 'danger')
          return
        }
      }

      let today = new Date()
      today = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/discounts?date=' + today
      let data = {
        promo_code: this.selectedPromoCode
      }
      if(this.add_discount){
        data.discount_amount = this.discount_amount
        data.discount_description = this.discount_description
      }

      this.loading = true
      axios.post(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', "Promo code has been applied", 'success')
          this.promo_code = ''
          this.selectedPromoCode = ''
          this.add_promo = false
          this.add_discount = false
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.promo_code = ''
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', err.response.data, 'danger')
          }
        })
    },
    addCustomPurchase(event){
      event.preventDefault();
      this.modals.custom_purchase = true
      this.errs.purchase.name = ''
      this.errs.purchase.price = ''
      this.purchase = {
        name: '',
        category: '',
        description: '',
        amount: '',
        quantity: '',
        price: ''
      }
    },
    addPurchase(event){
      event.preventDefault();
      // Opens the reused AddItemView drawer; it owns its own item/search state.
      this.modals.add_item = true
    },
    onItemAdded(){
      this.modals.add_item = false
      this.showAlertDialog('Success', 'Item has been added to the transaction', 'success')
      this.getTransaction()
    },
    addFee(){
      this.tip_amount = 0
      this.company_user_value = ''
      this.add_fee = true
    },
    addDiscount(){
      this.add_discount = true
      this.discount_amount = 0
      this.discount_description = ''
    },
    addPromoCode(){
      this.add_promo = true
    },
    isPhoneRequired() {
      try {
        return isInternalPhoneRequired(JSON.parse(localStorage.getItem('group') || '{}'))
      } catch (e) {
        return false
      }
    },
    async updateCustomer(){
      // Reset field-level errors (strings bound to base-input :error)
      this.errs.first_name = this.customer.first_name
        ? ''
        : 'First name cannot be empty'
      this.errs.last_name = this.customer.last_name
        ? ''
        : 'Last name cannot be empty'
      this.errs.email = isValidEmail(this.customer.email)
        ? ''
        : 'Please provide a valid email'

      const group = JSON.parse(localStorage.getItem('group') || '{}')
      this.errs.phone = validateInternalCustomerPhone(this.customer, group)
        ? ''
        : 'Phone number is required'

      if (this.errs.first_name || this.errs.last_name || this.errs.email || this.errs.phone) {
        return
      }

      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id
      let data = {
        first_name: this.customer.first_name,
        last_name: this.customer.last_name,
        phone: this.customer.phoneE164 || this.customer.phone,
        email: this.customer.email
      }
      this.loading = true
      axios.put(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', "Customer details have been updated", 'success')
          this.customerTabMode = 'view'
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })

    },
    async querySearchCu(queryString, cb) {
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/company-users?count=10000000&autocomplete=' + encodeURIComponent(queryString)
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.company_users){
            suggestions.push({
              value: JSON.stringify(response.data.company_users[n]),
              email: response.data.company_users[n].email,
              id: response.data.company_users[n].id,
              first_name: response.data.company_users[n].first_name,
              last_name: response.data.company_users[n].last_name
            })
          }
          const results = suggestions;
          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async querySearch(queryString, cb) {
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/customers?count=10000000&offset=0&first_name=&last_name=&email=&phone=&game=&tag=&autocomplete=' + encodeURIComponent(queryString)
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.customers){
            if(response.data.customers[n].email != null
              && response.data.customers[n].first_name != null
              && response.data.customers[n].first_name != ''){
              suggestions.push({
                value: JSON.stringify(response.data.customers[n]),
                email: response.data.customers[n].email,
                id: response.data.customers[n].id,
                first_name: response.data.customers[n].first_name,
                last_name: response.data.customers[n].last_name,
                phone: this.formatPhone(response.data.customers[n].country, response.data.customers[n].phone)
              })
            }

          }
          const results = suggestions;
          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    createFilter(queryString) {
      return (suggestion) => {
        return diacriticIncludes(suggestion.value, queryString);
      };
    },
    handleSelectCu(item){
      this.company_user_value = item.email
      this.company_user.first_name = item.first_name
      this.company_user.last_name = item.last_name
      this.company_user.email = item.email
      this.company_user.id = item.id
    },
    openCustomerTab(mode){
      this.lookup_value = ''
      this.customerTabMode = mode
    },
    // Back to the read-only view with the saved values, dropping unsaved edits.
    cancelCustomerTab(){
      this.customer.first_name = this.transaction.first_name || ''
      this.customer.last_name = this.transaction.last_name || ''
      this.customer.email = this.transaction.email || ''
      this.customer.phone = this.transaction.phone || ''
      this.customer.phoneE164 = ''
      this.errs.first_name = ''
      this.errs.last_name = ''
      this.errs.email = ''
      this.errs.phone = ''
      this.lookup_value = ''
      this.customerTabMode = 'view'
    },
    // A lookup pick fills the form; Save customer then links it.
    onCustomerLookupSelect(item){
      this.handleSelect(item)
      this.customerTabMode = 'edit'
    },
    handleSelect(item){
      this.lookup_value = item.email
      this.customer.first_name = item.first_name
      this.customer.last_name = item.last_name
      this.customer.email = item.email
      this.customer.phone = item.phone
    },
    async addPaymentModal(event){
      event.preventDefault()
      if (this.isReadOnly || this.transaction.due <= 0){
        return
      }

      if(this.$refs?.paymentForm){
        this.$refs.paymentForm.reset()
      }

      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/payment-methods'

      axios.get(url, config)
        .then((response) => {
          this.loading = false
          this.paymentOptions = response.data.payment_methods
          this.selectedPaymentOption = this.paymentOptions.length > 0 ?
            this.paymentOptions[0] : {name: '', content: '', id: '', is_default: ''}
          this.modals.add_payment = true
          this.payment_amount = parseFloat(this.transaction.due).toFixed(2)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })

      if(this.payment_settings.payment_gateway_id === 2){
        // Reset stored payment method state
        this.selected_payment_method = 'new'
        this.save_card_for_future = false
        await this.initializeSquare()
        // Load stored payment methods if enabled
        if(this.payment_settings.square_store_credit_card){
          await this.loadSquarePaymentMethods()
        }
      }
      if(this.payment_settings.payment_gateway_id === 3){
        await this.initializeStripe()
        // Reset stored payment method state
        this.selected_payment_method = 'new'
        this.save_card_for_future = false
        // Load stored payment methods if enabled
        if(this.payment_settings.store_credit_card){
          await this.loadStripePaymentMethods()
        }
      }
    },
    async loadPaystack(){
      const script = document.createElement('script');
      script.src = 'https://js.paystack.co/v2/inline.js'
      script.async = true;
      document.body.appendChild(script);
    },
    async loadStripe(){
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      document.body.appendChild(script);
    },
    async initializeStripe(){
      // A Stripe Connect venue tokenizes inside its connected account (platform key + account).
      const accountOpts = this.payment_settings.stripe_account_id ? { stripeAccount: this.payment_settings.stripe_account_id } : undefined;
      this.stripe = window.Stripe(this.payment_settings.api_name, accountOpts);
      this.elements = this.stripe.elements();

      const style = {
        base: {
          fontSize: '16px',
          fontFamily: 'Poppins, sans-serif',
          color: localStorage.getItem('mode') === '0' ? '#344675' : '#ffffff'
        },
      };

      // Create an instance of the card Element.
      this.card = this.elements.create('card', {style});
      // Add an instance of the card Element into the `card-element` <div>.
      this.card.mount('#card-element');
    },
    async loadStripePaymentMethods() {
      if (!this.transaction.end_user_id) {
        this.stripe_payment_methods = []
        return
      }
      this.loading_payment_methods = true
      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const customerId = this.transaction.end_user_id
        const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/stripe-customer`

        const response = await axios.get(url, config)
        this.stripe_customer = response.data.stripe_customer
        this.stripe_payment_methods = response.data.payment_methods || []

        // If there are stored cards, default to the default card
        if (this.stripe_payment_methods.length > 0) {
          const defaultCard = this.stripe_payment_methods.find(pm => pm.is_default)
          if (defaultCard) {
            this.selected_payment_method = defaultCard.id
          }
        }
      } catch (err) {
        // 404 means no Stripe customer exists yet - that's fine
        if (err.response && err.response.status !== 404) {
          console.error('Error loading payment methods:', err)
        }
        this.stripe_payment_methods = []
        this.stripe_customer = null
      } finally {
        this.loading_payment_methods = false
      }
    },
    getCardBrandIcon(brand) {
      const brandIcons = {
        'visa': 'fab fa-cc-visa',
        'mastercard': 'fab fa-cc-mastercard',
        'amex': 'fab fa-cc-amex',
        'discover': 'fab fa-cc-discover',
        'diners': 'fab fa-cc-diners-club',
        'jcb': 'fab fa-cc-jcb'
      }
      return brandIcons[brand?.toLowerCase()] || 'fas fa-credit-card'
    },
    getCardBrandName(brand) {
      const brandNames = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'amex': 'American Express',
        'discover': 'Discover',
        'diners': 'Diners Club',
        'jcb': 'JCB'
      }
      return brandNames[brand?.toLowerCase()] || brand || 'Card'
    },
    onPaymentMethodChange() {
      // When switching to a stored card, hide the save toggle
      // When switching to new card, show the card element
      this.save_card_for_future = false
    },
    async onPaymentOptionChange() {
      // When Card is selected and Stripe is the gateway, load stored payment methods
      if (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 3) {
        if (this.payment_settings.store_credit_card) {
          await this.loadStripePaymentMethods()
        }
      } else if (this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 2) {
        // Square: load stored payment methods if enabled
        if (this.payment_settings.square_store_credit_card) {
          await this.loadSquarePaymentMethods()
        }
      } else {
        // Reset stored cards when switching away from Card
        this.stripe_payment_methods = []
        this.square_payment_methods = []
        this.selected_payment_method = 'new'
        this.save_card_for_future = false
      }
    },
    async loadSquarePaymentMethods() {
      if (!this.transaction.end_user_id) {
        this.square_payment_methods = []
        this.square_customer = null
        return
      }

      this.loading_payment_methods = true
      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const customerId = this.transaction.end_user_id
        const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/square-customer`

        const response = await axios.get(url, config)
        this.square_customer = response.data.square_customer || null
        this.square_payment_methods = response.data.payment_methods || []

        if (this.square_payment_methods.length > 0) {
          const defaultCard = this.square_payment_methods.find(pm => pm.is_default)
          this.selected_payment_method = defaultCard ? defaultCard.id : this.square_payment_methods[0].id
        } else {
          this.selected_payment_method = 'new'
          // Reinitialize Square form when no stored cards found
          await this.reinitializeSquareForm()
        }
      } catch (err) {
        // 404 is expected when customer hasn't saved cards yet - not an error
        if (err.response?.status !== 404) {
          console.error('Error loading Square payment methods:', err)
        }
        this.square_payment_methods = []
        this.square_customer = null
        this.selected_payment_method = 'new'
        // Reinitialize Square form on error
        await this.reinitializeSquareForm()
      } finally {
        this.loading_payment_methods = false
      }
    },
    async onSquarePaymentMethodChange() {
      this.save_card_for_future = false
      if (this.selected_payment_method === 'new') {
        // Reinitialize Square form when switching to new card
        await this.reinitializeSquareForm()
      }
    },
    async reinitializeSquareForm() {
      // Only reinitialize if using Square payment gateway
      if (this.payment_settings.payment_gateway_id === 2) {
        // Destroy existing card element first
        if (this.card) {
          try {
            await this.card.destroy()
          } catch (e) {
            console.log('Error destroying Square card:', e)
          }
          this.card = null
        }
        // Reinitialize Square form after DOM updates
        this.$nextTick(() => {
          this.initializeSquare()
        })
      }
    },
    async loadSquare(is_live){
      const script = document.createElement('script');
      if(is_live){
        script.src = 'https://web.squarecdn.com/v1/square.js'
      } else {
        script.src = 'https://sandbox.web.squarecdn.com/v1/square.js'
      }
      script.async = true;
      document.body.appendChild(script);
    },
    async initializeSquare(){
      if (!window.Square) {
        throw new Error('Square.js failed to load properly');
      }
      if(this.card){
        await this.card.destroy()
      }
      this.square = window.Square.payments(this.squareAppId, this.squareLocationId);
      try {
        this.card = await this.initializeCard(this.square);

      } catch (e) {
        console.error('Initializing Card failed', e);
        return;
      }
    },
    async initializeCard(payments) {
      const customStyle = {
        '.input-container.is-focus': {
          borderColor: '#e14eca',
        },
        '.input-container.is-error': {
          borderColor: '#ff1600',
        },
        '.message-text.is-error': {
          color: '#ff1600',
        },
        '.message-icon.is-error': {
          color: '#ff1600',
        },
        'input.is-error': {
          color: '#ff1600',
        },
        '.message-icon': {
          color: '#adb5bd',
        },
        '@media screen and (max-width: 600px)': {
          'input': {
            'fontSize': '12px',
          }
        },
        '.input-container': {
          borderRadius: '6px',
        },
        '.message-text': {
          color: '#adb5bd',
        },
        input: {
          backgroundColor: localStorage.getItem('mode') === '0' ? '#ffffff' : '#22233a',
          color: localStorage.getItem('mode') === '0' ? '#344675' : '#ffffff',
        },
        'input::placeholder': {
          color: '#adb5bd',
        },
      }
      const card = await payments.card({
        style: customStyle,
      });
      await card.attach('#card-container');
      return card;
    },
    async verifyBuyer(payments, token, zip) {
      const verificationDetails = {
        amount: this.payment_amount.toString(),
        /* collected from the buyer */
        billingContact: {
          familyName: this.user.last_name,
          givenName: this.user.first_name,
          postalCode: zip
        },
        currencyCode: this.currency,
        intent: 'CHARGE',
      };

      const verificationResults = await payments.verifyBuyer(
        token,
        verificationDetails
      );
      return verificationResults.token;
    },
    reactivateBookingPrompt(item){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This action will restore the booking even if potential conflicts exist.",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.reactivateBooking(item);
        }
      })
    },
    async reactivateBooking(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/'
        + companyGroupId + '/bookings/' + item.id + '/reactivate'

      if(item.master_slot_id)  {
        url = API_LOCATION + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/bookings/' + item.master_slot_id + '/reactivate?booking_id=' + item.id
      }

      let data = {}
      this.axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.showAlertDialog('Success', "Booking has been reactivated", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } if(err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
          }
          else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async cancelBookingPrompt(item, event){
      event.preventDefault()
      this.selectedBookingSlot = item
      this.selectedCancellationStatus = {id: 1, label: 'Available', status: 'available'}
      this.deleteWaivers = 'keep'
      await this.getWaiverCountForBooking(item.id)
      this.modals.cancel_booking = true
    },
    async getWaiverCountForBooking(bookingId){
      this.waiverCount = 0
      try {
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/' + bookingId + '/waivers'
        let response = await this.axios.get(url, config)
        this.waiverCount = response.data.users ? response.data.users.length : 0
      } catch (err) {
        console.log('Error fetching waiver count:', err)
        this.waiverCount = 0
      }
    },
    async cancelBooking(item, new_status){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/'
        + companyGroupId + '/bookings/' + item.id + '?new_status=' + new_status + '&delete_waivers=' + (this.deleteWaivers === 'delete')

      if(item.master_slot_id)  {
        url = API_LOCATION + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/bookings/' + item.master_slot_id + '?new_status=' + new_status + '&delete_waivers=' + (this.deleteWaivers === 'delete') + '&booking_id=' + item.id
      }

      this.axios.delete(url, config)
        .then(response => {
          this.loading = false
          this.showAlertDialog('Success', "Booking has been cancelled", 'success')
          this.modals.cancel_booking = false
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } if(err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
          }
          else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    getGameObj(game){
      if(this.games != ''){
        let selectedGame = this.games.filter(obj => {
          return obj.name === game
        })
        return selectedGame
      }
    },
    getInitialSubtotal(item, source){

      item.number_of_players = 0
      item.pricing_categories = []
      item.booking_date = null
      item.start_time = null
      if(source === 'new'){
        this.booking_date = null
        this.selectedTimeSlot = ''
      } else {
        this.getSubtotal(item)
      }

    },
    onRescheduleSlotChange(new_time_slot, original_item){
      this.reschedule_duration_id = this.preselectRescheduleDuration(new_time_slot, original_item)
      this.getNewSubtotalForBookingSlot(new_time_slot, original_item)
    },
    onRescheduleDurationChange(item, durationId){
      this.reschedule_duration_id = durationId
      if(item.start_time && item.start_time.id) this.getNewSubtotalForBookingSlot(item.start_time, item)
    },
    // The target offers the booking's current length: keep it. Otherwise the target's default.
    preselectRescheduleDuration(slot, item){
      const settings = slotDurationSettings(slot || {})
      if(!settings.enabled) return null
      const w = item._originalWindow || {}
      const start = moment(`${String(w.booking_date || '').substring(0, 10)} ${w.start_time}`, 'YYYY-MM-DD HH:mm:ss')
      const end = moment(`${String(w.end_date || w.booking_date || '').substring(0, 10)} ${w.end_time}`, 'YYYY-MM-DD HH:mm:ss')
      const currentMinutes = start.isValid() && end.isValid() ? end.diff(start, 'minutes') : null
      const match = currentMinutes !== null ? settings.durations.find(d => Number(d.duration_minutes) === currentMinutes) : null
      if(match) return Number(match.is_default) === 1 ? null : Number(match.id)
      return null
    },
    getNewSubtotalForBookingSlot(new_time_slot, original_item){
      // Preserve per-category player counts across the time change (mirrors
      // RescheduleView.buildTicketsForSlot). Match on category_id; default to
      // 0 only for categories the new slot newly introduces.
      const prevCounts = new Map()
      for (const pc of (original_item.pricing_categories || [])) {
        prevCounts.set(pc.category_id, (prevCounts.get(pc.category_id) || 0) + (pc.number_of_players || 0))
      }

      //Multiple durations: the target slot's rows for the chosen duration (null = its default)
      let pricing = slotPricingRows(new_time_slot, this.reschedule_duration_id)

      // No pricing tiers on the new slot — never silently zero out the booking.
      if(!pricing || !pricing.length){
        this.pr_key++
        this.getSubtotal(original_item)
        return
      }

      if(new_time_slot.is_custom_pricing_enabled){
        this.number_of_players = 0
        this.custom_pricing_categories = []
        let categories = this.getCategories(pricing)
        for(let n in pricing){

          if(!(_.find(this.custom_pricing_categories, { category_id: pricing[n].category_id }))){
            this.custom_pricing_categories.push({
              category_id: pricing[n].category_id,
              category: pricing[n].category.toLowerCase(),
              number_of_players: prevCounts.has(pricing[n].category_id)
                ? prevCounts.get(pricing[n].category_id)
                : (pricing[n].default_participants || 0),
              price: pricing[n].price,
              category_pricing: _.find(categories, {category_id: pricing[n].category_id}).pricing
            })
            this.number_of_players++
          }
        }
        // Sort categories by category_id to ensure consistent order
        this.custom_pricing_categories.sort((a, b) => a.category_id - b.category_id)
        original_item.pricing_categories = this.custom_pricing_categories
      } else {
        this.number_of_players = 0
        this.pricing_categories = []
        for(let n in pricing){
          let categories = this.getCategories(pricing)
          if(!(_.find(this.pricing_categories, { category_id: pricing[n].category_id }))){
            this.pricing_categories.push({
              category_id: pricing[n].category_id,
              category: pricing[n].category.toLowerCase(),
              number_of_players: prevCounts.has(pricing[n].category_id)
                ? prevCounts.get(pricing[n].category_id)
                : (pricing[n].default_participants || 0),
              price: pricing[n].price,
              category_pricing: _.find(categories, {category_id: pricing[n].category_id}).pricing
            })
            this.number_of_players++
          }
        }
        // Sort categories by category_id to ensure consistent order
        this.pricing_categories.sort((a, b) => a.category_id - b.category_id)
        original_item.pricing_categories = this.pricing_categories
      }
      original_item.game_pricing = JSON.stringify(pricing)
      original_item.custom_pricing = JSON.stringify(pricing)
      original_item.pricing_type_id = new_time_slot.pricing_type_id
      original_item.cumulative_category_pricing = new_time_slot.cumulative_category_pricing
      original_item.is_custom_pricing_enabled = new_time_slot.is_custom_pricing_enabled
      original_item.slot_pricing_type_id = new_time_slot.slot_pricing_type_id
      original_item.slot_cumulative_category_pricing = new_time_slot.slot_cumulative_category_pricing

      this.pr_key++
      this.getSubtotal(original_item)
    },
    async getAvailableBookings(item, source){
      if(source === 'date'){
        item.start_time = null
      }

      let url = ''
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      if(item.hasOwnProperty('selectedGame')){
        // Editing existing booking - include blocked slots
        url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/available?t='
          + item.booking_date + '&game_id='
          + this.getGameObj(item.selectedGame)[0].id
          + '&booking_id=' + item.id
          + '&include_blocked=1'
      } else {
        // Adding new booking - include blocked slots
        let dt = new Date(this.booking_date)
        let date = dt.getFullYear() + '-' +  ('0' + (dt.getMonth()+1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)

        url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/available?t='
          + date + '&game_id='
          + this.selectedGame.id
          + '&include_blocked=1'
      }


      this.loading = true
      this.axios.get(url, config)
        .then(response => {
          this.available_bookings = response.data.bookings
          for(let n in this.available_bookings){
            this.available_bookings[n].pricing = JSON.parse(this.available_bookings[n].pricing)
            this.available_bookings[n].custom_pricing = JSON.parse(this.available_bookings[n].custom_pricing)
            this.available_bookings[n].all_pricing = JSON.parse(this.available_bookings[n].all_pricing || '[]')
            this.available_bookings[n].slot_durations = JSON.parse(this.available_bookings[n].slot_durations || '[]')
            this.available_bookings[n].game_durations = JSON.parse(this.available_bookings[n].game_durations || '[]')
            this.available_bookings[n].pricing_categories = []
          }

          if(item.booking_date !== null){
            this.errs.booking_date = ''
          }
          if(item.start_time !== null){
            this.errs.start_time = ''
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    switchTab(index){
      this.activeTabIndex = index
      // Fetch waiver settings when Waivers tab is selected
      if(index === 5 && this.waiverSettings.length === 0){
        this.getWaiverSettings()
      }
    },
    switchTabNotes(index){
      this.activeTabNotesIndex = index
    },
    async getGames (item) {
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/games'
      this.axios.get(url, config)
        .then(response => {
          this.games = response.data
          if(item){
            item.selectedGame = item.name
            this.getAvailableBookings(item)
          } else {
            this.selectedGame = this.games[0]
          }

          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    cancelEdit(item, index) {
      if (item.hasOwnProperty('start_time')) {
        item.game_pricing = item.placeholder_game_pricing
        item.subtotal = item.placeholder_subtotal
        item.pricing_categories = JSON.parse(item.placeholder_pricing_categories)
        item.pricing_type_id = item.placeholder_pricing_type_id
        item.group_size = item.placeholder_group_size
        item.booking_date = item.placeholder_booking_date
        item.end_date = item.placeholder_end_date
        item.start_time = item.placeholder_start_time
        item.is_reservation_upgraded = item.placeholder_is_reservation_upgraded
        item.reservation_upgrade_price = item.placeholder_reservation_upgrade_price
      }
      // Reset purchase price and quantity override
      if (item.placeholder_price !== undefined) {
        item.price = item.placeholder_price
      }
      if (item.placeholder_quantity !== undefined) {
        item.quantity = item.placeholder_quantity
      }
      this.$set(item, 'price_override', false)
      this.$set(this.editing_bookings, index, false)
    },
    saveItemPrompt(item, index){
      if(!this.validatePurchase(item)){
        return
      }
      this.showConfirmDialog({
        title: "Are you sure?",
        message: "This change will affect the transaction",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.updateItem(item, index);
        }
      })
    },
    async updateItem(item, index){

      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      //validate
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/transactions/' + this.transaction.id + '/items'
      let data = item
      data.amount = this.getPurchaseAmount(item.price, item.quantity)

      if(item.category.name === 'Custom'){
        data.custom_category = this.custom_category
      }

      this.loading = true
      axios.put(url, data, config)
        .then(response => {
          this.loading = false
          this.$set(this.editing_bookings, index, false);

          this.showAlertDialog('Success', "Item has been updated", 'success')

          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })

    },
    saveEditPrompt(item, index){
      if(!this.isBookingValid(item)){
        return
      }
      let html = 'Are you sure you want to make changes to this booking?'

      if(this.email_settings[1].is_active){
        html = 'Completing this action will make changes to this booking and send an email to ' + this.transaction.first_name + ' ' + this.transaction.last_name + '.'
      }

      let title = 'Update booking'

      this.showConfirmDialog({
        title: title,
        message: html,
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.saveEdit(item, index);
        }
      })
    },
    isBookingValid(item){
      let errors = 0
      if(item.booking_date === null || item.booking_date === '' || item.booking_date.length <=0){
        this.errs.booking_date = 'Invalid booking date'
        errors++
      } else {
        this.errs.booking_date = ''
      }
      if(item.start_time == null  || item.start_time === '' || item.start_time.length <=0){
        this.errs.start_time = 'Invalid time'
        errors++
      } else {
        this.errs.start_time = ''
      }

      if (item.is_reservation_upgraded && item.reservation_upgrade_pricing_mode !== 'tickets_plus_fee') {
        const price = item.reservation_upgrade_price
        if (!price || price <= 0) {
          this.errs.price = 'Please enter a valid upgrade override price'
          errors++
        } else {
          this.errs.price = ''
        }
      } else {
        if(item.number_of_players <= 0){
          this.errs.number_of_players = 'Please select a valid group size'
          errors++
        } else {
          this.errs.number_of_players = ''
        }
      }

      if(errors > 0){
        return false
      }
      return true
    },
    getTransactionTotal(item){
      let total = 0
      for(let n in this.bookings){
        if(item.id === this.bookings[n].id){
          total += this.subtotal
        } else {
          total += parseFloat(this.bookings[n].price)
        }
      }
      return total
    },
    async saveEdit(item, index) {
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/' + item.id + '/v2'

      let tickets = []
      let new_group_size = 0
      let price = 0

      if (item.is_reservation_upgraded) {
        for (let n in item.pricing_categories) {
          new_group_size += item.pricing_categories[n].number_of_players
        }
        tickets = item.pricing_categories
        // buyout: flat override fee. tickets+fee: real per-ticket subtotal + the
        // fixed fee (item.subtotal already includes it via getSubtotal).
        price = item.reservation_upgrade_pricing_mode === 'tickets_plus_fee'
          ? item.subtotal
          : item.reservation_upgrade_price
      } else {
        // For per-category bookings, calculate as before
        for (let n in item.pricing_categories) {
          new_group_size += item.pricing_categories[n].number_of_players
        }
        tickets = item.pricing_categories
        price = item.new_price ? item.new_price : item.subtotal
      }

      let data = {
        price: price,
        transaction: {
          price: this.getTransactionTotal(item)
        },
        booking_date: (item.start_time.booking_date || item.booking_date).substring(0, 10),
        end_date: (item.start_time.end_date || item.start_time.booking_date || item.booking_date).substring(0, 10),
        start_time: item.start_time.start_time,
        end_time: item.start_time.end_time,
        game_id: this.getGameObj(item.selectedGame)[0].id,
        tickets: tickets,
        group_size: new_group_size,
        booking_copy: item.start_time.id ? item.start_time.id : item.id,
        selected_duration_id: item.start_time.id ? this.reschedule_duration_id : null,
        book_entire_slot: item.is_reservation_upgraded
      }

      this.loading = true
      this.axios.put(url, data, config)
        .then(response => {
          this.$set(this.editing_bookings, index, false)
          this.price_override = false
          this.showAlertDialog('Success', "Booking has been updated", 'success')
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if (err.response.status == 401) {
            this.$router.push('/forbidden')
          } else if (err.response.status == 500) {
            this.showAlertDialog('Error', err.response.data, 'danger')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    editPurchase(item, index, event){
      event.preventDefault()

      // Prevent editing multiple items simultaneously to avoid data corruption
      const currentlyEditingIndex = this.editing_bookings.findIndex(isEditing => isEditing === true)
      if (currentlyEditingIndex !== -1 && currentlyEditingIndex !== index) {
        return
      }

      item.category = {id: item.category_id}
      this.is_custom_purchase = false
      // Store original catalog price
      this.$set(item, 'original_price', item.price)
      // Calculate actual per-unit price from saved amount (handles overridden prices)
      let currentPerUnitPrice = item.quantity > 0 ? item.amount / item.quantity : item.price
      this.$set(item, 'price', currentPerUnitPrice)
      // Store current price and quantity to restore on cancel
      this.$set(item, 'placeholder_price', currentPerUnitPrice)
      this.$set(item, 'placeholder_quantity', item.quantity)
      this.$set(this.editing_bookings, index, true);
    },
    overridePurchasePrice(item){
      // Only set original_price if not already set (preserves catalog price for previously overridden items)
      if (item.original_price === undefined) {
        this.$set(item, 'original_price', item.price)
      }
      this.$set(item, 'price_override', true)
    },
    savePurchasePriceOverride(item){
      this.$set(item, 'price_override', false)
    },
    async getTickets(bookingId){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/bookings/' + bookingId + '/tickets'

      return new Promise ( function(resolve) {
        axios.get(url, config)
          .then(response => {
            resolve(response.data)
          })
          .catch(err => {
            console.log(err)
          })
      })

    },
    async editBooking(item, index, event) {
      event.preventDefault()

      // Prevent editing multiple bookings simultaneously to avoid data corruption
      const currentlyEditingIndex = this.editing_bookings.findIndex(isEditing => isEditing === true)
      if (currentlyEditingIndex !== -1 && currentlyEditingIndex !== index) {
        return
      }

      this.date_format_cal = this.date_format
      this.date_format_cal = this.date_format_cal.replaceAll('Y', 'y')
      this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
      // Booked window, kept for the duration preselect once a new slot is picked
      this.$set(item, '_originalWindow', { booking_date: item.booking_date, end_date: item.end_date, start_time: item.start_time, end_time: item.end_time })
      this.reschedule_duration_id = null
      await this.getGames(item)

      item.pricing_categories = await this.getTickets(item.id)

      // Check if this is a reservation upgrade (category_id null means upgrade)
      const isReservationUpgrade = item.pricing_categories.length === 1 &&
        item.pricing_categories[0].category_id === null &&
        item.pricing_categories[0].category === null

      if (isReservationUpgrade) {
        // Only set properties on the item itself
        item.is_reservation_upgrade = true
        item.reservation_upgrade_price = item.pricing_categories[0].price
      } else {
        item.is_reservation_upgrade = false
        for (let n in item.pricing_categories) {
          item.pricing_categories[n].pricing = JSON.parse(item.pricing_categories[n].pricing)
          item.pricing_categories[n].category_pricing = item.pricing_categories[n].pricing
        }

        // Calculate total players for cumulative pricing calculation
        let totalPlayersForCalc = 0
        for(let n in item.pricing_categories){
          totalPlayersForCalc += item.pricing_categories[n].number_of_players || 0
        }

        // Check if prices were overridden by comparing stored price vs calculated price
        // If they differ, set original_price so getSubtotal uses stored price
        const isCumulative = Boolean(item.cumulative_category_pricing)
        const pricingTypeId = item.pricing_type_id || 1
        for(let n in item.pricing_categories){
          const category = item.pricing_categories[n]
          const calculatedPrice = this.calculatePriceFromRules(
            category.category_pricing,
            category.category_id,
            category.number_of_players,
            pricingTypeId,
            isCumulative,
            totalPlayersForCalc
          )

          // If calculated price differs from stored price, it was overridden
          // Set original_price so getSubtotal uses stored price and UI can show "Original: $X"
          // Note: DB stores total, but for per-person pricing we need rate
          // calculatedPrice is the total (rate * players), category.price from DB is also total
          if(calculatedPrice !== null && Math.abs(calculatedPrice - category.price) > 0.01){
            if(pricingTypeId === 1 && category.number_of_players > 0){
              // Per-person pricing: find original rate from rules for display
              let originalRate = null
              const playersForTierLookup = isCumulative ? totalPlayersForCalc : category.number_of_players
              for(let p of category.category_pricing || []){
                if(p.category_id === category.category_id &&
                   playersForTierLookup >= p.min_players &&
                   playersForTierLookup <= p.max_players){
                  originalRate = p.price
                  break
                }
              }
              if(originalRate === null && category.category_pricing && category.category_pricing.length > 0){
                const catPricing = category.category_pricing.filter(p => p.category_id === category.category_id)
                if(catPricing.length > 0) originalRate = catPricing[0].price
              }
              category.original_price = originalRate
              // Convert stored total to rate for backend
              category.price = roundCents(category.price / category.number_of_players)
            } else {
              // Flat rate pricing - price is total, stays as-is
              category.original_price = calculatedPrice
            }
          }
        }
      }

      this.getSubtotal(item)

      // Store placeholders
      item.placeholder_booking_date = item.booking_date
      item.placeholder_end_date = item.end_date
      item.placeholder_start_time = item.start_time
      item.placeholder_game_pricing = item.game_pricing
      item.placeholder_subtotal = item.subtotal
      item.placeholder_pricing_categories = JSON.stringify(item.pricing_categories)
      item.placeholder_pricing_type_id = item.pricing_type_id
      item.placeholder_group_size = item.group_size
      item.placeholder_is_reservation_upgraded = item.is_reservation_upgraded
      item.placeholder_reservation_upgrade_price = item.reservation_upgrade_price

      item.start_time = this.getTime(item.start_time) + '-' + this.getTime(item.end_time)
      this.$set(this.editing_bookings, index, true)
    },
    async resendConfirmationEmail(item, target){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/confirmation'
      let data = {
        email: this.transaction.email,
        bookings: this.bookings
      }
      if(target === 'gift_card'){
        data.target = 'gift_card'
      }

      this.axios.post(url, data, config)
        .then(response => {
          let text = "Booking confirmation sent to customer"
          if(target === 'gift_card'){
            text = "Gift card purchase confirmation email sent to customer"
          }
          this.showEmailSendSuccess(text)
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showEmailSendError(err)
          }
        })
    },
    resendConfirmationEmailPrompt(item, event){

      event.preventDefault()
      if (!this.emailSettingActive('confirmation') || !item.email){
        return
      }
      this.confirmationDialog = {
        show: true,
        title: 'Send booking confirmation',
        message: 'Completing this action will send a booking confirmation email to ' + item.first_name + ' ' + item.last_name + ' (' + item.email + ').',
        variant: 'warning',
        showCancel: true,
        confirmText: 'Send',
        onConfirm: () => this.resendConfirmationEmail(item)
      }
    },
    confirmationDialogConfirm(){
      const action = this.confirmationDialog.onConfirm
      this.confirmationDialog.show = false
      if(action){
        action()
      }
    },
    confirmationDialogCancel(){
      const action = this.confirmationDialog.onCancel
      this.confirmationDialog.show = false
      if(action){
        action()
      }
    },
    // Single acknowledge button. variant: success, danger, warning, info.
    showAlertDialog(title, message, variant = 'warning'){
      this.confirmationDialog = {
        show: true,
        title: title,
        message: typeof message === 'string' ? message : 'Something went wrong',
        variant: variant,
        showCancel: false,
        confirmText: 'OK',
        cancelText: 'Cancel',
        dismissible: true,
        onConfirm: null,
        onCancel: null
      }
    },
    // Confirm and cancel buttons; onConfirm runs only on the confirm button.
    showConfirmDialog({ title, message, variant = 'warning', confirmText = 'Confirm', cancelText = 'Cancel', dismissible = true, onConfirm = null, onCancel = null }){
      this.confirmationDialog = {
        show: true,
        title: title,
        message: message,
        variant: variant,
        showCancel: true,
        confirmText: confirmText,
        cancelText: cancelText,
        dismissible: dismissible,
        onConfirm: onConfirm,
        onCancel: onCancel
      }
    },
    // Promise form of showConfirmDialog for flows that need to await the answer.
    askConfirmation(options){
      return new Promise(resolve => {
        this.showConfirmDialog({
          ...options,
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false)
        })
      })
    },
    showSendPaymentButton(){
      let payment_request_email = _.find(this.email_settings, {
        email_type: 'payment_request'
      });


      if (this.transaction.status === 1 && this.transaction.due > 0 && payment_request_email.is_active){
        return true
      }
      return false
    },
    async sendPaymentRequest(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + item.id + '/payments/request'
      let data = {
        email: this.transaction.email,
        bookings: this.bookings
      }

      this.axios.post(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', "Payment request sent to customer", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if(err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    showSurveyButton(){
      let payment_request_email = _.find(this.email_settings, {
        email_type: 'payment_request'
      });


      if (this.transaction.status === 1 && this.transaction.due > 0 && payment_request_email.is_active){
        return true
      }
      return false
    },
    sendPaymentRequestPrompt(item){
      if (!this.showSendPaymentButton()){
        return
      }
      let html = 'Completing this action will send a payment request to ' + item.first_name + ' ' + item.last_name + '.'
      let title = 'Send payment request'

      this.showConfirmDialog({
        title: title,
        message: html,
        variant: 'warning',
        confirmText: 'Send',
        onConfirm: () => {
          this.sendPaymentRequest(item);
        }
      })
    },
    reactivateTransactionPrompt(){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This action will change the state of this transaction to 'Active', but it will not affect the status of existing bookings.",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.reactivateTransaction();
        }
      })
    },
    async reactivateTransaction(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/'
        + companyGroupId + '/transactions/' + this.transaction.id + '/reactivate'

      let data = {}
      this.axios.post(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', "Transaction has been reactivated", 'success')
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    cancelTransactionPrompt() {
      this.cancelDrawerOpen = true
    },
    async toggleDisabledFlagForAmount(item){
      if(this.selectedPaymentAmount.id === 0){
        this.refundAmount = (item.amount.toFixed(2) - item.refunded.toFixed(2)).toFixed(2)
        this.isAmountFieldDisabled = true
      } else if(this.selectedPaymentAmount.id === 3){
        this.refundAmount = (item.amount.toFixed(2) - item.refunded.toFixed(2)).toFixed(2)
        this.isAmountFieldDisabled = false
        // Load gift card types if not already loaded
        if(this.gift_card_types.length === 0){
          await this.getGiftCardSettings()
        }
        // Pre-select first gift card type
        if(this.gift_card_types.length > 0){
          this.selectedRefundGiftCardType = { id: this.gift_card_types[0].id, name: this.gift_card_types[0].name }
        }
      } else if(this.selectedPaymentAmount.id === 4){
        // Overpayment refund: prefill the amount owed back to the customer,
        // capped at this payment's available balance (the lambda rejects
        // anything above amount - refunded on the payment being refunded).
        let amountDueToCustomer = -parseFloat(this.transaction.due)
        let availableBalance = item.amount - item.refunded
        this.refundAmount = Math.min(amountDueToCustomer, availableBalance).toFixed(2)
        this.isAmountFieldDisabled = false
      } else {
        this.isAmountFieldDisabled = false
      }
    },
    isRefundable(item){
      if((item.amount - item.refunded) > 0){
        return true
      }
      return false
    },
    markAsPaidPrompt(item){
      this.showConfirmDialog({
        title: 'Are you sure?',
        message: "This will mark the payment as paid",
        variant: 'warning',
        confirmText: 'Confirm',
        onConfirm: () => {
          this.markAsPaid(item)
        }
      })
    },
    async markAsPaid(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/'
        + companyGroupId + '/transactions/' + this.transaction.id + '/payments/' + item.id

      let data = {}

      this.axios.put(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', 'Payment has been marked as paid', 'success');
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if(err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
          }
        })
    },
    markAsRefundedPrompt(item, index){
      let availableForRefund = parseFloat((item.amount - (item.refunded || 0)).toFixed(2))
      let formattedAmount = this.getAmount(availableForRefund)
      this.showConfirmDialog({
        title: 'Mark ' + formattedAmount + ' as refunded?',
        message: "This will mark " + formattedAmount + " as refunded without processing the " + (item.type === 'bank_transfer' ? 'bank transfer' : 'card') + ". Use this when the refund was handled outside of the system.",
        variant: 'warning',
        confirmText: 'Yes, mark as refunded',
        onConfirm: () => {
          this.markAsRefunded(item, index)
        }
      })
    },
    async markAsRefunded(item, index){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/'
        + companyGroupId + '/transactions/' + this.transaction.id + '/payments/' + item.id + '/refund?refund_only=1'

      let data = item
      // Calculate remaining amount available for refund
      let availableForRefund = item.amount - (item.refunded || 0)
      data.refunded = availableForRefund

      this.axios.post(url, data, config)
        .then(response => {
          this.$set(this.showRefund, index, 0)
          this.showAlertDialog('Success', 'The refund has been processed.', 'success');
          this.getTransaction()
          this.showRefund = []
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.showAlertDialog('Error', 'There was an issue with the refund.', 'danger');
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if(err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
            this.getTransaction()
          }
        })
    },
    getActiveExternalRefunds(paymentId){
      return this.payment_refunds.filter(r =>
        r.payment_id === paymentId &&
        r.refund_type === 'external' &&
        r.status === 'active'
      )
    },
    getExternalRefundTotal(paymentId){
      return this.getActiveExternalRefunds(paymentId)
        .reduce((sum, r) => sum + parseFloat(r.amount), 0)
    },
    getCustomerCreditRefundTotal(paymentId){
      return this.payment_refunds
        .filter(r => r.payment_id === paymentId && r.refund_type === 'customer_credit' && r.status === 'active')
        .reduce((sum, r) => sum + parseFloat(r.amount), 0)
    },
    refundBreakdownTrusted(payment){
      if(!payment.refunded || payment.refunded <= 0) return true
      const rows = this.payment_refunds.filter(r => r.payment_id === payment.id)
      // refunds that predate payment_refunds tracking entirely can't be attributed
      if(rows.length === 0) return false
      // 'customer_credit' and 'gift_card' stamps only exist post-classification, so they are
      // always reliable; 'gateway'/'external' rows from before the cutoff may be mislabeled
      const allRowsTrusted = rows.every(r =>
        r.refund_type === 'customer_credit' ||
        r.refund_type === 'gift_card' ||
        new Date(r.created_at) >= REFUND_TYPE_TRUST_CUTOFF
      )
      if(!allRowsTrusted) return false
      // if tracked rows don't add up to the payment's refunded total, part of the refund
      // history is untracked and the breakdown would misattribute the difference
      const activeSum = rows
        .filter(r => r.status === 'active')
        .reduce((sum, r) => sum + parseFloat(r.amount), 0)
      return Math.abs(activeSum - parseFloat(payment.refunded)) < 0.01
    },
    refundMethodLabel(type){
      if(type === 'card' || type === 'pos') return 'card'
      if(type === 'bank_transfer') return 'bank'
      if(type === 'cash') return 'cash'
      if(type === 'gift_card') return 'gift card'
      return 'original payment'
    },
    reverseExternalRefundPrompt(refund){
      this.showConfirmDialog({
        title: 'Reverse manual refund?',
        message: "This will undo the manual refund of " + this.getAmount(refund.amount) + " and restore the payment amount. This cannot be undone.",
        variant: 'warning',
        confirmText: 'Yes, reverse it',
        onConfirm: () => {
          this.reverseExternalRefund(refund)
        }
      })
    },
    async reverseExternalRefund(refund){
      this.loading = true
      try {
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/transactions/' + this.transaction.id + '/payments/' + refund.payment_id + '/refund/' + refund.id

        await this.axios.put(url, {}, config)
        this.showAlertDialog('Success', 'The manual refund has been reversed.', 'success')
        this.getTransaction()
      } catch(err) {
        console.log(err)
        if(err.response && err.response.status == 401){
          this.$router.push('/forbidden')
        } else if(err.response){
          this.showAlertDialog('Error', err.response.data, 'danger')
        } else {
          this.showAlertDialog('Error', 'There was an issue reversing the refund.', 'danger')
        }
      } finally {
        this.loading = false
      }
    },
    showRefundForPayment(item, index){
      this.selectedPaymentAmount = this.paymentAmountOptions[0]
      this.refundAmount = (item.amount.toFixed(2) - item.refunded.toFixed(2)).toFixed(2)
      this.$set(this.showRefund, index, 1)
    },
    validateRefundAmount(){
      if(isNaN(this.refundAmount) || this.refundAmount < 0){
        this.refundAmount = 0
      }
    },
    async processRefund(payment, index){
      //check that refund value doens't exceed the amount
      if(this.refundAmount > payment.amount){
        this.showAlertDialog('Error', 'The refund amount cannot exceed the paid amount.', 'danger');
        return
      }

      let isGiftCardRefund = this.selectedPaymentAmount.id === 3

      // Confirmation prompt for gift card refunds
      if(isGiftCardRefund){
        const issueGiftCard = await this.askConfirmation({
          title: 'Refund as gift card?',
          message: 'A gift card worth ' + this.getAmount(parseFloat(this.refundAmount)) + ' will be created. The payment will be marked as refunded.',
          confirmText: 'Issue gift card'
        })
        if(!issueGiftCard){
          return
        }
      }

      payment.currency_format = this.currency_format
      payment.currency_symbol = this.currency_symbol
      payment.currency = this.currency
      payment.number_format = this.number_format

      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      // For custom payment methods and non-gateway payments - use refund_only=1 since there's no gateway to process
      let isManualRefund = this.isCustomPaymentType(payment.type) || payment.type === 'cash' || payment.type === 'pos' || payment.type === 'customer_credit'
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments/' + payment.id + '/refund'
      if(isManualRefund || isGiftCardRefund){
        url += '?refund_only=1'
      }

      let data = { ...payment }
      data.refunded = parseFloat(this.refundAmount).toFixed(2).toString()
      if(payment.type === 'customer_credit' || this.selectedPaymentAmount.id === 2){
        data.customer_credit = true
        data.customer_id = this.transaction.end_user_id
      } else {
        data.customer_credit = false
      }

      if(isGiftCardRefund){
        data.gift_card_refund = true
        data.gift_card_type_id = this.selectedRefundGiftCardType ? this.selectedRefundGiftCardType.id : null
      } else {
        data.gift_card_refund = false
        data.gift_card_type_id = null
      }

      this.axios.post(url, data, config)
        .then(response => {
          this.$set(this.showRefund, index, 0)
          if(isGiftCardRefund && response.data && response.data.gift_card_code){
            this.showAlertDialog('Gift card created', 'Gift card code: ' + response.data.gift_card_code + ' with a balance of ' + this.getAmount(parseFloat(this.refundAmount)), 'success')
          } else {
            this.showAlertDialog('Success', 'The refund has been processed.', 'success');
          }
          this.getTransaction()
          this.showRefund = []
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.showAlertDialog('Error', 'There was an issue with the refund.', 'danger');
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else if(err.response && err.response.status == 500){
            this.showAlertDialog('Error', err.response.data, 'danger')
          }
        })
    },
    async deleteBookingNote(booking_id, id){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/' + booking_id + '/notes/' + id

      this.axios.delete(url, config)
        .then(response => {
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async deleteNote(id){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/notes/' + id

      this.axios.delete(url, config)
        .then(response => {
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async addNewComment(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/notes'
      let data = {
        note_type: this.note_type,
        note: this.note
      }
      this.axios.post(url, data, config)
        .then(response => {
          this.note = ''
          this.getTransaction()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    viewCustomerDetails(user_id){
      this.$router.push({ path: '/customers/details', query: { id:  user_id }})
    },
    async beforeDownloadSimple({ html2pdf, options, pdfContent }) {
      this.loading = true

      // Top and bottom margins (inches) keep content clear of the page edge and of the
      // page number stamped below; html2pdf computes page breaks from the inner height
      const pdfOptions = { ...options, margin: [0.3, 0, 0.5, 0] }

      try {
        const pdf = await html2pdf()
          .set(pdfOptions)
          .from(pdfContent)
          .toPdf()
          .get('pdf')

        const totalPages = pdf.internal.getNumberOfPages()

        // Add page numbers to all pages
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.setTextColor(150)
          pdf.text(
            `Page ${i} of ${totalPages}`,
            (pdf.internal.pageSize.getWidth() * 0.88),
            (pdf.internal.pageSize.getHeight() - 0.3)
          )
        }

        pdf.save(`invoice-${this.transaction.order_number || 'invoice'}.pdf`)

      } catch (error) {
        console.error('PDF generation error:', error)
        await html2pdf().set(pdfOptions).from(pdfContent).save(`invoice-${this.transaction.order_number || 'invoice'}.pdf`)
      }

      this.loading = false
    },
    openWaiverDrawer(row){
      this.waiverDrawer = { show: true, waiver: row }
    },
    onWaiverChanged(payload){
      // Rows don't show participation; anything that moves the waiver re-fetches quietly.
      if (payload.action === 'participation') {
        const row = (this.waivers || []).find(w => w.id === payload.waiverId)
        if (row) row.not_participating = payload.notParticipating ? 1 : 0
        return
      }
      this.getTransaction(true)
    },
    async downloadWaiver(waiver){
      if (this.pdfGeneratingId !== null) return
      this.pdfGeneratingId = waiver.id
      try {
        // Fetch full detail (waiver_text + decoded signature + custom/consent fields)
        // in one round trip, then render the normalized branded PDF via the shared
        // component. Merge list-row fields (game_name/booking_date/start_time) over
        // the detail payload so the PDF header is fully populated.
        const { waiver: detail, custom_field_responses, consent_fields } =
          await fetchWaiverDetail(waiver.id, { includeSignature: true })
        await this.$refs.waiverPdf.generate({
          waiver: { ...waiver, ...detail },
          consent_fields,
          custom_field_responses,
        })
      } catch (err) {
        console.log(err)
        if (err.response && err.response.status === 401) {
          this.showAlertDialog('Error', 'You do not have access to this feature.', 'danger')
        } else {
          this.showAlertDialog('Error', 'Could not download waiver PDF', 'danger')
        }
      } finally {
        this.pdfGeneratingId = null
      }
    },
    getInitials(item){
      if(item == null){
        return
      } else if(!item.company_user_id && !item.user_id) {
        return 'SU'
      } else if(item.company_user_first_name && item.company_user_last_name) {
        return item.company_user_first_name[0].toUpperCase() + item.company_user_last_name[0].toUpperCase()
      } else if(item.company_user_first_name && !item.company_user_last_name) {
        return item.company_user_first_name[0].toUpperCase()
      } else if(item.first_name){
        let ln = item.last_name ? item.last_name[0].toUpperCase() : ''
        return item.first_name[0].toUpperCase() + ln
      }
    },
    getLocalTime(d){
      return formatGroupTime(d)
    },
    isValidTime(timeStr) {
      const pattern = /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/;
      return pattern.test(timeStr);
    },
    getTime(d) {
      if(!this.isValidTime(d)){
        return
      }
      return time(this.time_format, d)
    },
    getDayOfWeek(d){
      if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
        return dayOfWeek(d) + ', '
      }
      return ''
    },
    getLocalDate(d){
      return formatGroupDate(d)
    },
    formatFieldResponse(field) {
      // Dropdown (type 3) with follow-up is stored as JSON: {option, follow_up}.
      // External booking site responses are pre-flattened strings and fall through untouched.
      if (field.type === 3 && typeof field.response === 'string' && field.response.startsWith('{')) {
        try {
          const parsed = JSON.parse(field.response)
          if (parsed && parsed.option) {
            return parsed.follow_up ? `${parsed.option} (${parsed.follow_up})` : parsed.option
          }
        } catch (e) {
          // fall through to raw response
        }
      }
      return field.response
    },
    getFormattedDate(d){
      return formattedDate(this.date_format, d)
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    roundToFixed(num, decimals) {
      let factor = Math.pow(10, decimals);
      return (Math.round(num * factor) / factor).toFixed(decimals);
    },
    getSubtotalAmount(subtotal){
      let inclusive_taxes = 0
      for(let n in this.taxes_fees){
        if(this.taxes_fees[n].pricing_type === 1){
          inclusive_taxes += this.taxes_fees[n].amount
        }
      }
      const waived = Number(this.transaction?.inclusive_tax_waived) || 0
      return this.getAmount(subtotal + inclusive_taxes + waived)
    },
    getInclusiveTaxes(){
      let inclusive_taxes = false
      for(let n in this.taxes_fees){
        if(this.taxes_fees[n].pricing_type === 1){
          inclusive_taxes = true
        }
      }

      return inclusive_taxes
    },
    getAmount(integer) {
      if (integer == null) {
        return;
      }

      // Get currency info
      const currencyInfo = _.find(this.currencies, { code: this.currency });
      const symbol = currencyInfo ? currencyInfo.symbol : this.currency_symbol;
      const isPostfix = currencyInfo ? currencyInfo.postfix : false;

      // A negative amount (a cash payment above the total leaves a negative
      // due) prints its sign before the symbol: -$8.00, never $-8.00. Half-cent
      // threshold so float residue on a settled balance prints a plain zero.
      const number = parseFloat(integer);
      const sign = number < -0.005 ? '-' : '';
      const magnitude = number < -0.005 ? -number : Math.max(number, 0);

      let formattedAmount;

      if (this.number_format === 1) {
        // European formatting (comma as decimal separator)
        formattedAmount = magnitude.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
      } else {
        // Standard formatting (dot as decimal separator)
        formattedAmount = magnitude.toFixed(2);
      }

      if (this.currency_format === 0) {
        // Symbol format
        if (isPostfix) {
          return sign + formattedAmount + symbol;  // 12.34kr
        } else {
          return sign + symbol + formattedAmount;  // $12.34
        }
      } else {
        // Currency code format
        return sign + formattedAmount + ' ' + this.currency;  // 12.34 SEK
      }
    },
    paymentRequest(url, data, config){
      this.loading = true
      this.axios.post(url, data, config)
        .then(response => {
          this.showAlertDialog('Success', 'Payment has been processed' , 'success')
          this.modals.add_payment = false
          this.selectedPaymentOption = this.paymentOptions.length > 0 ?
            this.paymentOptions[0] : {name: '', content: '', id: '', is_default: ''}
          this.user.first_name = ''
          this.user.last_name = ''
          this.user.email = ''
          this.authorize_opaque_data = null
          this.gift_card_code = ''
          this.getTransaction()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          const responseData = err.response?.data
          const errorMessage = responseData?.error || (typeof responseData === 'string' ? responseData : '')
          if(err.response?.status == 401){
            this.$router.push('/forbidden')
          } else if(errorMessage){
            this.showAlertDialog('Error', errorMessage, 'danger')
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async tokenize(paymentMethod) {
      const tokenResult = await paymentMethod.tokenize();

      if (tokenResult.status === 'OK') {
        const zip = tokenResult.details.billing.postalCode ? tokenResult.details.billing.postalCode : ''
        return {token: tokenResult.token, zip}
      } else {
        let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
        if (tokenResult.errors) {
          errorMessage += ` and errors: ${JSON.stringify(
            tokenResult.errors
          )}`;
        }

        throw new Error(errorMessage);
      }
    },
    async createSquarePayment(){
      this.loading = true
      try {
        const isStoredCard = this.selected_payment_method !== 'new' && this.selectedSquareStoredCard

        let tok = await this.getAuthToken()
        let config = {headers: {Authorization: tok}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/'+ companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments/square'

        let data = {
          amount: this.payment_amount,
          user: this.user
        }

        if (isStoredCard) {
          // Using stored payment method
          data.square_card_id = this.selectedSquareStoredCard.card_id
          data.square_customer_id = this.square_customer?.square_customer_id
        } else {
          // Using new card - create tokens
          const token = await this.tokenize(this.card);
          const verificationToken = await this.verifyBuyer(this.square, token.token, token.zip);

          data.sourceId = token.token
          data.verificationToken = verificationToken
          data.zip = token.zip

          // Include save card flag and second token if enabled
          if (this.save_card_for_future && this.transaction.end_user_id) {
            const token2 = await this.tokenize(this.card);
            data.sourceId2 = token2.token
            data.save_card = true
          }
        }

        let response = await this.paymentRequest(url, data, config)
      } catch (error) {
        //Square
        console.error('Square payment error:', error)
        this.loading = false
      }
    },
    async handleGiftCardPayment(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId +  '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments'
      let data = {
        amount: this.payment_amount,
        gift_card: this.selectedGiftCardCode,
        payment_type: 'gift_card',
      }
      let response = await this.paymentRequest(url, data, config)
    },
    async handleCashPayment(payment_type, is_default){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId +  '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments'
      let data = {
        amount: this.payment_amount,
        user: this.user,
        payment_type: payment_type,
        is_default: is_default
      }
      let response = await this.paymentRequest(url, data, config)
    },
    isValidPaymentForm(){
      let errors = 0
      const isNewCard = this.selected_payment_method === 'new' || (!this.selectedStoredCard && !this.selectedSquareStoredCard)

      if(this.selectedPaymentOption.name === 'Card' && isNewCard && this.user.first_name == ''){
        this.errs.first_name = 'First name cannot be empty'
        errors++
      } else {
        this.errs.first_name = ''
      }

      if(this.selectedPaymentOption.name === 'Card' && isNewCard && this.user.last_name == ''){
        this.errs.last_name = 'Last name cannot be empty'
        errors++
      } else {
        this.errs.last_name = ''
      }


      if(!allowsOverpayment(this.selectedPaymentOption.name) && parseFloat(this.payment_amount) > parseFloat(this.transaction.due)){
        this.errs.payment_amount = 'Amount cannot exceed due'
        errors++
      } else if (this.selectedPaymentOption.name === 'Customer credit'
        && parseFloat(this.payment_amount) > parseFloat(this.available_credit)) {
        this.errs.payment_amount = 'Amount cannot exceed available customer credits'
        errors++
      } else if (isNaN(this.payment_amount) || this.payment_amount <= 0) {
        this.errs.payment_amount = 'Invalid payment amount'
        errors++
      }  else if (this.selectedPaymentOption.name === 'Gift card'
        && parseFloat(this.payment_amount) > parseFloat(this.selectedGiftCardCode.remaining)) {
        this.errs.payment_amount = 'Amount cannot exceed available gift card balance'
        errors++
      } else {
        this.errs.payment_amount = ''
      }

      if(this.selectedPaymentOption.name === 'Gift card' && (!this.gift_card_code
        || !this.selectedGiftCardCode.hasOwnProperty('id')
        || this.getGiftCardCode(this.selectedGiftCardCode.code) !== this.gift_card_code)){
        this.errs.gift_card_code = 'You must choose a valid gift card'
        errors++
      } else {
        this.errs.gift_card_code = ''
      }

      if(errors > 0){
        return false
      }
      return true

    },
    async payWithPaystack() {
      // Metadata lets the paystack-webhook identify and record this charge
      // server-side if the callback below never reaches the lambda. A session
      // hiccup must never block a charge, so the operator email is best-effort.
      let operatorEmail = null
      try {
        const session = await Auth.currentSession()
        operatorEmail = session.getIdToken().payload.email
      } catch (e) {
        operatorEmail = null
      }
      const popup = new PaystackPop()
      popup.newTransaction({
        key: this.payment_settings.api_name,
        email: this.transaction.email,
        amount: Math.round(Number(parseFloat(this.payment_amount) + 'e2')),
        reference: ''+Math.floor((Math.random() * 1000000000) + 1),
        metadata: {
          otc: 1,
          otc_flow: 'console_payment',
          otc_transaction_id: this.transaction.id,
          otc_company_group_id: JSON.parse(localStorage.getItem('group')).id,
          otc_company_id: localStorage.getItem('companyId'),
          ...(operatorEmail ? { otc_user_email: operatorEmail } : {}),
          otc_first_name: this.user.first_name,
          otc_last_name: this.user.last_name
        },
        onSuccess: (response) => {
          // The lambda reads paystack_reference.transaction (v1 field name);
          // v2 carries the numeric transaction id as response.trans (verified from a live callback).
          this.handlePaystackPayment({ ...response, transaction: response.trans })
        }
      });
    },
    async handlePaystackPayment(reference){
      this.loading = true
      let tok = await this.getAuthToken()
      let config = {headers: {Authorization: tok}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'+ companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments'
      let data = data = {
        amount: this.payment_amount,
        user: this.user,
        paystack_reference: reference,
      }

      let response = await this.paymentRequest(url, data, config)
    },
    async handleStripePayment(){
      this.loading = true
      let tok = await this.getAuthToken()
      let config = {headers: {Authorization: tok}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'+ companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments/stripe'

      let data = {
        amount: this.payment_amount,
        user: this.user,
        customer_id: this.transaction.end_user_id
      }

      // Check if using a stored payment method or new card
      if (this.selected_payment_method !== 'new' && this.selectedStoredCard) {
        // Using stored payment method - send Stripe's payment_method_id (pm_xxx), not database id
        data.payment_method_id = this.selectedStoredCard.payment_method_id
        data.stripe_customer_id = this.stripe_customer?.stripe_customer_id
      } else {
        // Using new card - create token
        const {token, error} = await this.stripe.createToken(this.card)
        if (error) {
          this.loading = false
          this.showAlertDialog('Error', error.message, 'danger')
          return
        }
        data.token = token.id
        // Include save card flag if enabled
        if (this.save_card_for_future) {
          data.save_card = true
        }
      }

      let response = await this.paymentRequest(url, data, config)
    },
    async handleCustomerCreditPayment(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId +  '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments'
      let data = {
        amount: this.payment_amount,
        user: this.user,
        customer_credit: this.payment_amount
      }
      let response = await this.paymentRequest(url, data, config)
    },
    async handleAuthorizeNetPayment(){
      try {
        this.authorize_opaque_data = await this.$refs.authorizePaymentForm.tokenize()
      } catch (err) {
        this.$notify({ type: 'danger', message: err.message })
        return
      }
      const authorizeZip = this.$refs.authorizePaymentForm.zip
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + this.transaction.id + '/payments'
      let data = {
        amount: this.payment_amount,
        user: this.user,
        payment: {
          opaqueData: this.authorize_opaque_data,
          cardholder_first_name: this.user.first_name,
          cardholder_last_name: this.user.last_name,
          zip: authorizeZip
        },
      }

      let response = await this.paymentRequest(url, data, config)
    },
    async addPayment() {
      //validation
      if(!this.isValidPaymentForm()){
        return
      }
      if(this.payment_settings.payment_gateway_id === 3 && this.selectedPaymentOption.name === 'Card' ){
        let stripePayment = await this.handleStripePayment()
      } else if(this.payment_settings.payment_gateway_id === 2 && this.selectedPaymentOption.name === 'Card' ){
        let squarePayment = await this.createSquarePayment()
      }  else if(this.payment_settings.payment_gateway_id === 4 && this.selectedPaymentOption.name === 'Card' ){
        let paystack = await this.payWithPaystack()
        return
      } else if (!this.selectedPaymentOption.is_default || this.selectedPaymentOption.name === 'Yappy' ||
        this.selectedPaymentOption.name === 'Cash'
        || this.selectedPaymentOption.name === 'POS payment'){
        let payment_type = 'pos'
        if(this.selectedPaymentOption.name === 'Cash'){
          payment_type = 'cash'

        }
        if(!this.selectedPaymentOption.is_default){
          payment_type = this.selectedPaymentOption.name
        }
        if(this.selectedPaymentOption.name === 'Yappy'){
          payment_type = 'Yappy'
        }

        await this.handleCashPayment(payment_type, this.selectedPaymentOption.is_default)
      } else if(this.selectedPaymentOption.name === 'Customer credit'){
        let customerCreditPayment = await this.handleCustomerCreditPayment()
      } else if(this.selectedPaymentOption.name === 'Gift card'){
        let giftCardPayment = await this.handleGiftCardPayment()
      } else if(this.payment_settings.payment_gateway_id === 1 && this.selectedPaymentOption.name === 'Card' ){
        let authorizeNetPayment = await this.handleAuthorizeNetPayment()
        this.authorize_opaque_data = null
      }
    },
    getAvailableCredit(){
      let available = 0
      for(let n in this.customer_credits){
        available = available + parseFloat(this.customer_credits[n].remaining)
      }
      this.available_credit = available.toFixed(2)
      if(parseFloat(this.available_credit) < parseFloat(this.transaction.price)){
        this.applied_credit = this.available_credit
      } else {
        this.applied_credit = this.transaction.price
      }
    },
    async checkBookingAutomation() {
      try {
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/email-automations?count=100'

        const response = await this.axios.get(url, config)
        const automations = response.data.automations || []

        this.hasBookingCreatedAutomation = automations.some(
          a => a.trigger_type?.key === 'booking_created_internal' && a.is_active
        )
      } catch (err) {
        console.error('Error checking booking automation:', err)
        this.hasBookingCreatedAutomation = false
      }
    },
    async openAffiliateAttach() {
      this.affiliateAttach.open = true
      this.affiliateAttach.error = ''
      this.affiliateAttach.affiliateId = null
      if (this.affiliateAttach.options.length > 0) return
      this.affiliateAttach.loading = true
      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/affiliates`
        const response = await axios.get(url, config)
        // Only affiliates the ledger can pay: active and on a tier.
        this.affiliateAttach.options = (response.data.affiliates || [])
          .filter(a => a.status === 'active' && a.affiliate_tier_id != null)
      } catch (err) {
        this.$notify({ type: 'danger', message: 'Failed to load affiliates', icon: 'tim-icons icon-alert-circle-exc' })
        this.affiliateAttach.open = false
      } finally {
        this.affiliateAttach.loading = false
      }
    },
    async attachAffiliate() {
      if (!this.affiliateAttach.affiliateId) return
      this.affiliateAttach.saving = true
      this.affiliateAttach.error = ''
      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/affiliates/${this.affiliateAttach.affiliateId}/transactions`
        await axios.post(url, { transaction_id: this.transaction.id }, config)
        this.$notify({ type: 'success', message: 'Transaction added to the affiliate ledger', icon: 'tim-icons icon-check-2' })
        this.affiliateAttach.open = false
        // getTransaction uses a .then chain and returns nothing; the page
        // updates reactively when the response lands. Add no logic after this
        // line that assumes fresh transaction data.
        this.getTransaction(true)
      } catch (err) {
        // New lambdas return JSON errors; fall back to plain text.
        let message = 'Failed to attach the affiliate'
        const data = err.response && err.response.data
        if (data) {
          try {
            const parsed = typeof data === 'string' ? JSON.parse(data) : data
            if (parsed && parsed.error) message = parsed.error
          } catch (e) {
            if (typeof data === 'string' && data.length < 200) message = data
          }
        }
        this.affiliateAttach.error = message
        this.$notify({ type: 'danger', message, icon: 'tim-icons icon-alert-circle-exc' })
      } finally {
        this.affiliateAttach.saving = false
      }
    },
    // Switches through the shared active location module, which reloads the page.
    async switchToGroup(group){
      this.switchingGroup = true
      try {
        await switchGroup(Number(group.id), group.name)
      } catch (err) {
        this.switchingGroup = false
        this.showAlertDialog('Error', 'Something went wrong', 'danger')
      }
    },
    async getTransaction(quiet = false){
      if (!quiet) this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let transactionId = this.$route.query.id || this.$route.query.order_number
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let lookupParam = this.$route.query.order_number && !this.$route.query.id ? '?by=order_number' : ''
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +  '/transactions/' + transactionId + lookupParam
      this.axios.get(url, config)
        .then(response => {
          this.transaction = response.data.transaction
          this.notFound = false
          this.transactionLoaded = true
          this.activity = response.data.activity
          this.payments = response.data.payments
          this.waivers = response.data.waivers
          this.bookings = response.data.bookings.concat(response.data.items).concat(response.data.gift_cards)

          for (let booking of this.bookings) {
            // Only check bookings (not items or gift cards)
            if (booking.hasOwnProperty('booking_date') && booking.tickets) {
              let tickets = []

              // Parse tickets if it's a string
              if (typeof booking.tickets === 'string') {
                try {
                  tickets = JSON.parse(booking.tickets)
                } catch (e) {
                  console.warn('Failed to parse tickets for booking', booking.id)
                  tickets = []
                }
              } else {
                tickets = booking.tickets
              }

              // Check if reservation upgrade using the booking slot flag
              if (booking.is_reservation_upgraded) {
                booking.is_reservation_upgrade = true
                // Sum all ticket prices for the upgrade price
                booking.reservation_upgrade_price = tickets.reduce((sum, t) => sum + parseFloat(t.price || 0), 0)
                // tickets+fee: capture the fixed nominal fee once = booking subtotal
                // minus the real ticket sum. Held constant while counts are edited.
                if (booking.reservation_upgrade_pricing_mode === 'tickets_plus_fee') {
                  booking.private_booking_fee = roundCents(parseFloat(booking.price || 0) - booking.reservation_upgrade_price)
                }
              } else {
                booking.is_reservation_upgrade = false
              }
            }
          }

          this.payment_refunds = response.data.payment_refunds || []
          this.notes = response.data.notes
          this.payment_settings = response.data.payment_settings
          this.promos = response.data.promos
          this.enable_utm_source_tracking = response.data.enable_utm_source_tracking
          const grouped_promos =  _.groupBy( this.promos, 'name');
          this.promos_invoice = Object.entries(grouped_promos).map(([name, items]) => {
            return {
              name,
              amount: _.sumBy(items, p => Number(p.display_amount != null ? p.display_amount : p.amount) || 0),
              id: items[0]?.id || ''
            };
          });
          this.booking_notes = response.data.booking_notes
          let tips = response.data.tips
          for(let n in tips){
            tips[n].name = this.payment_settings.tip_line_item_label
          }
          this.taxes_fees = _.orderBy(response.data.taxes.concat(response.data.fees).concat(response.data.tips), 'timestamp', 'desc')
          const grouped =  _.groupBy( this.taxes_fees, 'name');
          this.taxes_fees_invoice = Object.entries(grouped).map(([name, items]) => {
            return {
              name: name !== 'undefined' ? name : 'Tips',
              amount: _.sumBy(items, 'amount'),
              tax_id: items[0]?.tax_id || '', // fallback in case type is missing
              fee_id: items[0]?.fee_id || '', // fallback in case type is missing
              pricing_type: items[0]?.pricing_type || 0,
              tax_number: items[0]?.tax_number || ''
            };
          });

          this.taxes = response.data.taxes_for_group
          this.fees = response.data.fees_for_group
          this.email_settings = response.data.email_settings
          this.custom_fields = response.data.custom_fields
          this.email_events = collapseEmailEvents(response.data.email_events)

          if(!this.email_settings[2].is_active || this.transaction.due <= 0){
            this.cursor_type.payment_request = 'not-allowed'
          } else {
            this.cursor_type.payment_request = 'pointer'
          }
          if(!this.email_settings[0].is_active){
            this.cursor_type.resend_confirmation_email = 'not-allowed'
          } else {
            this.cursor_type.resend_confirmation_email = 'pointer'
          }

          if(!this.emailSettingActive('gift_card_confirmation')){
            this.cursor_type.gift_card_confirmation_email = 'not-allowed'
          } else {
            this.cursor_type.gift_card_confirmation_email = 'pointer'
          }

          this.customer_credits = response.data.customer_credit
          this.customer.first_name = response.data.transaction.first_name
          this.customer.last_name = response.data.transaction.last_name
          this.customer.phone = response.data.transaction.phone
          this.customer.email = response.data.transaction.email
          if(this.payment_settings.payment_gateway_id === 2){
            this.squareAppId = this.payment_settings.api_name
            this.squareLocationId = this.payment_settings.api_location
            this.loadSquare(this.payment_settings.is_live)
          }
          if(this.payment_settings.payment_gateway_id === 3){
            this.loadStripe()
          }
          if(this.payment_settings.payment_gateway_id === 4){
            this.loadPaystack()
          }
          this.getAvailableCredit()
          this.selectedTax = ''
          this.selectedFee = ''
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          const status = err.response?.status
          if(status == 401){
            this.$router.push('/forbidden')
          }else if(status == 404 || status == 500){
            // 404 carries JSON with other_group when the transaction lives in another
            // group this user can open; older responses are plain strings.
            let body = null
            try {
              body = typeof err.response.data === 'string' ? JSON.parse(err.response.data) : err.response.data
            } catch (e) {
              body = null
            }
            this.otherGroup = body?.other_group || null
            this.notFoundOrderNumber = this.$route.query.order_number && !this.$route.query.id ? this.$route.query.order_number : ''
            this.transactionLoaded = false
            this.notFound = true
          } else {
            this.showAlertDialog('Error', 'Something went wrong', 'danger')
          }
        })
    },
    async getWaiverSettings(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/waiver-settings'

      this.axios.get(url, config)
        .then(response => {
          this.waiverSettings = response.data.waiver_setting_types || []
        })
        .catch(err => {
          console.log('Error fetching waiver settings:', err)
          this.waiverSettings = []
        })
    },
  },
  mounted(){
    this.date_format_cal = this.date_format
    this.date_format_cal =  this.date_format_cal.replaceAll('Y', 'y')
    this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
    if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
      this.day_of_week = 'ddd, '
    }
    if (this.time_format === 'HH:mm') {
      this.picker_time_format = 'HH:mm'
    }
    this.country = _.find(this.countries, { code: JSON.parse(localStorage.getItem('group')).country })
    this.currency_symbol =  _.find(this.currencies, { code: JSON.parse(localStorage.getItem('group')).currency }).symbol
    this.getTransaction()
    this.checkBookingAutomation()
  },
  beforeDestroy() {
    if (this._txWatcher) {
      this._txWatcher.disconnect()
      this._txWatcher = null
    }
  }
}
</script>

<style scoped>
/* Stored card visual is a deliberately dark credit-card graphic in both themes;
   keep its text legible in light mode instead of letting .text-white flip dark */
.white-content .stored-card .text-white { color: #fff !important; }
.white-content .stored-card .text-muted { color: rgba(255, 255, 255, 0.7) !important; }

.waive-toggle-row {
  display: flex;
  align-items: center;
}
.closed{
  position: absolute;
  pointer-events: all;
  z-index:10;
  right: 15px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.closed:hover {
  color: #560606 !important;
}

/* Fade transition for gift card modal steps */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Skeleton loading animation */
.skeleton-box {
  background: linear-gradient(90deg, #2b3553 25%, #3d4a6a 50%, #2b3553 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}


</style>

<style>
/* Requested-status chip: teal per the request-to-book palette, softened in
   light mode (class-based so .white-content can override; inline styles can't). */
.requested-status-chip {
  background: #00D6B4;
  color: #1E1E2F;
}
.white-content .requested-status-chip {
  background: #3fc1ab;
  color: #ffffff;
}

.waiver-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.waiver-option {
  border: 1px solid #2b3553;
  border-radius: 8px;
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.waiver-option:hover {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.02);
}
.waiver-option.selected {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.03);
}
.waiver-option .el-radio {
  margin-right: 0;
}
.waiver-option .el-radio__label {
  color: #fff;
  font-weight: 500;
}
.waiver-option.selected .el-radio__label {
  color: #e14eca;
}
.waiver-option .el-radio__input.is-checked .el-radio__inner {
  border-color: #e14eca;
  background: #e14eca;
}
.waiver-option small {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
  line-height: 1.4;
  padding-left: 24px;
}
</style>
